import require$$0 from 'stream';
import require$$1 from 'string_decoder';
import React, { useState, useRef, useEffect } from 'react';
import require$$1$1 from 'react-dom';

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var sax$1 = {};

(function (exports) {
(function (sax) { // wrapper for non-node envs
  sax.parser = function (strict, opt) { return new SAXParser(strict, opt) };
  sax.SAXParser = SAXParser;
  sax.SAXStream = SAXStream;
  sax.createStream = createStream;

  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
  // since that's the earliest that a buffer overrun could occur.  This way, checks are
  // as rare as required, but as often as necessary to ensure never crossing this bound.
  // Furthermore, buffers are only tested at most once per write(), so passing a very
  // large string into write() might have undesirable effects, but this is manageable by
  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
  // edge case, result in creating at most one complete copy of the string passed in.
  // Set to Infinity to have unlimited buffers.
  sax.MAX_BUFFER_LENGTH = 64 * 1024;

  var buffers = [
    'comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype',
    'procInstName', 'procInstBody', 'entity', 'attribName',
    'attribValue', 'cdata', 'script'
  ];

  sax.EVENTS = [
    'text',
    'processinginstruction',
    'sgmldeclaration',
    'doctype',
    'comment',
    'opentagstart',
    'attribute',
    'opentag',
    'closetag',
    'opencdata',
    'cdata',
    'closecdata',
    'error',
    'end',
    'ready',
    'script',
    'opennamespace',
    'closenamespace'
  ];

  function SAXParser (strict, opt) {
    if (!(this instanceof SAXParser)) {
      return new SAXParser(strict, opt)
    }

    var parser = this;
    clearBuffers(parser);
    parser.q = parser.c = '';
    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH;
    parser.opt = opt || {};
    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase';
    parser.tags = [];
    parser.closed = parser.closedRoot = parser.sawRoot = false;
    parser.tag = parser.error = null;
    parser.strict = !!strict;
    parser.noscript = !!(strict || parser.opt.noscript);
    parser.state = S.BEGIN;
    parser.strictEntities = parser.opt.strictEntities;
    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES);
    parser.attribList = [];

    // namespaces form a prototype chain.
    // it always points at the current tag,
    // which protos to its parent tag.
    if (parser.opt.xmlns) {
      parser.ns = Object.create(rootNS);
    }

    // mostly just for error reporting
    parser.trackPosition = parser.opt.position !== false;
    if (parser.trackPosition) {
      parser.position = parser.line = parser.column = 0;
    }
    emit(parser, 'onready');
  }

  if (!Object.create) {
    Object.create = function (o) {
      function F () {}
      F.prototype = o;
      var newf = new F();
      return newf
    };
  }

  if (!Object.keys) {
    Object.keys = function (o) {
      var a = [];
      for (var i in o) if (o.hasOwnProperty(i)) a.push(i);
      return a
    };
  }

  function checkBufferLength (parser) {
    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10);
    var maxActual = 0;
    for (var i = 0, l = buffers.length; i < l; i++) {
      var len = parser[buffers[i]].length;
      if (len > maxAllowed) {
        // Text/cdata nodes can get big, and since they're buffered,
        // we can get here under normal conditions.
        // Avoid issues by emitting the text node now,
        // so at least it won't get any bigger.
        switch (buffers[i]) {
          case 'textNode':
            closeText(parser);
            break

          case 'cdata':
            emitNode(parser, 'oncdata', parser.cdata);
            parser.cdata = '';
            break

          case 'script':
            emitNode(parser, 'onscript', parser.script);
            parser.script = '';
            break

          default:
            error(parser, 'Max buffer length exceeded: ' + buffers[i]);
        }
      }
      maxActual = Math.max(maxActual, len);
    }
    // schedule the next check for the earliest possible buffer overrun.
    var m = sax.MAX_BUFFER_LENGTH - maxActual;
    parser.bufferCheckPosition = m + parser.position;
  }

  function clearBuffers (parser) {
    for (var i = 0, l = buffers.length; i < l; i++) {
      parser[buffers[i]] = '';
    }
  }

  function flushBuffers (parser) {
    closeText(parser);
    if (parser.cdata !== '') {
      emitNode(parser, 'oncdata', parser.cdata);
      parser.cdata = '';
    }
    if (parser.script !== '') {
      emitNode(parser, 'onscript', parser.script);
      parser.script = '';
    }
  }

  SAXParser.prototype = {
    end: function () { end(this); },
    write: write,
    resume: function () { this.error = null; return this },
    close: function () { return this.write(null) },
    flush: function () { flushBuffers(this); }
  };

  var Stream;
  try {
    Stream = require$$0.Stream;
  } catch (ex) {
    Stream = function () {};
  }

  var streamWraps = sax.EVENTS.filter(function (ev) {
    return ev !== 'error' && ev !== 'end'
  });

  function createStream (strict, opt) {
    return new SAXStream(strict, opt)
  }

  function SAXStream (strict, opt) {
    if (!(this instanceof SAXStream)) {
      return new SAXStream(strict, opt)
    }

    Stream.apply(this);

    this._parser = new SAXParser(strict, opt);
    this.writable = true;
    this.readable = true;

    var me = this;

    this._parser.onend = function () {
      me.emit('end');
    };

    this._parser.onerror = function (er) {
      me.emit('error', er);

      // if didn't throw, then means error was handled.
      // go ahead and clear error, so we can write again.
      me._parser.error = null;
    };

    this._decoder = null;

    streamWraps.forEach(function (ev) {
      Object.defineProperty(me, 'on' + ev, {
        get: function () {
          return me._parser['on' + ev]
        },
        set: function (h) {
          if (!h) {
            me.removeAllListeners(ev);
            me._parser['on' + ev] = h;
            return h
          }
          me.on(ev, h);
        },
        enumerable: true,
        configurable: false
      });
    });
  }

  SAXStream.prototype = Object.create(Stream.prototype, {
    constructor: {
      value: SAXStream
    }
  });

  SAXStream.prototype.write = function (data) {
    if (typeof Buffer === 'function' &&
      typeof Buffer.isBuffer === 'function' &&
      Buffer.isBuffer(data)) {
      if (!this._decoder) {
        var SD = require$$1.StringDecoder;
        this._decoder = new SD('utf8');
      }
      data = this._decoder.write(data);
    }

    this._parser.write(data.toString());
    this.emit('data', data);
    return true
  };

  SAXStream.prototype.end = function (chunk) {
    if (chunk && chunk.length) {
      this.write(chunk);
    }
    this._parser.end();
    return true
  };

  SAXStream.prototype.on = function (ev, handler) {
    var me = this;
    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
      me._parser['on' + ev] = function () {
        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
        args.splice(0, 0, ev);
        me.emit.apply(me, args);
      };
    }

    return Stream.prototype.on.call(me, ev, handler)
  };

  // this really needs to be replaced with character classes.
  // XML allows all manner of ridiculous numbers and digits.
  var CDATA = '[CDATA[';
  var DOCTYPE = 'DOCTYPE';
  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace';
  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/';
  var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE };

  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
  // This implementation works on strings, a single character at a time
  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
  // without a significant breaking change to either this  parser, or the
  // JavaScript language.  Implementation of an emoji-capable xml parser
  // is left as an exercise for the reader.
  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;

  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;

  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;

  function isWhitespace (c) {
    return c === ' ' || c === '\n' || c === '\r' || c === '\t'
  }

  function isQuote (c) {
    return c === '"' || c === '\''
  }

  function isAttribEnd (c) {
    return c === '>' || isWhitespace(c)
  }

  function isMatch (regex, c) {
    return regex.test(c)
  }

  function notMatch (regex, c) {
    return !isMatch(regex, c)
  }

  var S = 0;
  sax.STATE = {
    BEGIN: S++, // leading byte order mark or whitespace
    BEGIN_WHITESPACE: S++, // leading whitespace
    TEXT: S++, // general stuff
    TEXT_ENTITY: S++, // &amp and such.
    OPEN_WAKA: S++, // <
    SGML_DECL: S++, // <!BLARG
    SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
    DOCTYPE: S++, // <!DOCTYPE
    DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
    DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
    DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
    COMMENT_STARTING: S++, // <!-
    COMMENT: S++, // <!--
    COMMENT_ENDING: S++, // <!-- blah -
    COMMENT_ENDED: S++, // <!-- blah --
    CDATA: S++, // <![CDATA[ something
    CDATA_ENDING: S++, // ]
    CDATA_ENDING_2: S++, // ]]
    PROC_INST: S++, // <?hi
    PROC_INST_BODY: S++, // <?hi there
    PROC_INST_ENDING: S++, // <?hi "there" ?
    OPEN_TAG: S++, // <strong
    OPEN_TAG_SLASH: S++, // <strong /
    ATTRIB: S++, // <a
    ATTRIB_NAME: S++, // <a foo
    ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
    ATTRIB_VALUE: S++, // <a foo=
    ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
    ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
    ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
    ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
    ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
    CLOSE_TAG: S++, // </a
    CLOSE_TAG_SAW_WHITE: S++, // </a   >
    SCRIPT: S++, // <script> ...
    SCRIPT_ENDING: S++ // <script> ... <
  };

  sax.XML_ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'"
  };

  sax.ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'",
    'AElig': 198,
    'Aacute': 193,
    'Acirc': 194,
    'Agrave': 192,
    'Aring': 197,
    'Atilde': 195,
    'Auml': 196,
    'Ccedil': 199,
    'ETH': 208,
    'Eacute': 201,
    'Ecirc': 202,
    'Egrave': 200,
    'Euml': 203,
    'Iacute': 205,
    'Icirc': 206,
    'Igrave': 204,
    'Iuml': 207,
    'Ntilde': 209,
    'Oacute': 211,
    'Ocirc': 212,
    'Ograve': 210,
    'Oslash': 216,
    'Otilde': 213,
    'Ouml': 214,
    'THORN': 222,
    'Uacute': 218,
    'Ucirc': 219,
    'Ugrave': 217,
    'Uuml': 220,
    'Yacute': 221,
    'aacute': 225,
    'acirc': 226,
    'aelig': 230,
    'agrave': 224,
    'aring': 229,
    'atilde': 227,
    'auml': 228,
    'ccedil': 231,
    'eacute': 233,
    'ecirc': 234,
    'egrave': 232,
    'eth': 240,
    'euml': 235,
    'iacute': 237,
    'icirc': 238,
    'igrave': 236,
    'iuml': 239,
    'ntilde': 241,
    'oacute': 243,
    'ocirc': 244,
    'ograve': 242,
    'oslash': 248,
    'otilde': 245,
    'ouml': 246,
    'szlig': 223,
    'thorn': 254,
    'uacute': 250,
    'ucirc': 251,
    'ugrave': 249,
    'uuml': 252,
    'yacute': 253,
    'yuml': 255,
    'copy': 169,
    'reg': 174,
    'nbsp': 160,
    'iexcl': 161,
    'cent': 162,
    'pound': 163,
    'curren': 164,
    'yen': 165,
    'brvbar': 166,
    'sect': 167,
    'uml': 168,
    'ordf': 170,
    'laquo': 171,
    'not': 172,
    'shy': 173,
    'macr': 175,
    'deg': 176,
    'plusmn': 177,
    'sup1': 185,
    'sup2': 178,
    'sup3': 179,
    'acute': 180,
    'micro': 181,
    'para': 182,
    'middot': 183,
    'cedil': 184,
    'ordm': 186,
    'raquo': 187,
    'frac14': 188,
    'frac12': 189,
    'frac34': 190,
    'iquest': 191,
    'times': 215,
    'divide': 247,
    'OElig': 338,
    'oelig': 339,
    'Scaron': 352,
    'scaron': 353,
    'Yuml': 376,
    'fnof': 402,
    'circ': 710,
    'tilde': 732,
    'Alpha': 913,
    'Beta': 914,
    'Gamma': 915,
    'Delta': 916,
    'Epsilon': 917,
    'Zeta': 918,
    'Eta': 919,
    'Theta': 920,
    'Iota': 921,
    'Kappa': 922,
    'Lambda': 923,
    'Mu': 924,
    'Nu': 925,
    'Xi': 926,
    'Omicron': 927,
    'Pi': 928,
    'Rho': 929,
    'Sigma': 931,
    'Tau': 932,
    'Upsilon': 933,
    'Phi': 934,
    'Chi': 935,
    'Psi': 936,
    'Omega': 937,
    'alpha': 945,
    'beta': 946,
    'gamma': 947,
    'delta': 948,
    'epsilon': 949,
    'zeta': 950,
    'eta': 951,
    'theta': 952,
    'iota': 953,
    'kappa': 954,
    'lambda': 955,
    'mu': 956,
    'nu': 957,
    'xi': 958,
    'omicron': 959,
    'pi': 960,
    'rho': 961,
    'sigmaf': 962,
    'sigma': 963,
    'tau': 964,
    'upsilon': 965,
    'phi': 966,
    'chi': 967,
    'psi': 968,
    'omega': 969,
    'thetasym': 977,
    'upsih': 978,
    'piv': 982,
    'ensp': 8194,
    'emsp': 8195,
    'thinsp': 8201,
    'zwnj': 8204,
    'zwj': 8205,
    'lrm': 8206,
    'rlm': 8207,
    'ndash': 8211,
    'mdash': 8212,
    'lsquo': 8216,
    'rsquo': 8217,
    'sbquo': 8218,
    'ldquo': 8220,
    'rdquo': 8221,
    'bdquo': 8222,
    'dagger': 8224,
    'Dagger': 8225,
    'bull': 8226,
    'hellip': 8230,
    'permil': 8240,
    'prime': 8242,
    'Prime': 8243,
    'lsaquo': 8249,
    'rsaquo': 8250,
    'oline': 8254,
    'frasl': 8260,
    'euro': 8364,
    'image': 8465,
    'weierp': 8472,
    'real': 8476,
    'trade': 8482,
    'alefsym': 8501,
    'larr': 8592,
    'uarr': 8593,
    'rarr': 8594,
    'darr': 8595,
    'harr': 8596,
    'crarr': 8629,
    'lArr': 8656,
    'uArr': 8657,
    'rArr': 8658,
    'dArr': 8659,
    'hArr': 8660,
    'forall': 8704,
    'part': 8706,
    'exist': 8707,
    'empty': 8709,
    'nabla': 8711,
    'isin': 8712,
    'notin': 8713,
    'ni': 8715,
    'prod': 8719,
    'sum': 8721,
    'minus': 8722,
    'lowast': 8727,
    'radic': 8730,
    'prop': 8733,
    'infin': 8734,
    'ang': 8736,
    'and': 8743,
    'or': 8744,
    'cap': 8745,
    'cup': 8746,
    'int': 8747,
    'there4': 8756,
    'sim': 8764,
    'cong': 8773,
    'asymp': 8776,
    'ne': 8800,
    'equiv': 8801,
    'le': 8804,
    'ge': 8805,
    'sub': 8834,
    'sup': 8835,
    'nsub': 8836,
    'sube': 8838,
    'supe': 8839,
    'oplus': 8853,
    'otimes': 8855,
    'perp': 8869,
    'sdot': 8901,
    'lceil': 8968,
    'rceil': 8969,
    'lfloor': 8970,
    'rfloor': 8971,
    'lang': 9001,
    'rang': 9002,
    'loz': 9674,
    'spades': 9824,
    'clubs': 9827,
    'hearts': 9829,
    'diams': 9830
  };

  Object.keys(sax.ENTITIES).forEach(function (key) {
    var e = sax.ENTITIES[key];
    var s = typeof e === 'number' ? String.fromCharCode(e) : e;
    sax.ENTITIES[key] = s;
  });

  for (var s in sax.STATE) {
    sax.STATE[sax.STATE[s]] = s;
  }

  // shorthand
  S = sax.STATE;

  function emit (parser, event, data) {
    parser[event] && parser[event](data);
  }

  function emitNode (parser, nodeType, data) {
    if (parser.textNode) closeText(parser);
    emit(parser, nodeType, data);
  }

  function closeText (parser) {
    parser.textNode = textopts(parser.opt, parser.textNode);
    if (parser.textNode) emit(parser, 'ontext', parser.textNode);
    parser.textNode = '';
  }

  function textopts (opt, text) {
    if (opt.trim) text = text.trim();
    if (opt.normalize) text = text.replace(/\s+/g, ' ');
    return text
  }

  function error (parser, er) {
    closeText(parser);
    if (parser.trackPosition) {
      er += '\nLine: ' + parser.line +
        '\nColumn: ' + parser.column +
        '\nChar: ' + parser.c;
    }
    er = new Error(er);
    parser.error = er;
    emit(parser, 'onerror', er);
    return parser
  }

  function end (parser) {
    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag');
    if ((parser.state !== S.BEGIN) &&
      (parser.state !== S.BEGIN_WHITESPACE) &&
      (parser.state !== S.TEXT)) {
      error(parser, 'Unexpected end');
    }
    closeText(parser);
    parser.c = '';
    parser.closed = true;
    emit(parser, 'onend');
    SAXParser.call(parser, parser.strict, parser.opt);
    return parser
  }

  function strictFail (parser, message) {
    if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
      throw new Error('bad call to strictFail')
    }
    if (parser.strict) {
      error(parser, message);
    }
  }

  function newTag (parser) {
    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]();
    var parent = parser.tags[parser.tags.length - 1] || parser;
    var tag = parser.tag = { name: parser.tagName, attributes: {} };

    // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
    if (parser.opt.xmlns) {
      tag.ns = parent.ns;
    }
    parser.attribList.length = 0;
    emitNode(parser, 'onopentagstart', tag);
  }

  function qname (name, attribute) {
    var i = name.indexOf(':');
    var qualName = i < 0 ? [ '', name ] : name.split(':');
    var prefix = qualName[0];
    var local = qualName[1];

    // <x "xmlns"="http://foo">
    if (attribute && name === 'xmlns') {
      prefix = 'xmlns';
      local = '';
    }

    return { prefix: prefix, local: local }
  }

  function attrib (parser) {
    if (!parser.strict) {
      parser.attribName = parser.attribName[parser.looseCase]();
    }

    if (parser.attribList.indexOf(parser.attribName) !== -1 ||
      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
      parser.attribName = parser.attribValue = '';
      return
    }

    if (parser.opt.xmlns) {
      var qn = qname(parser.attribName, true);
      var prefix = qn.prefix;
      var local = qn.local;

      if (prefix === 'xmlns') {
        // namespace binding attribute. push the binding into scope
        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
          strictFail(parser,
            'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue);
        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
          strictFail(parser,
            'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue);
        } else {
          var tag = parser.tag;
          var parent = parser.tags[parser.tags.length - 1] || parser;
          if (tag.ns === parent.ns) {
            tag.ns = Object.create(parent.ns);
          }
          tag.ns[local] = parser.attribValue;
        }
      }

      // defer onattribute events until all attributes have been seen
      // so any new bindings can take effect. preserve attribute order
      // so deferred events can be emitted in document order
      parser.attribList.push([parser.attribName, parser.attribValue]);
    } else {
      // in non-xmlns mode, we can emit the event right away
      parser.tag.attributes[parser.attribName] = parser.attribValue;
      emitNode(parser, 'onattribute', {
        name: parser.attribName,
        value: parser.attribValue
      });
    }

    parser.attribName = parser.attribValue = '';
  }

  function openTag (parser, selfClosing) {
    if (parser.opt.xmlns) {
      // emit namespace binding events
      var tag = parser.tag;

      // add namespace info to tag
      var qn = qname(parser.tagName);
      tag.prefix = qn.prefix;
      tag.local = qn.local;
      tag.uri = tag.ns[qn.prefix] || '';

      if (tag.prefix && !tag.uri) {
        strictFail(parser, 'Unbound namespace prefix: ' +
          JSON.stringify(parser.tagName));
        tag.uri = qn.prefix;
      }

      var parent = parser.tags[parser.tags.length - 1] || parser;
      if (tag.ns && parent.ns !== tag.ns) {
        Object.keys(tag.ns).forEach(function (p) {
          emitNode(parser, 'onopennamespace', {
            prefix: p,
            uri: tag.ns[p]
          });
        });
      }

      // handle deferred onattribute events
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      for (var i = 0, l = parser.attribList.length; i < l; i++) {
        var nv = parser.attribList[i];
        var name = nv[0];
        var value = nv[1];
        var qualName = qname(name, true);
        var prefix = qualName.prefix;
        var local = qualName.local;
        var uri = prefix === '' ? '' : (tag.ns[prefix] || '');
        var a = {
          name: name,
          value: value,
          prefix: prefix,
          local: local,
          uri: uri
        };

        // if there's any attributes with an undefined namespace,
        // then fail on them now.
        if (prefix && prefix !== 'xmlns' && !uri) {
          strictFail(parser, 'Unbound namespace prefix: ' +
            JSON.stringify(prefix));
          a.uri = prefix;
        }
        parser.tag.attributes[name] = a;
        emitNode(parser, 'onattribute', a);
      }
      parser.attribList.length = 0;
    }

    parser.tag.isSelfClosing = !!selfClosing;

    // process the tag
    parser.sawRoot = true;
    parser.tags.push(parser.tag);
    emitNode(parser, 'onopentag', parser.tag);
    if (!selfClosing) {
      // special case for <script> in non-strict mode.
      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
        parser.state = S.SCRIPT;
      } else {
        parser.state = S.TEXT;
      }
      parser.tag = null;
      parser.tagName = '';
    }
    parser.attribName = parser.attribValue = '';
    parser.attribList.length = 0;
  }

  function closeTag (parser) {
    if (!parser.tagName) {
      strictFail(parser, 'Weird empty close tag.');
      parser.textNode += '</>';
      parser.state = S.TEXT;
      return
    }

    if (parser.script) {
      if (parser.tagName !== 'script') {
        parser.script += '</' + parser.tagName + '>';
        parser.tagName = '';
        parser.state = S.SCRIPT;
        return
      }
      emitNode(parser, 'onscript', parser.script);
      parser.script = '';
    }

    // first make sure that the closing tag actually exists.
    // <a><b></c></b></a> will close everything, otherwise.
    var t = parser.tags.length;
    var tagName = parser.tagName;
    if (!parser.strict) {
      tagName = tagName[parser.looseCase]();
    }
    var closeTo = tagName;
    while (t--) {
      var close = parser.tags[t];
      if (close.name !== closeTo) {
        // fail the first time in strict mode
        strictFail(parser, 'Unexpected close tag');
      } else {
        break
      }
    }

    // didn't find it.  we already failed for strict, so just abort.
    if (t < 0) {
      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName);
      parser.textNode += '</' + parser.tagName + '>';
      parser.state = S.TEXT;
      return
    }
    parser.tagName = tagName;
    var s = parser.tags.length;
    while (s-- > t) {
      var tag = parser.tag = parser.tags.pop();
      parser.tagName = parser.tag.name;
      emitNode(parser, 'onclosetag', parser.tagName);

      var x = {};
      for (var i in tag.ns) {
        x[i] = tag.ns[i];
      }

      var parent = parser.tags[parser.tags.length - 1] || parser;
      if (parser.opt.xmlns && tag.ns !== parent.ns) {
        // remove namespace bindings introduced by tag
        Object.keys(tag.ns).forEach(function (p) {
          var n = tag.ns[p];
          emitNode(parser, 'onclosenamespace', { prefix: p, uri: n });
        });
      }
    }
    if (t === 0) parser.closedRoot = true;
    parser.tagName = parser.attribValue = parser.attribName = '';
    parser.attribList.length = 0;
    parser.state = S.TEXT;
  }

  function parseEntity (parser) {
    var entity = parser.entity;
    var entityLC = entity.toLowerCase();
    var num;
    var numStr = '';

    if (parser.ENTITIES[entity]) {
      return parser.ENTITIES[entity]
    }
    if (parser.ENTITIES[entityLC]) {
      return parser.ENTITIES[entityLC]
    }
    entity = entityLC;
    if (entity.charAt(0) === '#') {
      if (entity.charAt(1) === 'x') {
        entity = entity.slice(2);
        num = parseInt(entity, 16);
        numStr = num.toString(16);
      } else {
        entity = entity.slice(1);
        num = parseInt(entity, 10);
        numStr = num.toString(10);
      }
    }
    entity = entity.replace(/^0+/, '');
    if (isNaN(num) || numStr.toLowerCase() !== entity) {
      strictFail(parser, 'Invalid character entity');
      return '&' + parser.entity + ';'
    }

    return String.fromCodePoint(num)
  }

  function beginWhiteSpace (parser, c) {
    if (c === '<') {
      parser.state = S.OPEN_WAKA;
      parser.startTagPosition = parser.position;
    } else if (!isWhitespace(c)) {
      // have to process this as a text node.
      // weird, but happens.
      strictFail(parser, 'Non-whitespace before first tag.');
      parser.textNode = c;
      parser.state = S.TEXT;
    }
  }

  function charAt (chunk, i) {
    var result = '';
    if (i < chunk.length) {
      result = chunk.charAt(i);
    }
    return result
  }

  function write (chunk) {
    var parser = this;
    if (this.error) {
      throw this.error
    }
    if (parser.closed) {
      return error(parser,
        'Cannot write after close. Assign an onready handler.')
    }
    if (chunk === null) {
      return end(parser)
    }
    if (typeof chunk === 'object') {
      chunk = chunk.toString();
    }
    var i = 0;
    var c = '';
    while (true) {
      c = charAt(chunk, i++);
      parser.c = c;

      if (!c) {
        break
      }

      if (parser.trackPosition) {
        parser.position++;
        if (c === '\n') {
          parser.line++;
          parser.column = 0;
        } else {
          parser.column++;
        }
      }

      switch (parser.state) {
        case S.BEGIN:
          parser.state = S.BEGIN_WHITESPACE;
          if (c === '\uFEFF') {
            continue
          }
          beginWhiteSpace(parser, c);
          continue

        case S.BEGIN_WHITESPACE:
          beginWhiteSpace(parser, c);
          continue

        case S.TEXT:
          if (parser.sawRoot && !parser.closedRoot) {
            var starti = i - 1;
            while (c && c !== '<' && c !== '&') {
              c = charAt(chunk, i++);
              if (c && parser.trackPosition) {
                parser.position++;
                if (c === '\n') {
                  parser.line++;
                  parser.column = 0;
                } else {
                  parser.column++;
                }
              }
            }
            parser.textNode += chunk.substring(starti, i - 1);
          }
          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
            parser.state = S.OPEN_WAKA;
            parser.startTagPosition = parser.position;
          } else {
            if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) {
              strictFail(parser, 'Text data outside of root node.');
            }
            if (c === '&') {
              parser.state = S.TEXT_ENTITY;
            } else {
              parser.textNode += c;
            }
          }
          continue

        case S.SCRIPT:
          // only non-strict
          if (c === '<') {
            parser.state = S.SCRIPT_ENDING;
          } else {
            parser.script += c;
          }
          continue

        case S.SCRIPT_ENDING:
          if (c === '/') {
            parser.state = S.CLOSE_TAG;
          } else {
            parser.script += '<' + c;
            parser.state = S.SCRIPT;
          }
          continue

        case S.OPEN_WAKA:
          // either a /, ?, !, or text is coming next.
          if (c === '!') {
            parser.state = S.SGML_DECL;
            parser.sgmlDecl = '';
          } else if (isWhitespace(c)) ; else if (isMatch(nameStart, c)) {
            parser.state = S.OPEN_TAG;
            parser.tagName = c;
          } else if (c === '/') {
            parser.state = S.CLOSE_TAG;
            parser.tagName = '';
          } else if (c === '?') {
            parser.state = S.PROC_INST;
            parser.procInstName = parser.procInstBody = '';
          } else {
            strictFail(parser, 'Unencoded <');
            // if there was some whitespace, then add that in.
            if (parser.startTagPosition + 1 < parser.position) {
              var pad = parser.position - parser.startTagPosition;
              c = new Array(pad).join(' ') + c;
            }
            parser.textNode += '<' + c;
            parser.state = S.TEXT;
          }
          continue

        case S.SGML_DECL:
          if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
            emitNode(parser, 'onopencdata');
            parser.state = S.CDATA;
            parser.sgmlDecl = '';
            parser.cdata = '';
          } else if (parser.sgmlDecl + c === '--') {
            parser.state = S.COMMENT;
            parser.comment = '';
            parser.sgmlDecl = '';
          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
            parser.state = S.DOCTYPE;
            if (parser.doctype || parser.sawRoot) {
              strictFail(parser,
                'Inappropriately located doctype declaration');
            }
            parser.doctype = '';
            parser.sgmlDecl = '';
          } else if (c === '>') {
            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl);
            parser.sgmlDecl = '';
            parser.state = S.TEXT;
          } else if (isQuote(c)) {
            parser.state = S.SGML_DECL_QUOTED;
            parser.sgmlDecl += c;
          } else {
            parser.sgmlDecl += c;
          }
          continue

        case S.SGML_DECL_QUOTED:
          if (c === parser.q) {
            parser.state = S.SGML_DECL;
            parser.q = '';
          }
          parser.sgmlDecl += c;
          continue

        case S.DOCTYPE:
          if (c === '>') {
            parser.state = S.TEXT;
            emitNode(parser, 'ondoctype', parser.doctype);
            parser.doctype = true; // just remember that we saw it.
          } else {
            parser.doctype += c;
            if (c === '[') {
              parser.state = S.DOCTYPE_DTD;
            } else if (isQuote(c)) {
              parser.state = S.DOCTYPE_QUOTED;
              parser.q = c;
            }
          }
          continue

        case S.DOCTYPE_QUOTED:
          parser.doctype += c;
          if (c === parser.q) {
            parser.q = '';
            parser.state = S.DOCTYPE;
          }
          continue

        case S.DOCTYPE_DTD:
          parser.doctype += c;
          if (c === ']') {
            parser.state = S.DOCTYPE;
          } else if (isQuote(c)) {
            parser.state = S.DOCTYPE_DTD_QUOTED;
            parser.q = c;
          }
          continue

        case S.DOCTYPE_DTD_QUOTED:
          parser.doctype += c;
          if (c === parser.q) {
            parser.state = S.DOCTYPE_DTD;
            parser.q = '';
          }
          continue

        case S.COMMENT:
          if (c === '-') {
            parser.state = S.COMMENT_ENDING;
          } else {
            parser.comment += c;
          }
          continue

        case S.COMMENT_ENDING:
          if (c === '-') {
            parser.state = S.COMMENT_ENDED;
            parser.comment = textopts(parser.opt, parser.comment);
            if (parser.comment) {
              emitNode(parser, 'oncomment', parser.comment);
            }
            parser.comment = '';
          } else {
            parser.comment += '-' + c;
            parser.state = S.COMMENT;
          }
          continue

        case S.COMMENT_ENDED:
          if (c !== '>') {
            strictFail(parser, 'Malformed comment');
            // allow <!-- blah -- bloo --> in non-strict mode,
            // which is a comment of " blah -- bloo "
            parser.comment += '--' + c;
            parser.state = S.COMMENT;
          } else {
            parser.state = S.TEXT;
          }
          continue

        case S.CDATA:
          if (c === ']') {
            parser.state = S.CDATA_ENDING;
          } else {
            parser.cdata += c;
          }
          continue

        case S.CDATA_ENDING:
          if (c === ']') {
            parser.state = S.CDATA_ENDING_2;
          } else {
            parser.cdata += ']' + c;
            parser.state = S.CDATA;
          }
          continue

        case S.CDATA_ENDING_2:
          if (c === '>') {
            if (parser.cdata) {
              emitNode(parser, 'oncdata', parser.cdata);
            }
            emitNode(parser, 'onclosecdata');
            parser.cdata = '';
            parser.state = S.TEXT;
          } else if (c === ']') {
            parser.cdata += ']';
          } else {
            parser.cdata += ']]' + c;
            parser.state = S.CDATA;
          }
          continue

        case S.PROC_INST:
          if (c === '?') {
            parser.state = S.PROC_INST_ENDING;
          } else if (isWhitespace(c)) {
            parser.state = S.PROC_INST_BODY;
          } else {
            parser.procInstName += c;
          }
          continue

        case S.PROC_INST_BODY:
          if (!parser.procInstBody && isWhitespace(c)) {
            continue
          } else if (c === '?') {
            parser.state = S.PROC_INST_ENDING;
          } else {
            parser.procInstBody += c;
          }
          continue

        case S.PROC_INST_ENDING:
          if (c === '>') {
            emitNode(parser, 'onprocessinginstruction', {
              name: parser.procInstName,
              body: parser.procInstBody
            });
            parser.procInstName = parser.procInstBody = '';
            parser.state = S.TEXT;
          } else {
            parser.procInstBody += '?' + c;
            parser.state = S.PROC_INST_BODY;
          }
          continue

        case S.OPEN_TAG:
          if (isMatch(nameBody, c)) {
            parser.tagName += c;
          } else {
            newTag(parser);
            if (c === '>') {
              openTag(parser);
            } else if (c === '/') {
              parser.state = S.OPEN_TAG_SLASH;
            } else {
              if (!isWhitespace(c)) {
                strictFail(parser, 'Invalid character in tag name');
              }
              parser.state = S.ATTRIB;
            }
          }
          continue

        case S.OPEN_TAG_SLASH:
          if (c === '>') {
            openTag(parser, true);
            closeTag(parser);
          } else {
            strictFail(parser, 'Forward-slash in opening tag not followed by >');
            parser.state = S.ATTRIB;
          }
          continue

        case S.ATTRIB:
          // haven't read the attribute name yet.
          if (isWhitespace(c)) {
            continue
          } else if (c === '>') {
            openTag(parser);
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH;
          } else if (isMatch(nameStart, c)) {
            parser.attribName = c;
            parser.attribValue = '';
            parser.state = S.ATTRIB_NAME;
          } else {
            strictFail(parser, 'Invalid attribute name');
          }
          continue

        case S.ATTRIB_NAME:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE;
          } else if (c === '>') {
            strictFail(parser, 'Attribute without value');
            parser.attribValue = parser.attribName;
            attrib(parser);
            openTag(parser);
          } else if (isWhitespace(c)) {
            parser.state = S.ATTRIB_NAME_SAW_WHITE;
          } else if (isMatch(nameBody, c)) {
            parser.attribName += c;
          } else {
            strictFail(parser, 'Invalid attribute name');
          }
          continue

        case S.ATTRIB_NAME_SAW_WHITE:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE;
          } else if (isWhitespace(c)) {
            continue
          } else {
            strictFail(parser, 'Attribute without value');
            parser.tag.attributes[parser.attribName] = '';
            parser.attribValue = '';
            emitNode(parser, 'onattribute', {
              name: parser.attribName,
              value: ''
            });
            parser.attribName = '';
            if (c === '>') {
              openTag(parser);
            } else if (isMatch(nameStart, c)) {
              parser.attribName = c;
              parser.state = S.ATTRIB_NAME;
            } else {
              strictFail(parser, 'Invalid attribute name');
              parser.state = S.ATTRIB;
            }
          }
          continue

        case S.ATTRIB_VALUE:
          if (isWhitespace(c)) {
            continue
          } else if (isQuote(c)) {
            parser.q = c;
            parser.state = S.ATTRIB_VALUE_QUOTED;
          } else {
            strictFail(parser, 'Unquoted attribute value');
            parser.state = S.ATTRIB_VALUE_UNQUOTED;
            parser.attribValue = c;
          }
          continue

        case S.ATTRIB_VALUE_QUOTED:
          if (c !== parser.q) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_Q;
            } else {
              parser.attribValue += c;
            }
            continue
          }
          attrib(parser);
          parser.q = '';
          parser.state = S.ATTRIB_VALUE_CLOSED;
          continue

        case S.ATTRIB_VALUE_CLOSED:
          if (isWhitespace(c)) {
            parser.state = S.ATTRIB;
          } else if (c === '>') {
            openTag(parser);
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH;
          } else if (isMatch(nameStart, c)) {
            strictFail(parser, 'No whitespace between attributes');
            parser.attribName = c;
            parser.attribValue = '';
            parser.state = S.ATTRIB_NAME;
          } else {
            strictFail(parser, 'Invalid attribute name');
          }
          continue

        case S.ATTRIB_VALUE_UNQUOTED:
          if (!isAttribEnd(c)) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_U;
            } else {
              parser.attribValue += c;
            }
            continue
          }
          attrib(parser);
          if (c === '>') {
            openTag(parser);
          } else {
            parser.state = S.ATTRIB;
          }
          continue

        case S.CLOSE_TAG:
          if (!parser.tagName) {
            if (isWhitespace(c)) {
              continue
            } else if (notMatch(nameStart, c)) {
              if (parser.script) {
                parser.script += '</' + c;
                parser.state = S.SCRIPT;
              } else {
                strictFail(parser, 'Invalid tagname in closing tag.');
              }
            } else {
              parser.tagName = c;
            }
          } else if (c === '>') {
            closeTag(parser);
          } else if (isMatch(nameBody, c)) {
            parser.tagName += c;
          } else if (parser.script) {
            parser.script += '</' + parser.tagName;
            parser.tagName = '';
            parser.state = S.SCRIPT;
          } else {
            if (!isWhitespace(c)) {
              strictFail(parser, 'Invalid tagname in closing tag');
            }
            parser.state = S.CLOSE_TAG_SAW_WHITE;
          }
          continue

        case S.CLOSE_TAG_SAW_WHITE:
          if (isWhitespace(c)) {
            continue
          }
          if (c === '>') {
            closeTag(parser);
          } else {
            strictFail(parser, 'Invalid characters in closing tag');
          }
          continue

        case S.TEXT_ENTITY:
        case S.ATTRIB_VALUE_ENTITY_Q:
        case S.ATTRIB_VALUE_ENTITY_U:
          var returnState;
          var buffer;
          switch (parser.state) {
            case S.TEXT_ENTITY:
              returnState = S.TEXT;
              buffer = 'textNode';
              break

            case S.ATTRIB_VALUE_ENTITY_Q:
              returnState = S.ATTRIB_VALUE_QUOTED;
              buffer = 'attribValue';
              break

            case S.ATTRIB_VALUE_ENTITY_U:
              returnState = S.ATTRIB_VALUE_UNQUOTED;
              buffer = 'attribValue';
              break
          }

          if (c === ';') {
            parser[buffer] += parseEntity(parser);
            parser.entity = '';
            parser.state = returnState;
          } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) {
            parser.entity += c;
          } else {
            strictFail(parser, 'Invalid character in entity name');
            parser[buffer] += '&' + parser.entity + c;
            parser.entity = '';
            parser.state = returnState;
          }

          continue

        default:
          throw new Error(parser, 'Unknown state: ' + parser.state)
      }
    } // while

    if (parser.position >= parser.bufferCheckPosition) {
      checkBufferLength(parser);
    }
    return parser
  }

  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
  /* istanbul ignore next */
  if (!String.fromCodePoint) {
    (function () {
      var stringFromCharCode = String.fromCharCode;
      var floor = Math.floor;
      var fromCodePoint = function () {
        var MAX_SIZE = 0x4000;
        var codeUnits = [];
        var highSurrogate;
        var lowSurrogate;
        var index = -1;
        var length = arguments.length;
        if (!length) {
          return ''
        }
        var result = '';
        while (++index < length) {
          var codePoint = Number(arguments[index]);
          if (
            !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
            codePoint < 0 || // not a valid Unicode code point
            codePoint > 0x10FFFF || // not a valid Unicode code point
            floor(codePoint) !== codePoint // not an integer
          ) {
            throw RangeError('Invalid code point: ' + codePoint)
          }
          if (codePoint <= 0xFFFF) { // BMP code point
            codeUnits.push(codePoint);
          } else { // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000;
            highSurrogate = (codePoint >> 10) + 0xD800;
            lowSurrogate = (codePoint % 0x400) + 0xDC00;
            codeUnits.push(highSurrogate, lowSurrogate);
          }
          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
            result += stringFromCharCode.apply(null, codeUnits);
            codeUnits.length = 0;
          }
        }
        return result
      };
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(String, 'fromCodePoint', {
          value: fromCodePoint,
          configurable: true,
          writable: true
        });
      } else {
        String.fromCodePoint = fromCodePoint;
      }
    }());
  }
})(exports);
}(sax$1));

var arrayHelper = {

  isArray: function(value) {
    if (Array.isArray) {
      return Array.isArray(value);
    }
    // fallback for older browsers like  IE 8
    return Object.prototype.toString.call( value ) === '[object Array]';
  }

};

var isArray$2 = arrayHelper.isArray;

var optionsHelper = {

  copyOptions: function (options) {
    var key, copy = {};
    for (key in options) {
      if (options.hasOwnProperty(key)) {
        copy[key] = options[key];
      }
    }
    return copy;
  },

  ensureFlagExists: function (item, options) {
    if (!(item in options) || typeof options[item] !== 'boolean') {
      options[item] = false;
    }
  },

  ensureSpacesExists: function (options) {
    if (!('spaces' in options) || (typeof options.spaces !== 'number' && typeof options.spaces !== 'string')) {
      options.spaces = 0;
    }
  },

  ensureAlwaysArrayExists: function (options) {
    if (!('alwaysArray' in options) || (typeof options.alwaysArray !== 'boolean' && !isArray$2(options.alwaysArray))) {
      options.alwaysArray = false;
    }
  },

  ensureKeyExists: function (key, options) {
    if (!(key + 'Key' in options) || typeof options[key + 'Key'] !== 'string') {
      options[key + 'Key'] = options.compact ? '_' + key : key;
    }
  },

  checkFnExists: function (key, options) {
    return key + 'Fn' in options;
  }

};

var sax = sax$1;
var helper$2 = optionsHelper;
var isArray$1 = arrayHelper.isArray;

var options;
var currentElement$1;

function validateOptions$2(userOptions) {
  options = helper$2.copyOptions(userOptions);
  helper$2.ensureFlagExists('ignoreDeclaration', options);
  helper$2.ensureFlagExists('ignoreInstruction', options);
  helper$2.ensureFlagExists('ignoreAttributes', options);
  helper$2.ensureFlagExists('ignoreText', options);
  helper$2.ensureFlagExists('ignoreComment', options);
  helper$2.ensureFlagExists('ignoreCdata', options);
  helper$2.ensureFlagExists('ignoreDoctype', options);
  helper$2.ensureFlagExists('compact', options);
  helper$2.ensureFlagExists('alwaysChildren', options);
  helper$2.ensureFlagExists('addParent', options);
  helper$2.ensureFlagExists('trim', options);
  helper$2.ensureFlagExists('nativeType', options);
  helper$2.ensureFlagExists('nativeTypeAttributes', options);
  helper$2.ensureFlagExists('sanitize', options);
  helper$2.ensureFlagExists('instructionHasAttributes', options);
  helper$2.ensureFlagExists('captureSpacesBetweenElements', options);
  helper$2.ensureAlwaysArrayExists(options);
  helper$2.ensureKeyExists('declaration', options);
  helper$2.ensureKeyExists('instruction', options);
  helper$2.ensureKeyExists('attributes', options);
  helper$2.ensureKeyExists('text', options);
  helper$2.ensureKeyExists('comment', options);
  helper$2.ensureKeyExists('cdata', options);
  helper$2.ensureKeyExists('doctype', options);
  helper$2.ensureKeyExists('type', options);
  helper$2.ensureKeyExists('name', options);
  helper$2.ensureKeyExists('elements', options);
  helper$2.ensureKeyExists('parent', options);
  return options;
}

function nativeType(value) {
  var nValue = Number(value);
  if (!isNaN(nValue)) {
    return nValue;
  }
  var bValue = value.toLowerCase();
  if (bValue === 'true') {
    return true;
  } else if (bValue === 'false') {
    return false;
  }
  return value;
}

function addField(type, value) {
  var key;
  if (options.compact) {
    if (
      !currentElement$1[options[type + 'Key']] &&
      (isArray$1(options.alwaysArray) ? options.alwaysArray.indexOf(options[type + 'Key']) !== -1 : options.alwaysArray)
    ) {
      currentElement$1[options[type + 'Key']] = [];
    }
    if (currentElement$1[options[type + 'Key']] && !isArray$1(currentElement$1[options[type + 'Key']])) {
      currentElement$1[options[type + 'Key']] = [currentElement$1[options[type + 'Key']]];
    }
    if (type + 'Fn' in options && typeof value === 'string') {
      value = options[type + 'Fn'](value, currentElement$1);
    }
    if (type === 'instruction' && ('instructionFn' in options || 'instructionNameFn' in options)) {
      for (key in value) {
        if (value.hasOwnProperty(key)) {
          if ('instructionFn' in options) {
            value[key] = options.instructionFn(value[key], key, currentElement$1);
          } else {
            var temp = value[key];
            delete value[key];
            value[options.instructionNameFn(key, temp, currentElement$1)] = temp;
          }
        }
      }
    }
    if (isArray$1(currentElement$1[options[type + 'Key']])) {
      currentElement$1[options[type + 'Key']].push(value);
    } else {
      currentElement$1[options[type + 'Key']] = value;
    }
  } else {
    if (!currentElement$1[options.elementsKey]) {
      currentElement$1[options.elementsKey] = [];
    }
    var element = {};
    element[options.typeKey] = type;
    if (type === 'instruction') {
      for (key in value) {
        if (value.hasOwnProperty(key)) {
          break;
        }
      }
      element[options.nameKey] = 'instructionNameFn' in options ? options.instructionNameFn(key, value, currentElement$1) : key;
      if (options.instructionHasAttributes) {
        element[options.attributesKey] = value[key][options.attributesKey];
        if ('instructionFn' in options) {
          element[options.attributesKey] = options.instructionFn(element[options.attributesKey], key, currentElement$1);
        }
      } else {
        if ('instructionFn' in options) {
          value[key] = options.instructionFn(value[key], key, currentElement$1);
        }
        element[options.instructionKey] = value[key];
      }
    } else {
      if (type + 'Fn' in options) {
        value = options[type + 'Fn'](value, currentElement$1);
      }
      element[options[type + 'Key']] = value;
    }
    if (options.addParent) {
      element[options.parentKey] = currentElement$1;
    }
    currentElement$1[options.elementsKey].push(element);
  }
}

function manipulateAttributes(attributes) {
  if ('attributesFn' in options && attributes) {
    attributes = options.attributesFn(attributes, currentElement$1);
  }
  if ((options.trim || 'attributeValueFn' in options || 'attributeNameFn' in options || options.nativeTypeAttributes) && attributes) {
    var key;
    for (key in attributes) {
      if (attributes.hasOwnProperty(key)) {
        if (options.trim) attributes[key] = attributes[key].trim();
        if (options.nativeTypeAttributes) {
          attributes[key] = nativeType(attributes[key]);
        }
        if ('attributeValueFn' in options) attributes[key] = options.attributeValueFn(attributes[key], key, currentElement$1);
        if ('attributeNameFn' in options) {
          var temp = attributes[key];
          delete attributes[key];
          attributes[options.attributeNameFn(key, attributes[key], currentElement$1)] = temp;
        }
      }
    }
  }
  return attributes;
}

function onInstruction(instruction) {
  var attributes = {};
  if (instruction.body && (instruction.name.toLowerCase() === 'xml' || options.instructionHasAttributes)) {
    var attrsRegExp = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|(\w+))\s*/g;
    var match;
    while ((match = attrsRegExp.exec(instruction.body)) !== null) {
      attributes[match[1]] = match[2] || match[3] || match[4];
    }
    attributes = manipulateAttributes(attributes);
  }
  if (instruction.name.toLowerCase() === 'xml') {
    if (options.ignoreDeclaration) {
      return;
    }
    currentElement$1[options.declarationKey] = {};
    if (Object.keys(attributes).length) {
      currentElement$1[options.declarationKey][options.attributesKey] = attributes;
    }
    if (options.addParent) {
      currentElement$1[options.declarationKey][options.parentKey] = currentElement$1;
    }
  } else {
    if (options.ignoreInstruction) {
      return;
    }
    if (options.trim) {
      instruction.body = instruction.body.trim();
    }
    var value = {};
    if (options.instructionHasAttributes && Object.keys(attributes).length) {
      value[instruction.name] = {};
      value[instruction.name][options.attributesKey] = attributes;
    } else {
      value[instruction.name] = instruction.body;
    }
    addField('instruction', value);
  }
}

function onStartElement(name, attributes) {
  var element;
  if (typeof name === 'object') {
    attributes = name.attributes;
    name = name.name;
  }
  attributes = manipulateAttributes(attributes);
  if ('elementNameFn' in options) {
    name = options.elementNameFn(name, currentElement$1);
  }
  if (options.compact) {
    element = {};
    if (!options.ignoreAttributes && attributes && Object.keys(attributes).length) {
      element[options.attributesKey] = {};
      var key;
      for (key in attributes) {
        if (attributes.hasOwnProperty(key)) {
          element[options.attributesKey][key] = attributes[key];
        }
      }
    }
    if (
      !(name in currentElement$1) &&
      (isArray$1(options.alwaysArray) ? options.alwaysArray.indexOf(name) !== -1 : options.alwaysArray)
    ) {
      currentElement$1[name] = [];
    }
    if (currentElement$1[name] && !isArray$1(currentElement$1[name])) {
      currentElement$1[name] = [currentElement$1[name]];
    }
    if (isArray$1(currentElement$1[name])) {
      currentElement$1[name].push(element);
    } else {
      currentElement$1[name] = element;
    }
  } else {
    if (!currentElement$1[options.elementsKey]) {
      currentElement$1[options.elementsKey] = [];
    }
    element = {};
    element[options.typeKey] = 'element';
    element[options.nameKey] = name;
    if (!options.ignoreAttributes && attributes && Object.keys(attributes).length) {
      element[options.attributesKey] = attributes;
    }
    if (options.alwaysChildren) {
      element[options.elementsKey] = [];
    }
    currentElement$1[options.elementsKey].push(element);
  }
  element[options.parentKey] = currentElement$1; // will be deleted in onEndElement() if !options.addParent
  currentElement$1 = element;
}

function onText(text) {
  if (options.ignoreText) {
    return;
  }
  if (!text.trim() && !options.captureSpacesBetweenElements) {
    return;
  }
  if (options.trim) {
    text = text.trim();
  }
  if (options.nativeType) {
    text = nativeType(text);
  }
  if (options.sanitize) {
    text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  addField('text', text);
}

function onComment(comment) {
  if (options.ignoreComment) {
    return;
  }
  if (options.trim) {
    comment = comment.trim();
  }
  addField('comment', comment);
}

function onEndElement(name) {
  var parentElement = currentElement$1[options.parentKey];
  if (!options.addParent) {
    delete currentElement$1[options.parentKey];
  }
  currentElement$1 = parentElement;
}

function onCdata(cdata) {
  if (options.ignoreCdata) {
    return;
  }
  if (options.trim) {
    cdata = cdata.trim();
  }
  addField('cdata', cdata);
}

function onDoctype(doctype) {
  if (options.ignoreDoctype) {
    return;
  }
  doctype = doctype.replace(/^ /, '');
  if (options.trim) {
    doctype = doctype.trim();
  }
  addField('doctype', doctype);
}

function onError(error) {
  error.note = error; //console.error(error);
}

var xml2js$2 = function (xml, userOptions) {

  var parser = sax.parser(true, {}) ;
  var result = {};
  currentElement$1 = result;

  options = validateOptions$2(userOptions);

  {
    parser.opt = {strictEntities: true};
    parser.onopentag = onStartElement;
    parser.ontext = onText;
    parser.oncomment = onComment;
    parser.onclosetag = onEndElement;
    parser.onerror = onError;
    parser.oncdata = onCdata;
    parser.ondoctype = onDoctype;
    parser.onprocessinginstruction = onInstruction;
  }

  {
    parser.write(xml).close();
  }

  if (result[options.elementsKey]) {
    var temp = result[options.elementsKey];
    delete result[options.elementsKey];
    result[options.elementsKey] = temp;
    delete result.text;
  }

  return result;

};

var helper$1 = optionsHelper;
var xml2js$1 = xml2js$2;

function validateOptions$1 (userOptions) {
  var options = helper$1.copyOptions(userOptions);
  helper$1.ensureSpacesExists(options);
  return options;
}

var xml2json$1 = function(xml, userOptions) {
  var options, js, json, parentKey;
  options = validateOptions$1(userOptions);
  js = xml2js$1(xml, options);
  parentKey = 'compact' in options && options.compact ? '_parent' : 'parent';
  // parentKey = ptions.compact ? '_parent' : 'parent'; // consider this
  if ('addParent' in options && options.addParent) {
    json = JSON.stringify(js, function (k, v) { return k === parentKey? '_' : v; }, options.spaces);
  } else {
    json = JSON.stringify(js, null, options.spaces);
  }
  return json.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
};

var helper = optionsHelper;
var isArray = arrayHelper.isArray;

var currentElement, currentElementName;

function validateOptions(userOptions) {
  var options = helper.copyOptions(userOptions);
  helper.ensureFlagExists('ignoreDeclaration', options);
  helper.ensureFlagExists('ignoreInstruction', options);
  helper.ensureFlagExists('ignoreAttributes', options);
  helper.ensureFlagExists('ignoreText', options);
  helper.ensureFlagExists('ignoreComment', options);
  helper.ensureFlagExists('ignoreCdata', options);
  helper.ensureFlagExists('ignoreDoctype', options);
  helper.ensureFlagExists('compact', options);
  helper.ensureFlagExists('indentText', options);
  helper.ensureFlagExists('indentCdata', options);
  helper.ensureFlagExists('indentAttributes', options);
  helper.ensureFlagExists('indentInstruction', options);
  helper.ensureFlagExists('fullTagEmptyElement', options);
  helper.ensureFlagExists('noQuotesForNativeAttributes', options);
  helper.ensureSpacesExists(options);
  if (typeof options.spaces === 'number') {
    options.spaces = Array(options.spaces + 1).join(' ');
  }
  helper.ensureKeyExists('declaration', options);
  helper.ensureKeyExists('instruction', options);
  helper.ensureKeyExists('attributes', options);
  helper.ensureKeyExists('text', options);
  helper.ensureKeyExists('comment', options);
  helper.ensureKeyExists('cdata', options);
  helper.ensureKeyExists('doctype', options);
  helper.ensureKeyExists('type', options);
  helper.ensureKeyExists('name', options);
  helper.ensureKeyExists('elements', options);
  return options;
}

function writeIndentation(options, depth, firstLine) {
  return (!firstLine && options.spaces ? '\n' : '') + Array(depth + 1).join(options.spaces);
}

function writeAttributes(attributes, options, depth) {
  if (options.ignoreAttributes) {
    return '';
  }
  if ('attributesFn' in options) {
    attributes = options.attributesFn(attributes, currentElementName, currentElement);
  }
  var key, attr, attrName, quote, result = [];
  for (key in attributes) {
    if (attributes.hasOwnProperty(key) && attributes[key] !== null && attributes[key] !== undefined) {
      quote = options.noQuotesForNativeAttributes && typeof attributes[key] !== 'string' ? '' : '"';
      attr = '' + attributes[key]; // ensure number and boolean are converted to String
      attr = attr.replace(/"/g, '&quot;');
      attrName = 'attributeNameFn' in options ? options.attributeNameFn(key, attr, currentElementName, currentElement) : key;
      result.push((options.spaces && options.indentAttributes? writeIndentation(options, depth+1, false) : ' '));
      result.push(attrName + '=' + quote + ('attributeValueFn' in options ? options.attributeValueFn(attr, key, currentElementName, currentElement) : attr) + quote);
    }
  }
  if (attributes && Object.keys(attributes).length && options.spaces && options.indentAttributes) {
    result.push(writeIndentation(options, depth, false));
  }
  return result.join('');
}

function writeDeclaration(declaration, options, depth) {
  currentElement = declaration;
  currentElementName = 'xml';
  return options.ignoreDeclaration ? '' :  '<?' + 'xml' + writeAttributes(declaration[options.attributesKey], options, depth) + '?>';
}

function writeInstruction(instruction, options, depth) {
  if (options.ignoreInstruction) {
    return '';
  }
  var key;
  for (key in instruction) {
    if (instruction.hasOwnProperty(key)) {
      break;
    }
  }
  var instructionName = 'instructionNameFn' in options ? options.instructionNameFn(key, instruction[key], currentElementName, currentElement) : key;
  if (typeof instruction[key] === 'object') {
    currentElement = instruction;
    currentElementName = instructionName;
    return '<?' + instructionName + writeAttributes(instruction[key][options.attributesKey], options, depth) + '?>';
  } else {
    var instructionValue = instruction[key] ? instruction[key] : '';
    if ('instructionFn' in options) instructionValue = options.instructionFn(instructionValue, key, currentElementName, currentElement);
    return '<?' + instructionName + (instructionValue ? ' ' + instructionValue : '') + '?>';
  }
}

function writeComment(comment, options) {
  return options.ignoreComment ? '' : '<!--' + ('commentFn' in options ? options.commentFn(comment, currentElementName, currentElement) : comment) + '-->';
}

function writeCdata(cdata, options) {
  return options.ignoreCdata ? '' : '<![CDATA[' + ('cdataFn' in options ? options.cdataFn(cdata, currentElementName, currentElement) : cdata.replace(']]>', ']]]]><![CDATA[>')) + ']]>';
}

function writeDoctype(doctype, options) {
  return options.ignoreDoctype ? '' : '<!DOCTYPE ' + ('doctypeFn' in options ? options.doctypeFn(doctype, currentElementName, currentElement) : doctype) + '>';
}

function writeText(text, options) {
  if (options.ignoreText) return '';
  text = '' + text; // ensure Number and Boolean are converted to String
  text = text.replace(/&amp;/g, '&'); // desanitize to avoid double sanitization
  text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return 'textFn' in options ? options.textFn(text, currentElementName, currentElement) : text;
}

function hasContent(element, options) {
  var i;
  if (element.elements && element.elements.length) {
    for (i = 0; i < element.elements.length; ++i) {
      switch (element.elements[i][options.typeKey]) {
      case 'text':
        if (options.indentText) {
          return true;
        }
        break; // skip to next key
      case 'cdata':
        if (options.indentCdata) {
          return true;
        }
        break; // skip to next key
      case 'instruction':
        if (options.indentInstruction) {
          return true;
        }
        break; // skip to next key
      case 'doctype':
      case 'comment':
      case 'element':
        return true;
      default:
        return true;
      }
    }
  }
  return false;
}

function writeElement(element, options, depth) {
  currentElement = element;
  currentElementName = element.name;
  var xml = [], elementName = 'elementNameFn' in options ? options.elementNameFn(element.name, element) : element.name;
  xml.push('<' + elementName);
  if (element[options.attributesKey]) {
    xml.push(writeAttributes(element[options.attributesKey], options, depth));
  }
  var withClosingTag = element[options.elementsKey] && element[options.elementsKey].length || element[options.attributesKey] && element[options.attributesKey]['xml:space'] === 'preserve';
  if (!withClosingTag) {
    if ('fullTagEmptyElementFn' in options) {
      withClosingTag = options.fullTagEmptyElementFn(element.name, element);
    } else {
      withClosingTag = options.fullTagEmptyElement;
    }
  }
  if (withClosingTag) {
    xml.push('>');
    if (element[options.elementsKey] && element[options.elementsKey].length) {
      xml.push(writeElements(element[options.elementsKey], options, depth + 1));
      currentElement = element;
      currentElementName = element.name;
    }
    xml.push(options.spaces && hasContent(element, options) ? '\n' + Array(depth + 1).join(options.spaces) : '');
    xml.push('</' + elementName + '>');
  } else {
    xml.push('/>');
  }
  return xml.join('');
}

function writeElements(elements, options, depth, firstLine) {
  return elements.reduce(function (xml, element) {
    var indent = writeIndentation(options, depth, firstLine && !xml);
    switch (element.type) {
    case 'element': return xml + indent + writeElement(element, options, depth);
    case 'comment': return xml + indent + writeComment(element[options.commentKey], options);
    case 'doctype': return xml + indent + writeDoctype(element[options.doctypeKey], options);
    case 'cdata': return xml + (options.indentCdata ? indent : '') + writeCdata(element[options.cdataKey], options);
    case 'text': return xml + (options.indentText ? indent : '') + writeText(element[options.textKey], options);
    case 'instruction':
      var instruction = {};
      instruction[element[options.nameKey]] = element[options.attributesKey] ? element : element[options.instructionKey];
      return xml + (options.indentInstruction ? indent : '') + writeInstruction(instruction, options, depth);
    }
  }, '');
}

function hasContentCompact(element, options, anyContent) {
  var key;
  for (key in element) {
    if (element.hasOwnProperty(key)) {
      switch (key) {
      case options.parentKey:
      case options.attributesKey:
        break; // skip to next key
      case options.textKey:
        if (options.indentText || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.cdataKey:
        if (options.indentCdata || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.instructionKey:
        if (options.indentInstruction || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.doctypeKey:
      case options.commentKey:
        return true;
      default:
        return true;
      }
    }
  }
  return false;
}

function writeElementCompact(element, name, options, depth, indent) {
  currentElement = element;
  currentElementName = name;
  var elementName = 'elementNameFn' in options ? options.elementNameFn(name, element) : name;
  if (typeof element === 'undefined' || element === null || element === '') {
    return 'fullTagEmptyElementFn' in options && options.fullTagEmptyElementFn(name, element) || options.fullTagEmptyElement ? '<' + elementName + '></' + elementName + '>' : '<' + elementName + '/>';
  }
  var xml = [];
  if (name) {
    xml.push('<' + elementName);
    if (typeof element !== 'object') {
      xml.push('>' + writeText(element,options) + '</' + elementName + '>');
      return xml.join('');
    }
    if (element[options.attributesKey]) {
      xml.push(writeAttributes(element[options.attributesKey], options, depth));
    }
    var withClosingTag = hasContentCompact(element, options, true) || element[options.attributesKey] && element[options.attributesKey]['xml:space'] === 'preserve';
    if (!withClosingTag) {
      if ('fullTagEmptyElementFn' in options) {
        withClosingTag = options.fullTagEmptyElementFn(name, element);
      } else {
        withClosingTag = options.fullTagEmptyElement;
      }
    }
    if (withClosingTag) {
      xml.push('>');
    } else {
      xml.push('/>');
      return xml.join('');
    }
  }
  xml.push(writeElementsCompact(element, options, depth + 1, false));
  currentElement = element;
  currentElementName = name;
  if (name) {
    xml.push((indent ? writeIndentation(options, depth, false) : '') + '</' + elementName + '>');
  }
  return xml.join('');
}

function writeElementsCompact(element, options, depth, firstLine) {
  var i, key, nodes, xml = [];
  for (key in element) {
    if (element.hasOwnProperty(key)) {
      nodes = isArray(element[key]) ? element[key] : [element[key]];
      for (i = 0; i < nodes.length; ++i) {
        switch (key) {
        case options.declarationKey: xml.push(writeDeclaration(nodes[i], options, depth)); break;
        case options.instructionKey: xml.push((options.indentInstruction ? writeIndentation(options, depth, firstLine) : '') + writeInstruction(nodes[i], options, depth)); break;
        case options.attributesKey: case options.parentKey: break; // skip
        case options.textKey: xml.push((options.indentText ? writeIndentation(options, depth, firstLine) : '') + writeText(nodes[i], options)); break;
        case options.cdataKey: xml.push((options.indentCdata ? writeIndentation(options, depth, firstLine) : '') + writeCdata(nodes[i], options)); break;
        case options.doctypeKey: xml.push(writeIndentation(options, depth, firstLine) + writeDoctype(nodes[i], options)); break;
        case options.commentKey: xml.push(writeIndentation(options, depth, firstLine) + writeComment(nodes[i], options)); break;
        default: xml.push(writeIndentation(options, depth, firstLine) + writeElementCompact(nodes[i], key, options, depth, hasContentCompact(nodes[i], options)));
        }
        firstLine = firstLine && !xml.length;
      }
    }
  }
  return xml.join('');
}

var js2xml$2 = function (js, options) {
  options = validateOptions(options);
  var xml = [];
  currentElement = js;
  currentElementName = '_root_';
  if (options.compact) {
    xml.push(writeElementsCompact(js, options, 0, true));
  } else {
    if (js[options.declarationKey]) {
      xml.push(writeDeclaration(js[options.declarationKey], options, 0));
    }
    if (js[options.elementsKey] && js[options.elementsKey].length) {
      xml.push(writeElements(js[options.elementsKey], options, 0, !xml.length));
    }
  }
  return xml.join('');
};

var js2xml$1 = js2xml$2;

var json2xml$1 = function (json, options) {
  if (json instanceof Buffer) {
    json = json.toString();
  }
  var js = null;
  if (typeof (json) === 'string') {
    try {
      js = JSON.parse(json);
    } catch (e) {
      throw new Error('The JSON structure is invalid');
    }
  } else {
    js = json;
  }
  return js2xml$1(js, options);
};

/*jslint node:true */

var xml2js = xml2js$2;
var xml2json = xml2json$1;
var js2xml = js2xml$2;
var json2xml = json2xml$1;

var lib$1 = {
  xml2js: xml2js,
  xml2json: xml2json,
  js2xml: js2xml,
  json2xml: json2xml
};

const maxTemplateComponentWidth = 680;
const defaultSignatureLayout = { type: 'DefaultSignature' };
function generateComponentId() {
    return Math.round(Math.random() * 100000);
}
const content = {
    id: generateComponentId(),
    type: 'ContentComponent',
    columnSpan: '12',
    fontFamily: { name: 'Arial' },
    fontSize: 14,
    fontColour: '#111111',
};
const signature = {
    id: generateComponentId(),
    layout: defaultSignatureLayout,
    type: 'SignatureComponent',
    profileImage: {
        horizontalAlignment: 'left',
        verticalAlignment: 'middle',
        width: 140,
        height: 140
    },
    alignment: { type: 'left' },
    columnSpan: '12',
    fontPrimaryColour: '#111111',
    fontSecondaryColour: '#333333',
    fontSize: 14,
    fontFamily: { name: 'Arial' },
    backgroundColour: { type: 'useBody' },
    socialMedia: {
        color: 'default',
        iconPack: 'circle-solid',
        size: 24,
        alignment: 'left',
    },
};
const defaultFreemium = {
    id: generateComponentId(),
    type: 'FreemiumComponent',
    columnSpan: '12',
};
const defaultBanner = {
    id: Math.round(Math.random() * 100000),
    name: 'to be replaced',
    type: 'BannerComponent',
    columnSpan: '12',
    url: null,
    linkUrl: '',
    format: '',
    base64: null,
    height: null,
    width: null,
};
const defaultLogo = {
    id: generateComponentId(),
    name: 'to be replaced',
    type: 'LogoComponent',
    columnSpan: '12',
    url: null,
    alignment: { type: 'left' },
    backgroundColour: { type: 'useBody' },
    linkUrl: '',
    format: '',
    base64: null,
    height: null,
    width: null,
    padding: null,
};
const defaultDisclaimer = {
    type: 'DisclaimerComponent',
    columnSpan: '12',
    content: '',
    fontColour: '#cccccc',
    fontSize: 10,
    alignment: 'justify',
    fontFamily: { name: 'Arial' },
    backgroundColour: { type: 'useBackground' },
    id: generateComponentId(),
};
const defaultTemplate = {
    style: {
        kind: 'fluid',
        width: maxTemplateComponentWidth,
        colour: null,
        topMargin: 24,
        spacing: 36,
    },
    components: [
        { ...defaultLogo, name: 'image at top' },
        content,
        { ...defaultBanner, name: 'image above signature' },
        signature,
        {
            ...defaultBanner,
            name: 'image below signature',
            id: generateComponentId(),
        },
        defaultFreemium,
    ],
};
const defaultSignatureData = [
    { name: 'default/name', value: '[Name]' },
    { name: 'default/position', value: '[Job title]' },
    { name: 'default/division', value: '[Division]' },
    { name: 'default/workphone', value: '[Phone 1]' },
    { name: 'default/mobilephone', value: '[Phone 2]' },
    { name: 'default/homephone', value: '[Phone 3]' },
    { name: 'default/orgname', value: '[Organization]' },
    { name: 'emailAccount/email', value: '[Primary Email]' },
    { name: 'default/physicaladdress', value: '[Address]' },
    { name: 'default/website', value: '[https://yourwebsite.com]' },
    { name: 'default/facebook', value: 'https://facebook.com' },
    { name: 'default/twitter', value: 'https://twitter.com' },
    { name: 'default/instagram', value: 'https://instagram.com' },
    { name: 'default/linkedin', value: 'https://linkedin.com' },
    { name: 'default/pinterest', value: 'https://pinterest.com' },
    { name: 'default/youtube', value: 'https://youtube.com' },
    { name: 'default/tiktok', value: 'https://tiktok.com' },
    {
        name: 'default/profileimage',
        value: '/content/images/placeholder-signature.png',
    },
];
const customXslt = `

<xsl:if xmlns="" test="account/default/name">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:19px;font-family:Arial, Helvetica, sans-serif;font-size:15px;font-weight:bold;color:#111111">
    <xsl:value-of xmlns="" select="account/default/name"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/position">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/position"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/division">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/division"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/workphone">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/workphone"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/mobilephone">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/mobilephone"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/homephone">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/homephone"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/fax">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/fax"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/skype">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/skype"></xsl:value-of>
  </div>
</xsl:if>
<div style="line-height:19px;font-family:Arial, Helvetica, sans-serif;font-size:15px;font-weight:bold;color:#111111"> ‌</div>
<xsl:if xmlns="" test="account/default/orgname">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:19px;font-family:Arial, Helvetica, sans-serif;font-size:15px;font-weight:bold;color:#111111">
    <xsl:value-of xmlns="" select="account/default/orgname"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/physicaladdress">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/physicaladdress"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/physicaladdresscity">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/physicaladdresscity"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/physicaladdressstate">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/physicaladdressstate"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/physicaladdresspostcode">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/physicaladdresspostcode"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/physicaladdresscountry">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/physicaladdresscountry"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/postaladdress">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/postaladdress"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/postaladdresscity">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/postaladdresscity"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/postaladdressstate">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/postaladdressstate"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/postaladdresspostcode">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/postaladdresspostcode"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/postaladdresscountry">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/postaladdresscountry"></xsl:value-of>
  </div>
</xsl:if>
<xsl:if xmlns="" test="account/default/website">
  <div xmlns="http://www.w3.org/1999/xhtml" style="line-height:17px;font-family:Arial, Helvetica, sans-serif;font-size:13px;color:#333333">
    <xsl:value-of xmlns="" select="account/default/website"></xsl:value-of>
  </div>
</xsl:if>
`;

const getBackgroundColour = (style, backgroundColour) => {
    switch (backgroundColour.type) {
        case 'useBackground':
            return style.colour || '#ffffff';
        case 'useBody':
            return '#ffffff';
        case 'custom':
            return backgroundColour.colour || '#ffffff';
        default:
            return '#ffffff';
    }
};
const isDisclaimerNextActive = (components, index) => {
    // this is the last element in the list or the disclaimer its self
    if (components.length - 1 === index ||
        components[index].type === 'DisclaimerComponent') {
        return false;
    }
    // the next component is disclaimer whether the image is active or not
    if (components[index + 1].type === 'DisclaimerComponent') {
        return true;
    }
    // this next component could be an inactive image and the next a disclaimer
    if (components[index + 1].type === 'LogoComponent' ||
        components[index + 1].type === 'BannerComponent') {
        // check that the selected component isn't an inactive image
        const nextComponent = components[index + 1];
        return (nextComponent.url === null &&
            components[index + 2].type === 'DisclaimerComponent');
    }
    return false;
};
const getCorrectSpacing = (disclaimerNext, spacing) => {
    if (disclaimerNext) {
        return 12;
    }
    return spacing;
};
const isImageActive = (component) => {
    const imageComponent = component;
    return imageComponent.url !== null;
};
const formatSignatureData = (data) => {
    const formattedData = {};
    data.forEach((item) => (formattedData[item.name] = item.value));
    return formattedData;
};
const convertSignatureDataToXml = (data) => {
    const cleanData = {};
    for (const [key, value] of Object.entries(data)) {
        cleanData[key.replace('default/', '').replace('emailAccount/', '')] = value;
    }
    const { email, ...cleanDefaultValues } = cleanData;
    const userData = {
        account: {
            default: cleanDefaultValues,
            emailAccount: { email },
        },
    };
    return lib$1.js2xml(userData, { compact: true });
};
const transformXslt = (xslt, xml) => {
    const parser = new DOMParser();
    const xmlNode = parser.parseFromString(xml, 'application/xml');
    const preXslt = `
    <xsl:stylesheet version="1.0" xmlns:xsl="http://www.w3.org/1999/XSL/Transform">
        <xsl:output method="html" indent="yes" />
        <xsl:template match="/">
        <xsl:variable name="urlChecker" select="'http://'"></xsl:variable>
        <xsl:variable name="urlCheckerSecure" select="'https://'"></xsl:variable>`;
    const postXslt = `
        </xsl:template>
  </xsl:stylesheet>`;
    const xsltNode = parser.parseFromString(preXslt + xslt + postXslt, 'application/xml');
    const xsltProcessor = new XSLTProcessor();
    try {
        xsltProcessor.importStylesheet(xsltNode);
        const xmlSerializer = new XMLSerializer();
        return xmlSerializer.serializeToString(xsltProcessor.transformToFragment(xmlNode, document));
    }
    catch (error) {
        // tslint:disable-next-line: no-console
        console.log(error);
    }
    return '';
};
const getFontHtmlCode = (font) => {
    switch (font.name) {
        case 'Arial':
            return 'Arial, Helvetica, sans-serif';
        case 'Times New Roman':
            return "'Times New Roman', Times, serif";
        case 'Georgia':
            return 'Georgia, serif';
        case 'Verdana':
            return 'Verdana, Geneva, sans-serif';
        case 'Impact':
            return 'Impact, Charcoal, sans-serif';
        case 'Arial Black':
            return "'Arial Black', Gadget, sans-serif";
        case 'Courier':
            return "'Courier New', Courier, monospace";
        case 'Calibri':
            return "Calibri, Candara, Segoe, 'Segoe UI', Optima, Arial, sans-serif";
        default:
            return 'Arial, Helvetica, sans-serif';
    }
};
const updateLegacyValues = (templateData) => {
    return {
        ...templateData,
        style: addLayoutSpacing(templateData.style),
        components: updateSocialPosition(updateComponentType(moveFreemiumToLast(updateDisclaimerAlignment(flattenComponentStructure(templateData.components))))),
    };
};
const updateSocialPosition = (components) => {
    const correctComponents = components.map((item) => {
        if (item.type === 'SignatureComponent' ||
            item.type === 'SignatureComponentEmpty') {
            const selectedItem = item;
            // remove legacy float alignment
            if (selectedItem.socialMedia &&
                // @ts-ignore
                selectedItem.socialMedia.alignment.type === 'float') {
                return {
                    ...selectedItem,
                    socialMedia: {
                        ...selectedItem.socialMedia,
                        alignment: { type: 'left' },
                    },
                };
            }
        }
        return item;
    });
    // @ts-ignore
    return correctComponents.map((item) => {
        if (item.type === 'SignatureComponent' ||
            item.type === 'SignatureComponentEmpty') {
            const selectedItem = item;
            if (selectedItem.socialMedia &&
                // @ts-ignore
                selectedItem.socialMedia.iconPack.name !== undefined) {
                const selectedSocial = selectedItem.socialMedia;
                return {
                    ...selectedItem,
                    socialMedia: {
                        color: 
                        // @ts-ignore
                        selectedSocial.colour.type === 'custom'
                            ? // @ts-ignore
                                selectedSocial.colour.colour
                            : 'default',
                        // @ts-ignore
                        alignment: selectedSocial.alignment.type,
                        // @ts-ignore
                        iconPack: translateIconType(selectedSocial.iconPack.name),
                        size: translateIconSize(selectedSocial.size),
                    },
                };
            }
            return item;
        }
        return item;
    });
};
const updateComponentType = (components) => {
    // tslint:disable-next-line: no-any
    return components.map((item) => {
        if (item.type === 'StandardSignatureComponent') {
            return {
                ...item,
                type: 'SignatureComponent',
            };
        }
        // @ts-ignore this is ignored because it no longer exists in the type but it used to be
        if (item.type === 'StandardSignatureComponentEmpty') {
            return {
                ...item,
                type: 'SignatureComponentEmpty',
            };
        }
        return item;
    });
};
const addLayoutSpacing = (layout) => {
    // tslint:disable-next-line: strict-type-predicates
    if (layout.spacing === undefined) {
        return { ...layout, spacing: 36 };
    }
    return layout;
};
const updateDisclaimerAlignment = (components) => {
    return components.map((item) => {
        if (item.type === 'DisclaimerComponent' &&
            // @ts-ignore
            item.alignment.type !== undefined) {
            return {
                ...item,
                // @ts-ignore
                alignment: item.alignment.type,
            };
        }
        return item;
    });
};
const moveFreemiumToLast = (components) => {
    const removedFreemiumComponents = components.filter((item) => {
        return item.type !== 'FreemiumComponent';
    });
    return [...removedFreemiumComponents, defaultFreemium];
};
// tslint:disable-next-line: no-any
const flattenComponentStructure = (components) => {
    if (components.length > 0 && components[0].type === undefined) {
        return components.flat();
    }
    return components;
};
const translateIconType = (type) => {
    switch (type) {
        case 'Circle':
            return 'circle-solid';
        case 'Square':
            return 'square-solid';
        default:
            return 'block';
    }
};
const translateIconSize = (size) => {
    switch (size) {
        case 22:
            return 24;
        case 33:
            return 32;
        default:
            return size;
    }
};

var server_node = {exports: {}};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/** @license React v16.14.0
 * react-dom-server.node.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var k$1=objectAssign,m$1=React,aa=require$$0;function r$1(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return "Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var u="function"===typeof Symbol&&Symbol.for,ba=u?Symbol.for("react.portal"):60106,v$1=u?Symbol.for("react.fragment"):60107,ca=u?Symbol.for("react.strict_mode"):60108,da=u?Symbol.for("react.profiler"):60114,w$1=u?Symbol.for("react.provider"):60109,ea=u?Symbol.for("react.context"):60110,fa=u?Symbol.for("react.concurrent_mode"):60111,ha=u?Symbol.for("react.forward_ref"):60112,B=u?Symbol.for("react.suspense"):60113,ia=u?Symbol.for("react.suspense_list"):60120,ja=u?Symbol.for("react.memo"):60115,ka=u?Symbol.for("react.lazy"):
60116,la=u?Symbol.for("react.block"):60121,ma=u?Symbol.for("react.fundamental"):60117,na=u?Symbol.for("react.scope"):60119;function oa(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(c){0===a._status&&(c=c.default,a._status=1,a._result=c);},function(c){0===a._status&&(a._status=2,a._result=c);});}}
function C(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case v$1:return "Fragment";case ba:return "Portal";case da:return "Profiler";case ca:return "StrictMode";case B:return "Suspense";case ia:return "SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case ea:return "Context.Consumer";case w$1:return "Context.Provider";case ha:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
case ja:return C(a.type);case la:return C(a.render);case ka:if(a=1===a._status?a._result:null)return C(a)}return null}var D=m$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;D.hasOwnProperty("ReactCurrentDispatcher")||(D.ReactCurrentDispatcher={current:null});D.hasOwnProperty("ReactCurrentBatchConfig")||(D.ReactCurrentBatchConfig={suspense:null});var pa={};function E(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1;}
function qa(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return E(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c;}else b=pa;return b}for(var F=new Uint16Array(16),H=0;15>H;H++)F[H]=H+1;F[15]=0;
var ra=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,sa=Object.prototype.hasOwnProperty,ta={},ua={};
function va(a){if(sa.call(ua,a))return !0;if(sa.call(ta,a))return !1;if(ra.test(a))return ua[a]=!0;ta[a]=!0;return !1}function wa(a,b,c,d){if(null!==c&&0===c.type)return !1;switch(typeof b){case "function":case "symbol":return !0;case "boolean":if(d)return !1;if(null!==c)return !c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return "data-"!==a&&"aria-"!==a;default:return !1}}
function xa(a,b,c,d){if(null===b||"undefined"===typeof b||wa(a,b,c,d))return !0;if(d)return !1;if(null!==c)switch(c.type){case 3:return !b;case 4:return !1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return !1}function J(a,b,c,d,f,h){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=h;}var K={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null,!1);});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null,!1);});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null,!1);});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null,!1);});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null,!1);});
["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a,null,!1);});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a,null,!1);});["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a,null,!1);});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null,!1);});var L=/[\-:]([a-z])/g;function M(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(L,
M);K[b]=new J(b,1,!1,a,null,!1);});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink",!1);});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1);});["tabIndex","crossOrigin"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!1);});
K.xlinkHref=new J("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!0);});var ya=/["'&<>]/;
function N(a){if("boolean"===typeof a||"number"===typeof a)return ""+a;a=""+a;var b=ya.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b;}a=f!==d?c+a.substring(f,d):c;}return a}
function za(a,b){var c=K.hasOwnProperty(a)?K[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||xa(a,b,c,!1))return "";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+'="'+(N(b)+'"')}return va(a)?a+'="'+(N(b)+'"'):""}function Aa(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
var Ba="function"===typeof Object.is?Object.is:Aa,O=null,P=null,Q=null,R=!1,S=!1,U=null,V=0;function W(){if(null===O)throw Error(r$1(321));return O}function Ca(){if(0<V)throw Error(r$1(312));return {memoizedState:null,queue:null,next:null}}function Da(){null===Q?null===P?(R=!1,P=Q=Ca()):(R=!0,Q=P):null===Q.next?(R=!1,Q=Q.next=Ca()):(R=!0,Q=Q.next);return Q}function Ea(a,b,c,d){for(;S;)S=!1,V+=1,Q=null,c=a(b,d);P=O=null;V=0;Q=U=null;return c}function Fa(a,b){return "function"===typeof b?b(a):b}
function Ga(a,b,c){O=W();Q=Da();if(R){var d=Q.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=Q.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);Q.memoizedState=d;return [d,b]}return [Q.memoizedState,b]}a=a===Fa?"function"===typeof b?b():b:void 0!==c?c(b):b;Q.memoizedState=a;a=Q.queue={last:null,dispatch:null};a=a.dispatch=Ha.bind(null,O,a);return [Q.memoizedState,a]}
function Ha(a,b,c){if(!(25>V))throw Error(r$1(301));if(a===O)if(S=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else {for(b=c;null!==b.next;)b=b.next;b.next=a;}}function Ia(){}
var X=0,Ja={readContext:function(a){var b=X;E(a,b);return a[b]},useContext:function(a){W();var b=X;E(a,b);return a[b]},useMemo:function(a,b){O=W();Q=Da();b=void 0===b?null:b;if(null!==Q){var c=Q.memoizedState;if(null!==c&&null!==b){a:{var d=c[1];if(null===d)d=!1;else {for(var f=0;f<d.length&&f<b.length;f++)if(!Ba(b[f],d[f])){d=!1;break a}d=!0;}}if(d)return c[0]}}a=a();Q.memoizedState=[a,b];return a},useReducer:Ga,useRef:function(a){O=W();Q=Da();var b=Q.memoizedState;return null===b?(a={current:a},Q.memoizedState=
a):b},useState:function(a){return Ga(Fa,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:Ia,useEffect:Ia,useDebugValue:Ia,useResponder:function(a,b){return {props:b,responder:a}},useDeferredValue:function(a){W();return a},useTransition:function(){W();return [function(a){a();},!1]}},Ka={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function La(a){switch(a){case "svg":return "http://www.w3.org/2000/svg";case "math":return "http://www.w3.org/1998/Math/MathML";default:return "http://www.w3.org/1999/xhtml"}}
var Ma={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Na=k$1({menuitem:!0},Ma),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Oa=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Oa.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a];});});
var Pa=/([A-Z])/g,Qa=/^ms-/,Z=m$1.Children.toArray,Ra=D.ReactCurrentDispatcher,Sa={listing:!0,pre:!0,textarea:!0},Ta=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Ua={},Va={};function Wa(a){if(void 0===a||null===a)return a;var b="";m$1.Children.forEach(a,function(a){null!=a&&(b+=a);});return b}var Xa=Object.prototype.hasOwnProperty,Ya={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Za(a,b){if(void 0===a)throw Error(r$1(152,C(b)||"Component"));}
function $a(a,b,c){function d(d,h){var e=h.prototype&&h.prototype.isReactComponent,f=qa(h,b,c,e),p=[],g=!1,l={isMounted:function(){return !1},enqueueForceUpdate:function(){if(null===p)return null},enqueueReplaceState:function(a,c){g=!0;p=[c];},enqueueSetState:function(a,c){if(null===p)return null;p.push(c);}};if(e){if(e=new h(d.props,f,l),"function"===typeof h.getDerivedStateFromProps){var x=h.getDerivedStateFromProps.call(null,d.props,e.state);null!=x&&(e.state=k$1({},e.state,x));}}else if(O={},e=h(d.props,
f,l),e=Ea(h,d.props,e,f),null==e||null==e.render){a=e;Za(a,h);return}e.props=d.props;e.context=f;e.updater=l;l=e.state;void 0===l&&(e.state=l=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof h.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof h.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),p.length){l=p;var t=
g;p=null;g=!1;if(t&&1===l.length)e.state=l[0];else {x=t?l[0]:e.state;var y=!0;for(t=t?1:0;t<l.length;t++){var q=l[t];q="function"===typeof q?q.call(e,x,d.props,f):q;null!=q&&(y?(y=!1,x=k$1({},x,q)):k$1(x,q));}e.state=x;}}else p=null;a=e.render();Za(a,h);if("function"===typeof e.getChildContext&&(d=h.childContextTypes,"object"===typeof d)){var A=e.getChildContext();for(var T in A)if(!(T in d))throw Error(r$1(108,C(h)||"Unknown",T));}A&&(b=k$1({},b,A));}for(;m$1.isValidElement(a);){var f=a,h=f.type;if("function"!==
typeof h)break;d(f,h);}return {child:a,context:b}}
var ab=function(){function a(a,b){m$1.isValidElement(a)?a.type!==v$1?a=[a]:(a=a.props.children,a=m$1.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:Ka.html,children:a,childIndex:0,context:pa,footer:""};var c=F[0];if(0===c){var d=F;c=d.length;var p=2*c;if(!(65536>=p))throw Error(r$1(304));var g=new Uint16Array(p);g.set(d);F=g;F[0]=c+1;for(d=c;d<p-1;d++)F[d]=d+1;F[p-1]=0;}else F[0]=F[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=
b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[];}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;F[a]=F[0];F[0]=a;}};b.pushProvider=function(a){var b=++this.contextIndex,c=a.type._context,h=this.threadID;E(c,h);var p=c[h];this.contextStack[b]=c;this.contextValueStack[b]=p;c[h]=a.props.value;};b.popProvider=function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];
this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f;};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a];};b.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Ra.current;Ra.current=Ja;try{for(var h=[""],p=!1;h[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var g=this.threadID;F[g]=F[0];F[0]=g;break}var e=this.stack[this.stack.length-1];if(p||e.childIndex>=
e.children.length){var I=e.footer;""!==I&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===w$1)this.popProvider(e.type);else if(e.type===B){this.suspenseDepth--;var G=h.pop();if(p){p=!1;var n=e.fallbackFrame;if(!n)throw Error(r$1(303));this.stack.push(n);h[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else h[this.suspenseDepth]+=G;}h[this.suspenseDepth]+=I;}else {var l=e.children[e.childIndex++],
x="";try{x+=this.render(l,e.context,e.domNamespace);}catch(t){if(null!=t&&"function"===typeof t.then)throw Error(r$1(294));throw t;}finally{}h.length<=this.suspenseDepth&&h.push("");h[this.suspenseDepth]+=x;}}return h[0]}finally{Ra.current=c,X=b;}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return "";if(this.makeStaticMarkup)return N(f);if(this.previousWasTextNode)return "\x3c!-- --\x3e"+N(f);this.previousWasTextNode=!0;return N(f)}b=$a(a,b,this.threadID);a=b.child;
b=b.context;if(null===a||!1===a)return "";if(!m$1.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===ba)throw Error(r$1(257));throw Error(r$1(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return ""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ca:case fa:case da:case ia:case v$1:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
"";case B:throw Error(r$1(294));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case ha:O={};var d=c.render(a.props,a.ref);d=Ea(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return "";case ja:return a=[m$1.createElement(c.type,k$1({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case w$1:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,
context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case ea:c=a.type;d=a.props;var g=this.threadID;E(c,g);c=Z(d.children(c[g]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return "";case ma:throw Error(r$1(338));case ka:switch(c=a.type,oa(c),c._status){case 1:return a=[m$1.createElement(c._result,k$1({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case 2:throw c._result;default:throw Error(r$1(295));
}case na:throw Error(r$1(343));}throw Error(r$1(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();if(!Ua.hasOwnProperty(c)){if(!Ta.test(c))throw Error(r$1(65,c));Ua[c]=!0;}var d=a.props;if("input"===c)d=k$1({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var g=d.value;if(null==g){g=d.defaultValue;var e=d.children;if(null!=e){if(null!=
g)throw Error(r$1(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(r$1(93));e=e[0];}g=""+e;}null==g&&(g="");}d=k$1({},d,{value:void 0,children:""+g});}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=k$1({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var I=Wa(d.children);if(null!=e){var G=null!=d.value?d.value+"":I;g=!1;if(Array.isArray(e))for(var n=0;n<e.length;n++){if(""+e[n]===G){g=!0;break}}else g=""+e===G;d=k$1({selected:void 0,children:void 0},
d,{selected:g,children:I});}}if(g=d){if(Na[c]&&(null!=g.children||null!=g.dangerouslySetInnerHTML))throw Error(r$1(137,c,""));if(null!=g.dangerouslySetInnerHTML){if(null!=g.children)throw Error(r$1(60));if(!("object"===typeof g.dangerouslySetInnerHTML&&"__html"in g.dangerouslySetInnerHTML))throw Error(r$1(61));}if(null!=g.style&&"object"!==typeof g.style)throw Error(r$1(62,""));}g=d;e=this.makeStaticMarkup;I=1===this.stack.length;G="<"+a.type;for(z in g)if(Xa.call(g,z)){var l=g[z];if(null!=l){if("style"===
z){n=void 0;var x="",t="";for(n in l)if(l.hasOwnProperty(n)){var y=0===n.indexOf("--"),q=l[n];if(null!=q){if(y)var A=n;else if(A=n,Va.hasOwnProperty(A))A=Va[A];else {var T=A.replace(Pa,"-$1").toLowerCase().replace(Qa,"-ms-");A=Va[A]=T;}x+=t+A+":";t=n;y=null==q||"boolean"===typeof q||""===q?"":y||"number"!==typeof q||0===q||Y.hasOwnProperty(t)&&Y[t]?(""+q).trim():q+"px";x+=y;t=";";}}l=x||null;}n=null;b:if(y=c,q=g,-1===y.indexOf("-"))y="string"===typeof q.is;else switch(y){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":y=
!1;break b;default:y=!0;}y?Ya.hasOwnProperty(z)||(n=z,n=va(n)&&null!=l?n+'="'+(N(l)+'"'):""):n=za(z,l);n&&(G+=" "+n);}}e||I&&(G+=' data-reactroot=""');var z=G;g="";Ma.hasOwnProperty(c)?z+="/>":(z+=">",g="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=N(e);break a}e=null;}null!=e?(d=[],Sa.hasOwnProperty(c)&&"\n"===e.charAt(0)&&(z+="\n"),z+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===
f?La(a):"http://www.w3.org/2000/svg"===f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:g});this.previousWasTextNode=!1;return z};return a}();function bb(a,b){a.prototype=Object.create(b.prototype);a.prototype.constructor=a;a.__proto__=b;}
var cb=function(a){function b(b,c){var d=a.call(this,{})||this;d.partialRenderer=new ab(b,c);return d}bb(b,a);var c=b.prototype;c._destroy=function(a,b){this.partialRenderer.destroy();b(a);};c._read=function(a){try{this.push(this.partialRenderer.read(a));}catch(f){this.destroy(f);}};return b}(aa.Readable),db={renderToString:function(a){a=new ab(a,!1);try{return a.read(Infinity)}finally{a.destroy();}},renderToStaticMarkup:function(a){a=new ab(a,!0);try{return a.read(Infinity)}finally{a.destroy();}},renderToNodeStream:function(a){return new cb(a,
!1)},renderToStaticNodeStream:function(a){return new cb(a,!0)},version:"16.14.0"};var reactDomServer_node_production_min=db.default||db;

var reactDomServer_node_development = {exports: {}};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/** @license React v16.14.0
 * react-dom-server.node.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

var React$1 = React;
var _assign = objectAssign;
var checkPropTypes = checkPropTypes_1;
var stream = require$$0;

var ReactVersion = '16.14.0';

// Do not require this module directly! Use normal `invariant` calls with
// template literal strings. The messages will be replaced with error codes
// during build.
function formatProdErrorMessage(code) {
  var url = 'https://reactjs.org/docs/error-decoder.html?invariant=' + code;

  for (var i = 1; i < arguments.length; i++) {
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return "Minified React error #" + code + "; visit " + url + " for the full message or " + 'use the non-minified dev environment for full errors and additional ' + 'helpful warnings.';
}

var ReactSharedInternals = React$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED; // Prevent newer renderers from RTE when used with older react package versions.
// Current owner and dispatcher used to share the same ref,
// but PR #14548 split them out to better support the react-debug-tools package.

if (!ReactSharedInternals.hasOwnProperty('ReactCurrentDispatcher')) {
  ReactSharedInternals.ReactCurrentDispatcher = {
    current: null
  };
}

if (!ReactSharedInternals.hasOwnProperty('ReactCurrentBatchConfig')) {
  ReactSharedInternals.ReactCurrentBatchConfig = {
    suspense: null
  };
}

// by calls to these methods by a Babel plugin.
//
// In PROD (or in packages without access to React internals),
// they are left as they are instead.

function warn(format) {
  {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    printWarning('warn', format, args);
  }
}
function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var hasExistingStack = args.length > 0 && typeof args[args.length - 1] === 'string' && args[args.length - 1].indexOf('\n    in') === 0;

    if (!hasExistingStack) {
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      var stack = ReactDebugCurrentFrame.getStackAddendum();

      if (stack !== '') {
        format += '%s';
        args = args.concat([stack]);
      }
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      throw new Error(message);
    } catch (x) {}
  }
}

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

var Uninitialized = -1;
var Pending = 0;
var Resolved = 1;
var Rejected = 2;
function refineResolvedLazyComponent(lazyComponent) {
  return lazyComponent._status === Resolved ? lazyComponent._result : null;
}
function initializeLazyComponentType(lazyComponent) {
  if (lazyComponent._status === Uninitialized) {
    lazyComponent._status = Pending;
    var ctor = lazyComponent._ctor;
    var thenable = ctor();
    lazyComponent._result = thenable;
    thenable.then(function (moduleObject) {
      if (lazyComponent._status === Pending) {
        var defaultExport = moduleObject.default;

        {
          if (defaultExport === undefined) {
            error('lazy: Expected the result of a dynamic import() call. ' + 'Instead received: %s\n\nYour code should look like: \n  ' + "const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
          }
        }

        lazyComponent._status = Resolved;
        lazyComponent._result = defaultExport;
      }
    }, function (error) {
      if (lazyComponent._status === Pending) {
        lazyComponent._status = Rejected;
        lazyComponent._result = error;
      }
    });
  }
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case REACT_FRAGMENT_TYPE:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return "Profiler";

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        return 'Context.Consumer';

      case REACT_PROVIDER_TYPE:
        return 'Context.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type.render);

      case REACT_LAZY_TYPE:
        {
          var thenable = type;
          var resolvedThenable = refineResolvedLazyComponent(thenable);

          if (resolvedThenable) {
            return getComponentName(resolvedThenable);
          }

          break;
        }
    }
  }

  return null;
}

var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
function describeComponentFrame (name, source, ownerName) {
  var sourceInfo = '';

  if (source) {
    var path = source.fileName;
    var fileName = path.replace(BEFORE_SLASH_RE, '');

    {
      // In DEV, include code for a common special case:
      // prefer "folder/index.js" instead of just "index.js".
      if (/^index\./.test(fileName)) {
        var match = path.match(BEFORE_SLASH_RE);

        if (match) {
          var pathBeforeSlash = match[1];

          if (pathBeforeSlash) {
            var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
            fileName = folderName + '/' + fileName;
          }
        }
      }
    }

    sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
  } else if (ownerName) {
    sourceInfo = ' (created by ' + ownerName + ')';
  }

  return '\n    in ' + (name || 'Unknown') + sourceInfo;
}

var enableSuspenseServerRenderer = false;

var enableDeprecatedFlareAPI = false; // Experimental Host Component support.

var ReactDebugCurrentFrame;
var didWarnAboutInvalidateContextType;

{
  ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
  didWarnAboutInvalidateContextType = new Set();
}

var emptyObject = {};

{
  Object.freeze(emptyObject);
}

function maskContext(type, context) {
  var contextTypes = type.contextTypes;

  if (!contextTypes) {
    return emptyObject;
  }

  var maskedContext = {};

  for (var contextName in contextTypes) {
    maskedContext[contextName] = context[contextName];
  }

  return maskedContext;
}

function checkContextTypes(typeSpecs, values, location) {
  {
    checkPropTypes(typeSpecs, values, location, 'Component', ReactDebugCurrentFrame.getCurrentStack);
  }
}

function validateContextBounds(context, threadID) {
  // If we don't have enough slots in this context to store this threadID,
  // fill it in without leaving any holes to ensure that the VM optimizes
  // this as non-holey index properties.
  // (Note: If `react` package is < 16.6, _threadCount is undefined.)
  for (var i = context._threadCount | 0; i <= threadID; i++) {
    // We assume that this is the same as the defaultValue which might not be
    // true if we're rendering inside a secondary renderer but they are
    // secondary because these use cases are very rare.
    context[i] = context._currentValue2;
    context._threadCount = i + 1;
  }
}
function processContext(type, context, threadID, isClass) {
  if (isClass) {
    var contextType = type.contextType;

    {
      if ('contextType' in type) {
        var isValid = // Allow null for conditional declaration
        contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>

        if (!isValid && !didWarnAboutInvalidateContextType.has(type)) {
          didWarnAboutInvalidateContextType.add(type);
          var addendum = '';

          if (contextType === undefined) {
            addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
          } else if (typeof contextType !== 'object') {
            addendum = ' However, it is set to a ' + typeof contextType + '.';
          } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
            addendum = ' Did you accidentally pass the Context.Provider instead?';
          } else if (contextType._context !== undefined) {
            // <Context.Consumer>
            addendum = ' Did you accidentally pass the Context.Consumer instead?';
          } else {
            addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
          }

          error('%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentName(type) || 'Component', addendum);
        }
      }
    }

    if (typeof contextType === 'object' && contextType !== null) {
      validateContextBounds(contextType, threadID);
      return contextType[threadID];
    }

    {
      var maskedContext = maskContext(type, context);

      {
        if (type.contextTypes) {
          checkContextTypes(type.contextTypes, maskedContext, 'context');
        }
      }

      return maskedContext;
    }
  } else {
    {
      var _maskedContext = maskContext(type, context);

      {
        if (type.contextTypes) {
          checkContextTypes(type.contextTypes, _maskedContext, 'context');
        }
      }

      return _maskedContext;
    }
  }
}

var nextAvailableThreadIDs = new Uint16Array(16);

for (var i = 0; i < 15; i++) {
  nextAvailableThreadIDs[i] = i + 1;
}

nextAvailableThreadIDs[15] = 0;

function growThreadCountAndReturnNextAvailable() {
  var oldArray = nextAvailableThreadIDs;
  var oldSize = oldArray.length;
  var newSize = oldSize * 2;

  if (!(newSize <= 0x10000)) {
    {
      throw Error( "Maximum number of concurrent React renderers exceeded. This can happen if you are not properly destroying the Readable provided by React. Ensure that you call .destroy() on it if you no longer want to read from it, and did not read to the end. If you use .pipe() this should be automatic." );
    }
  }

  var newArray = new Uint16Array(newSize);
  newArray.set(oldArray);
  nextAvailableThreadIDs = newArray;
  nextAvailableThreadIDs[0] = oldSize + 1;

  for (var _i = oldSize; _i < newSize - 1; _i++) {
    nextAvailableThreadIDs[_i] = _i + 1;
  }

  nextAvailableThreadIDs[newSize - 1] = 0;
  return oldSize;
}

function allocThreadID() {
  var nextID = nextAvailableThreadIDs[0];

  if (nextID === 0) {
    return growThreadCountAndReturnNextAvailable();
  }

  nextAvailableThreadIDs[0] = nextAvailableThreadIDs[nextID];
  return nextID;
}
function freeThreadID(id) {
  nextAvailableThreadIDs[id] = nextAvailableThreadIDs[0];
  nextAvailableThreadIDs[0] = id;
}

// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
var RESERVED = 0; // A simple string attribute.
// Attributes that aren't in the whitelist are presumed to have this type.

var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.

var BOOLEANISH_STRING = 2; // A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.

var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.

var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.

var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.

var POSITIVE_NUMERIC = 6;

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
/* eslint-enable max-len */

var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
var hasOwnProperty = Object.prototype.hasOwnProperty;
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
  if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
    return true;
  }

  if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
    return false;
  }

  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }

  illegalAttributeNameCache[attributeName] = true;

  {
    error('Invalid attribute name: `%s`', attributeName);
  }

  return false;
}
function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
  if (propertyInfo !== null) {
    return propertyInfo.type === RESERVED;
  }

  if (isCustomComponentTag) {
    return false;
  }

  if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
    return true;
  }

  return false;
}
function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
  if (propertyInfo !== null && propertyInfo.type === RESERVED) {
    return false;
  }

  switch (typeof value) {
    case 'function': // $FlowIssue symbol is perfectly valid here

    case 'symbol':
      // eslint-disable-line
      return true;

    case 'boolean':
      {
        if (isCustomComponentTag) {
          return false;
        }

        if (propertyInfo !== null) {
          return !propertyInfo.acceptsBooleans;
        } else {
          var prefix = name.toLowerCase().slice(0, 5);
          return prefix !== 'data-' && prefix !== 'aria-';
        }
      }

    default:
      return false;
  }
}
function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
  if (value === null || typeof value === 'undefined') {
    return true;
  }

  if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
    return true;
  }

  if (isCustomComponentTag) {
    return false;
  }

  if (propertyInfo !== null) {
    switch (propertyInfo.type) {
      case BOOLEAN:
        return !value;

      case OVERLOADED_BOOLEAN:
        return value === false;

      case NUMERIC:
        return isNaN(value);

      case POSITIVE_NUMERIC:
        return isNaN(value) || value < 1;
    }
  }

  return false;
}
function getPropertyInfo(name) {
  return properties.hasOwnProperty(name) ? properties[name] : null;
}

function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL) {
  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
  this.attributeName = attributeName;
  this.attributeNamespace = attributeNamespace;
  this.mustUseProperty = mustUseProperty;
  this.propertyName = name;
  this.type = type;
  this.sanitizeURL = sanitizeURL;
} // When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.


var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

var reservedProps = ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
// elements (not just inputs). Now that ReactDOMInput assigns to the
// defaultValue property -- do we need this?
'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];

reservedProps.forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false);
}); // A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.

[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
  var name = _ref[0],
      attributeName = _ref[1];
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, // attributeName
  null, // attributeNamespace
  false);
}); // These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).

['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false);
}); // These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.

['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false);
}); // These are HTML boolean attributes.

['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
// on the client side because the browsers are inconsistent. Instead we call focus().
'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
'itemScope'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false);
}); // These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.

['checked', // Note: `option.selected` is not updated if `select.multiple` is
// disabled with `removeAttribute`. We have special logic for handling this.
'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false);
}); // These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.

['capture', 'download' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false);
}); // These are HTML attributes that must be positive numbers.

['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false);
}); // These are HTML attributes that must be numbers.

['rowSpan', 'start'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false);
});
var CAMELIZE = /[\-\:]([a-z])/g;

var capitalize = function (token) {
  return token[1].toUpperCase();
}; // This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML whitelist.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.


['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, null, // attributeNamespace
  false);
}); // String SVG attributes with the xlink namespace.

['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/1999/xlink', false);
}); // String SVG attributes with the xml namespace.

['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/XML/1998/namespace', false);
}); // These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.

['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  false);
}); // These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.

var xlinkHref = 'xlinkHref';
properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, // mustUseProperty
'xlink:href', 'http://www.w3.org/1999/xlink', true);
['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  true);
});
// and any newline or tab are filtered out as if they're not part of the URL.
// https://url.spec.whatwg.org/#url-parsing
// Tab or newline are defined as \r\n\t:
// https://infra.spec.whatwg.org/#ascii-tab-or-newline
// A C0 control is a code point in the range \u0000 NULL to \u001F
// INFORMATION SEPARATOR ONE, inclusive:
// https://infra.spec.whatwg.org/#c0-control-or-space

/* eslint-disable max-len */


var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
var didWarn = false;

function sanitizeURL(url) {
  {
    if (!didWarn && isJavaScriptProtocol.test(url)) {
      didWarn = true;

      error('A future version of React will block javascript: URLs as a security precaution. ' + 'Use event handlers instead if you can. If you need to generate unsafe HTML try ' + 'using dangerouslySetInnerHTML instead. React was passed %s.', JSON.stringify(url));
    }
  }
}

// code copied and modified from escape-html

/**
 * Module variables.
 * @private
 */
var matchHtmlRegExp = /["'&<>]/;
/**
 * Escapes special characters and HTML entities in a given html string.
 *
 * @param  {string} string HTML string to escape for later insertion
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;

      case 38:
        // &
        escape = '&amp;';
        break;

      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'

        break;

      case 60:
        // <
        escape = '&lt;';
        break;

      case 62:
        // >
        escape = '&gt;';
        break;

      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
} // end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */


function escapeTextForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }

  return escapeHtml(text);
}

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */

function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextForBrowser(value) + '"';
}

function createMarkupForRoot() {
  return ROOT_ATTRIBUTE_NAME + '=""';
}
/**
 * Creates markup for a property.
 *
 * @param {string} name
 * @param {*} value
 * @return {?string} Markup string, or null if the property was invalid.
 */

function createMarkupForProperty(name, value) {
  var propertyInfo = getPropertyInfo(name);

  if (name !== 'style' && shouldIgnoreAttribute(name, propertyInfo, false)) {
    return '';
  }

  if (shouldRemoveAttribute(name, value, propertyInfo, false)) {
    return '';
  }

  if (propertyInfo !== null) {
    var attributeName = propertyInfo.attributeName;
    var type = propertyInfo.type;

    if (type === BOOLEAN || type === OVERLOADED_BOOLEAN && value === true) {
      return attributeName + '=""';
    } else {
      if (propertyInfo.sanitizeURL) {
        value = '' + value;
        sanitizeURL(value);
      }

      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    }
  } else if (isAttributeNameSafe(name)) {
    return name + '=' + quoteAttributeValueForBrowser(value);
  }

  return '';
}
/**
 * Creates markup for a custom property.
 *
 * @param {string} name
 * @param {*} value
 * @return {string} Markup string, or empty string if the property was invalid.
 */

function createMarkupForCustomAttribute(name, value) {
  if (!isAttributeNameSafe(name) || value == null) {
    return '';
  }

  return name + '=' + quoteAttributeValueForBrowser(value);
}

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
  ;
}

var objectIs = typeof Object.is === 'function' ? Object.is : is;

var currentlyRenderingComponent = null;
var firstWorkInProgressHook = null;
var workInProgressHook = null; // Whether the work-in-progress hook is a re-rendered hook

var isReRender = false; // Whether an update was scheduled during the currently executing render pass.

var didScheduleRenderPhaseUpdate = false; // Lazily created map of render-phase updates

var renderPhaseUpdates = null; // Counter to prevent infinite loops.

var numberOfReRenders = 0;
var RE_RENDER_LIMIT = 25;
var isInHookUserCodeInDev = false; // In DEV, this is the name of the currently executing primitive hook

var currentHookNameInDev;

function resolveCurrentlyRenderingComponent() {
  if (!(currentlyRenderingComponent !== null)) {
    {
      throw Error( "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem." );
    }
  }

  {
    if (isInHookUserCodeInDev) {
      error('Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://fb.me/rules-of-hooks');
    }
  }

  return currentlyRenderingComponent;
}

function areHookInputsEqual(nextDeps, prevDeps) {
  if (prevDeps === null) {
    {
      error('%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
    }

    return false;
  }

  {
    // Don't bother comparing lengths in prod because these arrays should be
    // passed inline.
    if (nextDeps.length !== prevDeps.length) {
      error('The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, "[" + nextDeps.join(', ') + "]", "[" + prevDeps.join(', ') + "]");
    }
  }

  for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
    if (objectIs(nextDeps[i], prevDeps[i])) {
      continue;
    }

    return false;
  }

  return true;
}

function createHook() {
  if (numberOfReRenders > 0) {
    {
      {
        throw Error( "Rendered more hooks than during the previous render" );
      }
    }
  }

  return {
    memoizedState: null,
    queue: null,
    next: null
  };
}

function createWorkInProgressHook() {
  if (workInProgressHook === null) {
    // This is the first hook in the list
    if (firstWorkInProgressHook === null) {
      isReRender = false;
      firstWorkInProgressHook = workInProgressHook = createHook();
    } else {
      // There's already a work-in-progress. Reuse it.
      isReRender = true;
      workInProgressHook = firstWorkInProgressHook;
    }
  } else {
    if (workInProgressHook.next === null) {
      isReRender = false; // Append to the end of the list

      workInProgressHook = workInProgressHook.next = createHook();
    } else {
      // There's already a work-in-progress. Reuse it.
      isReRender = true;
      workInProgressHook = workInProgressHook.next;
    }
  }

  return workInProgressHook;
}

function prepareToUseHooks(componentIdentity) {
  currentlyRenderingComponent = componentIdentity;

  {
    isInHookUserCodeInDev = false;
  } // The following should have already been reset
  // didScheduleRenderPhaseUpdate = false;
  // firstWorkInProgressHook = null;
  // numberOfReRenders = 0;
  // renderPhaseUpdates = null;
  // workInProgressHook = null;

}
function finishHooks(Component, props, children, refOrContext) {
  // This must be called after every function component to prevent hooks from
  // being used in classes.
  while (didScheduleRenderPhaseUpdate) {
    // Updates were scheduled during the render phase. They are stored in
    // the `renderPhaseUpdates` map. Call the component again, reusing the
    // work-in-progress hooks and applying the additional updates on top. Keep
    // restarting until no more updates are scheduled.
    didScheduleRenderPhaseUpdate = false;
    numberOfReRenders += 1; // Start over from the beginning of the list

    workInProgressHook = null;
    children = Component(props, refOrContext);
  }

  currentlyRenderingComponent = null;
  firstWorkInProgressHook = null;
  numberOfReRenders = 0;
  renderPhaseUpdates = null;
  workInProgressHook = null;

  {
    isInHookUserCodeInDev = false;
  } // These were reset above
  // currentlyRenderingComponent = null;
  // didScheduleRenderPhaseUpdate = false;
  // firstWorkInProgressHook = null;
  // numberOfReRenders = 0;
  // renderPhaseUpdates = null;
  // workInProgressHook = null;


  return children;
}

function readContext(context, observedBits) {
  var threadID = currentThreadID;
  validateContextBounds(context, threadID);

  {
    if (isInHookUserCodeInDev) {
      error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
    }
  }

  return context[threadID];
}

function useContext(context, observedBits) {
  {
    currentHookNameInDev = 'useContext';
  }

  resolveCurrentlyRenderingComponent();
  var threadID = currentThreadID;
  validateContextBounds(context, threadID);
  return context[threadID];
}

function basicStateReducer(state, action) {
  // $FlowFixMe: Flow doesn't like mixed types
  return typeof action === 'function' ? action(state) : action;
}

function useState(initialState) {
  {
    currentHookNameInDev = 'useState';
  }

  return useReducer(basicStateReducer, // useReducer has a special case to support lazy useState initializers
  initialState);
}
function useReducer(reducer, initialArg, init) {
  {
    if (reducer !== basicStateReducer) {
      currentHookNameInDev = 'useReducer';
    }
  }

  currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
  workInProgressHook = createWorkInProgressHook();

  if (isReRender) {
    // This is a re-render. Apply the new render phase updates to the previous
    // current hook.
    var queue = workInProgressHook.queue;
    var dispatch = queue.dispatch;

    if (renderPhaseUpdates !== null) {
      // Render phase updates are stored in a map of queue -> linked list
      var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);

      if (firstRenderPhaseUpdate !== undefined) {
        renderPhaseUpdates.delete(queue);
        var newState = workInProgressHook.memoizedState;
        var update = firstRenderPhaseUpdate;

        do {
          // Process this render phase update. We don't have to check the
          // priority because it will always be the same as the current
          // render's.
          var action = update.action;

          {
            isInHookUserCodeInDev = true;
          }

          newState = reducer(newState, action);

          {
            isInHookUserCodeInDev = false;
          }

          update = update.next;
        } while (update !== null);

        workInProgressHook.memoizedState = newState;
        return [newState, dispatch];
      }
    }

    return [workInProgressHook.memoizedState, dispatch];
  } else {
    {
      isInHookUserCodeInDev = true;
    }

    var initialState;

    if (reducer === basicStateReducer) {
      // Special case for `useState`.
      initialState = typeof initialArg === 'function' ? initialArg() : initialArg;
    } else {
      initialState = init !== undefined ? init(initialArg) : initialArg;
    }

    {
      isInHookUserCodeInDev = false;
    }

    workInProgressHook.memoizedState = initialState;

    var _queue = workInProgressHook.queue = {
      last: null,
      dispatch: null
    };

    var _dispatch = _queue.dispatch = dispatchAction.bind(null, currentlyRenderingComponent, _queue);

    return [workInProgressHook.memoizedState, _dispatch];
  }
}

function useMemo(nextCreate, deps) {
  currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
  workInProgressHook = createWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;

  if (workInProgressHook !== null) {
    var prevState = workInProgressHook.memoizedState;

    if (prevState !== null) {
      if (nextDeps !== null) {
        var prevDeps = prevState[1];

        if (areHookInputsEqual(nextDeps, prevDeps)) {
          return prevState[0];
        }
      }
    }
  }

  {
    isInHookUserCodeInDev = true;
  }

  var nextValue = nextCreate();

  {
    isInHookUserCodeInDev = false;
  }

  workInProgressHook.memoizedState = [nextValue, nextDeps];
  return nextValue;
}

function useRef(initialValue) {
  currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
  workInProgressHook = createWorkInProgressHook();
  var previousRef = workInProgressHook.memoizedState;

  if (previousRef === null) {
    var ref = {
      current: initialValue
    };

    {
      Object.seal(ref);
    }

    workInProgressHook.memoizedState = ref;
    return ref;
  } else {
    return previousRef;
  }
}

function useLayoutEffect(create, inputs) {
  {
    currentHookNameInDev = 'useLayoutEffect';

    error('useLayoutEffect does nothing on the server, because its effect cannot ' + "be encoded into the server renderer's output format. This will lead " + 'to a mismatch between the initial, non-hydrated UI and the intended ' + 'UI. To avoid this, useLayoutEffect should only be used in ' + 'components that render exclusively on the client. ' + 'See https://fb.me/react-uselayouteffect-ssr for common fixes.');
  }
}

function dispatchAction(componentIdentity, queue, action) {
  if (!(numberOfReRenders < RE_RENDER_LIMIT)) {
    {
      throw Error( "Too many re-renders. React limits the number of renders to prevent an infinite loop." );
    }
  }

  if (componentIdentity === currentlyRenderingComponent) {
    // This is a render phase update. Stash it in a lazily-created map of
    // queue -> linked list of updates. After this render pass, we'll restart
    // and apply the stashed updates on top of the work-in-progress hook.
    didScheduleRenderPhaseUpdate = true;
    var update = {
      action: action,
      next: null
    };

    if (renderPhaseUpdates === null) {
      renderPhaseUpdates = new Map();
    }

    var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);

    if (firstRenderPhaseUpdate === undefined) {
      renderPhaseUpdates.set(queue, update);
    } else {
      // Append the update to the end of the list.
      var lastRenderPhaseUpdate = firstRenderPhaseUpdate;

      while (lastRenderPhaseUpdate.next !== null) {
        lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
      }

      lastRenderPhaseUpdate.next = update;
    }
  }
}

function useCallback(callback, deps) {
  // Callbacks are passed as they are in the server environment.
  return callback;
}

function useResponder(responder, props) {
  return {
    props: props,
    responder: responder
  };
}

function useDeferredValue(value, config) {
  resolveCurrentlyRenderingComponent();
  return value;
}

function useTransition(config) {
  resolveCurrentlyRenderingComponent();

  var startTransition = function (callback) {
    callback();
  };

  return [startTransition, false];
}

function noop() {}

var currentThreadID = 0;
function setCurrentThreadID(threadID) {
  currentThreadID = threadID;
}
var Dispatcher = {
  readContext: readContext,
  useContext: useContext,
  useMemo: useMemo,
  useReducer: useReducer,
  useRef: useRef,
  useState: useState,
  useLayoutEffect: useLayoutEffect,
  useCallback: useCallback,
  // useImperativeHandle is not run in the server environment
  useImperativeHandle: noop,
  // Effects are not run in the server environment.
  useEffect: noop,
  // Debugging effect
  useDebugValue: noop,
  useResponder: useResponder,
  useDeferredValue: useDeferredValue,
  useTransition: useTransition
};

var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
var Namespaces = {
  html: HTML_NAMESPACE,
  mathml: MATH_NAMESPACE,
  svg: SVG_NAMESPACE
}; // Assumes there is no parent namespace.

function getIntrinsicNamespace(type) {
  switch (type) {
    case 'svg':
      return SVG_NAMESPACE;

    case 'math':
      return MATH_NAMESPACE;

    default:
      return HTML_NAMESPACE;
  }
}
function getChildNamespace(parentNamespace, type) {
  if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
    // No (or default) parent namespace: potential entry point.
    return getIntrinsicNamespace(type);
  }

  if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') {
    // We're leaving SVG.
    return HTML_NAMESPACE;
  } // By default, pass namespace below.


  return parentNamespace;
}

var ReactDebugCurrentFrame$2 = null;
var ReactControlledValuePropTypes = {
  checkPropTypes: null
};

{
  ReactDebugCurrentFrame$2 = ReactSharedInternals.ReactDebugCurrentFrame;
  var hasReadOnlyValue = {
    button: true,
    checkbox: true,
    image: true,
    hidden: true,
    radio: true,
    reset: true,
    submit: true
  };
  var propTypes = {
    value: function (props, propName, componentName) {
      if (hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled || props[propName] == null || enableDeprecatedFlareAPI ) {
        return null;
      }

      return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
    },
    checked: function (props, propName, componentName) {
      if (props.onChange || props.readOnly || props.disabled || props[propName] == null || enableDeprecatedFlareAPI ) {
        return null;
      }

      return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
    }
  };
  /**
   * Provide a linked `value` attribute for controlled forms. You should not use
   * this outside of the ReactDOM controlled form components.
   */

  ReactControlledValuePropTypes.checkPropTypes = function (tagName, props) {
    checkPropTypes(propTypes, props, 'prop', tagName, ReactDebugCurrentFrame$2.getStackAddendum);
  };
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.
var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.

};

// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

var HTML = '__html';
var ReactDebugCurrentFrame$3 = null;

{
  ReactDebugCurrentFrame$3 = ReactSharedInternals.ReactDebugCurrentFrame;
}

function assertValidProps(tag, props) {
  if (!props) {
    return;
  } // Note the use of `==` which checks for null or undefined.


  if (voidElementTags[tag]) {
    if (!(props.children == null && props.dangerouslySetInnerHTML == null)) {
      {
        throw Error( tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`." + ( ReactDebugCurrentFrame$3.getStackAddendum() ) );
      }
    }
  }

  if (props.dangerouslySetInnerHTML != null) {
    if (!(props.children == null)) {
      {
        throw Error( "Can only set one of `children` or `props.dangerouslySetInnerHTML`." );
      }
    }

    if (!(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML)) {
      {
        throw Error( "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information." );
      }
    }
  }

  {
    if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
      error('A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.');
    }
  }

  if (!(props.style == null || typeof props.style === 'object')) {
    {
      throw Error( "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX." + ( ReactDebugCurrentFrame$3.getStackAddendum() ) );
    }
  }
}

/**
 * CSS properties which accept numbers but are not in units of "px".
 */
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridArea: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */

function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}
/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */


var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.

Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */

function dangerousStyleValue(name, value, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901
  var isEmpty = value == null || typeof value === 'boolean' || value === '';

  if (isEmpty) {
    return '';
  }

  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return ('' + value).trim();
}

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */

function hyphenateStyleName(name) {
  return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

function isCustomComponent(tagName, props) {
  if (tagName.indexOf('-') === -1) {
    return typeof props.is === 'string';
  }

  switch (tagName) {
    // These are reserved SVG and MathML elements.
    // We don't mind this whitelist too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return false;

    default:
      return true;
  }
}

var warnValidStyle = function () {};

{
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
  var msPattern$1 = /^-ms-/;
  var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon

  var badStyleValueWithSemicolonPattern = /;\s*$/;
  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;
  var warnedForInfinityValue = false;

  var camelize = function (string) {
    return string.replace(hyphenPattern, function (_, character) {
      return character.toUpperCase();
    });
  };

  var warnHyphenatedStyleName = function (name) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;

    error('Unsupported style property %s. Did you mean %s?', name, // As Andi Smith suggests
    // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
    // is converted to lowercase `ms`.
    camelize(name.replace(msPattern$1, 'ms-')));
  };

  var warnBadVendoredStyleName = function (name) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;

    error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
  };

  var warnStyleValueWithSemicolon = function (name, value) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;

    error("Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
  };

  var warnStyleValueIsNaN = function (name, value) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;

    error('`NaN` is an invalid value for the `%s` css style property.', name);
  };

  var warnStyleValueIsInfinity = function (name, value) {
    if (warnedForInfinityValue) {
      return;
    }

    warnedForInfinityValue = true;

    error('`Infinity` is an invalid value for the `%s` css style property.', name);
  };

  warnValidStyle = function (name, value) {
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value);
    }

    if (typeof value === 'number') {
      if (isNaN(value)) {
        warnStyleValueIsNaN(name, value);
      } else if (!isFinite(value)) {
        warnStyleValueIsInfinity(name, value);
      }
    }
  };
}

var warnValidStyle$1 = warnValidStyle;

var ariaProperties = {
  'aria-current': 0,
  // state
  'aria-details': 0,
  'aria-disabled': 0,
  // state
  'aria-hidden': 0,
  // state
  'aria-invalid': 0,
  // state
  'aria-keyshortcuts': 0,
  'aria-label': 0,
  'aria-roledescription': 0,
  // Widget Attributes
  'aria-autocomplete': 0,
  'aria-checked': 0,
  'aria-expanded': 0,
  'aria-haspopup': 0,
  'aria-level': 0,
  'aria-modal': 0,
  'aria-multiline': 0,
  'aria-multiselectable': 0,
  'aria-orientation': 0,
  'aria-placeholder': 0,
  'aria-pressed': 0,
  'aria-readonly': 0,
  'aria-required': 0,
  'aria-selected': 0,
  'aria-sort': 0,
  'aria-valuemax': 0,
  'aria-valuemin': 0,
  'aria-valuenow': 0,
  'aria-valuetext': 0,
  // Live Region Attributes
  'aria-atomic': 0,
  'aria-busy': 0,
  'aria-live': 0,
  'aria-relevant': 0,
  // Drag-and-Drop Attributes
  'aria-dropeffect': 0,
  'aria-grabbed': 0,
  // Relationship Attributes
  'aria-activedescendant': 0,
  'aria-colcount': 0,
  'aria-colindex': 0,
  'aria-colspan': 0,
  'aria-controls': 0,
  'aria-describedby': 0,
  'aria-errormessage': 0,
  'aria-flowto': 0,
  'aria-labelledby': 0,
  'aria-owns': 0,
  'aria-posinset': 0,
  'aria-rowcount': 0,
  'aria-rowindex': 0,
  'aria-rowspan': 0,
  'aria-setsize': 0
};

var warnedProperties = {};
var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;

function validateProperty(tagName, name) {
  {
    if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) {
      return true;
    }

    if (rARIACamel.test(name)) {
      var ariaName = 'aria-' + name.slice(4).toLowerCase();
      var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
      // DOM properties, then it is an invalid aria-* attribute.

      if (correctName == null) {
        error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);

        warnedProperties[name] = true;
        return true;
      } // aria-* attributes should be lowercase; suggest the lowercase version.


      if (name !== correctName) {
        error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);

        warnedProperties[name] = true;
        return true;
      }
    }

    if (rARIA.test(name)) {
      var lowerCasedName = name.toLowerCase();
      var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
      // DOM properties, then it is an invalid aria-* attribute.

      if (standardName == null) {
        warnedProperties[name] = true;
        return false;
      } // aria-* attributes should be lowercase; suggest the lowercase version.


      if (name !== standardName) {
        error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);

        warnedProperties[name] = true;
        return true;
      }
    }
  }

  return true;
}

function warnInvalidARIAProps(type, props) {
  {
    var invalidProps = [];

    for (var key in props) {
      var isValid = validateProperty(type, key);

      if (!isValid) {
        invalidProps.push(key);
      }
    }

    var unknownPropString = invalidProps.map(function (prop) {
      return '`' + prop + '`';
    }).join(', ');

    if (invalidProps.length === 1) {
      error('Invalid aria prop %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop', unknownPropString, type);
    } else if (invalidProps.length > 1) {
      error('Invalid aria props %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop', unknownPropString, type);
    }
  }
}

function validateProperties(type, props) {
  if (isCustomComponent(type, props)) {
    return;
  }

  warnInvalidARIAProps(type, props);
}

var didWarnValueNull = false;
function validateProperties$1(type, props) {
  {
    if (type !== 'input' && type !== 'textarea' && type !== 'select') {
      return;
    }

    if (props != null && props.value === null && !didWarnValueNull) {
      didWarnValueNull = true;

      if (type === 'select' && props.multiple) {
        error('`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.', type);
      } else {
        error('`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.', type);
      }
    }
  }
}

/**
 * Mapping from registration name to plugin module
 */

var registrationNameModules = {};
/**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */

var possibleRegistrationNames =  {} ; // Trust the developer to only use possibleRegistrationNames in true

// When adding attributes to the HTML or SVG whitelist, be sure to
// also add them to this module to ensure casing and incorrect name
// warnings.
var possibleStandardNames = {
  // HTML
  accept: 'accept',
  acceptcharset: 'acceptCharset',
  'accept-charset': 'acceptCharset',
  accesskey: 'accessKey',
  action: 'action',
  allowfullscreen: 'allowFullScreen',
  alt: 'alt',
  as: 'as',
  async: 'async',
  autocapitalize: 'autoCapitalize',
  autocomplete: 'autoComplete',
  autocorrect: 'autoCorrect',
  autofocus: 'autoFocus',
  autoplay: 'autoPlay',
  autosave: 'autoSave',
  capture: 'capture',
  cellpadding: 'cellPadding',
  cellspacing: 'cellSpacing',
  challenge: 'challenge',
  charset: 'charSet',
  checked: 'checked',
  children: 'children',
  cite: 'cite',
  class: 'className',
  classid: 'classID',
  classname: 'className',
  cols: 'cols',
  colspan: 'colSpan',
  content: 'content',
  contenteditable: 'contentEditable',
  contextmenu: 'contextMenu',
  controls: 'controls',
  controlslist: 'controlsList',
  coords: 'coords',
  crossorigin: 'crossOrigin',
  dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
  data: 'data',
  datetime: 'dateTime',
  default: 'default',
  defaultchecked: 'defaultChecked',
  defaultvalue: 'defaultValue',
  defer: 'defer',
  dir: 'dir',
  disabled: 'disabled',
  disablepictureinpicture: 'disablePictureInPicture',
  download: 'download',
  draggable: 'draggable',
  enctype: 'encType',
  for: 'htmlFor',
  form: 'form',
  formmethod: 'formMethod',
  formaction: 'formAction',
  formenctype: 'formEncType',
  formnovalidate: 'formNoValidate',
  formtarget: 'formTarget',
  frameborder: 'frameBorder',
  headers: 'headers',
  height: 'height',
  hidden: 'hidden',
  high: 'high',
  href: 'href',
  hreflang: 'hrefLang',
  htmlfor: 'htmlFor',
  httpequiv: 'httpEquiv',
  'http-equiv': 'httpEquiv',
  icon: 'icon',
  id: 'id',
  innerhtml: 'innerHTML',
  inputmode: 'inputMode',
  integrity: 'integrity',
  is: 'is',
  itemid: 'itemID',
  itemprop: 'itemProp',
  itemref: 'itemRef',
  itemscope: 'itemScope',
  itemtype: 'itemType',
  keyparams: 'keyParams',
  keytype: 'keyType',
  kind: 'kind',
  label: 'label',
  lang: 'lang',
  list: 'list',
  loop: 'loop',
  low: 'low',
  manifest: 'manifest',
  marginwidth: 'marginWidth',
  marginheight: 'marginHeight',
  max: 'max',
  maxlength: 'maxLength',
  media: 'media',
  mediagroup: 'mediaGroup',
  method: 'method',
  min: 'min',
  minlength: 'minLength',
  multiple: 'multiple',
  muted: 'muted',
  name: 'name',
  nomodule: 'noModule',
  nonce: 'nonce',
  novalidate: 'noValidate',
  open: 'open',
  optimum: 'optimum',
  pattern: 'pattern',
  placeholder: 'placeholder',
  playsinline: 'playsInline',
  poster: 'poster',
  preload: 'preload',
  profile: 'profile',
  radiogroup: 'radioGroup',
  readonly: 'readOnly',
  referrerpolicy: 'referrerPolicy',
  rel: 'rel',
  required: 'required',
  reversed: 'reversed',
  role: 'role',
  rows: 'rows',
  rowspan: 'rowSpan',
  sandbox: 'sandbox',
  scope: 'scope',
  scoped: 'scoped',
  scrolling: 'scrolling',
  seamless: 'seamless',
  selected: 'selected',
  shape: 'shape',
  size: 'size',
  sizes: 'sizes',
  span: 'span',
  spellcheck: 'spellCheck',
  src: 'src',
  srcdoc: 'srcDoc',
  srclang: 'srcLang',
  srcset: 'srcSet',
  start: 'start',
  step: 'step',
  style: 'style',
  summary: 'summary',
  tabindex: 'tabIndex',
  target: 'target',
  title: 'title',
  type: 'type',
  usemap: 'useMap',
  value: 'value',
  width: 'width',
  wmode: 'wmode',
  wrap: 'wrap',
  // SVG
  about: 'about',
  accentheight: 'accentHeight',
  'accent-height': 'accentHeight',
  accumulate: 'accumulate',
  additive: 'additive',
  alignmentbaseline: 'alignmentBaseline',
  'alignment-baseline': 'alignmentBaseline',
  allowreorder: 'allowReorder',
  alphabetic: 'alphabetic',
  amplitude: 'amplitude',
  arabicform: 'arabicForm',
  'arabic-form': 'arabicForm',
  ascent: 'ascent',
  attributename: 'attributeName',
  attributetype: 'attributeType',
  autoreverse: 'autoReverse',
  azimuth: 'azimuth',
  basefrequency: 'baseFrequency',
  baselineshift: 'baselineShift',
  'baseline-shift': 'baselineShift',
  baseprofile: 'baseProfile',
  bbox: 'bbox',
  begin: 'begin',
  bias: 'bias',
  by: 'by',
  calcmode: 'calcMode',
  capheight: 'capHeight',
  'cap-height': 'capHeight',
  clip: 'clip',
  clippath: 'clipPath',
  'clip-path': 'clipPath',
  clippathunits: 'clipPathUnits',
  cliprule: 'clipRule',
  'clip-rule': 'clipRule',
  color: 'color',
  colorinterpolation: 'colorInterpolation',
  'color-interpolation': 'colorInterpolation',
  colorinterpolationfilters: 'colorInterpolationFilters',
  'color-interpolation-filters': 'colorInterpolationFilters',
  colorprofile: 'colorProfile',
  'color-profile': 'colorProfile',
  colorrendering: 'colorRendering',
  'color-rendering': 'colorRendering',
  contentscripttype: 'contentScriptType',
  contentstyletype: 'contentStyleType',
  cursor: 'cursor',
  cx: 'cx',
  cy: 'cy',
  d: 'd',
  datatype: 'datatype',
  decelerate: 'decelerate',
  descent: 'descent',
  diffuseconstant: 'diffuseConstant',
  direction: 'direction',
  display: 'display',
  divisor: 'divisor',
  dominantbaseline: 'dominantBaseline',
  'dominant-baseline': 'dominantBaseline',
  dur: 'dur',
  dx: 'dx',
  dy: 'dy',
  edgemode: 'edgeMode',
  elevation: 'elevation',
  enablebackground: 'enableBackground',
  'enable-background': 'enableBackground',
  end: 'end',
  exponent: 'exponent',
  externalresourcesrequired: 'externalResourcesRequired',
  fill: 'fill',
  fillopacity: 'fillOpacity',
  'fill-opacity': 'fillOpacity',
  fillrule: 'fillRule',
  'fill-rule': 'fillRule',
  filter: 'filter',
  filterres: 'filterRes',
  filterunits: 'filterUnits',
  floodopacity: 'floodOpacity',
  'flood-opacity': 'floodOpacity',
  floodcolor: 'floodColor',
  'flood-color': 'floodColor',
  focusable: 'focusable',
  fontfamily: 'fontFamily',
  'font-family': 'fontFamily',
  fontsize: 'fontSize',
  'font-size': 'fontSize',
  fontsizeadjust: 'fontSizeAdjust',
  'font-size-adjust': 'fontSizeAdjust',
  fontstretch: 'fontStretch',
  'font-stretch': 'fontStretch',
  fontstyle: 'fontStyle',
  'font-style': 'fontStyle',
  fontvariant: 'fontVariant',
  'font-variant': 'fontVariant',
  fontweight: 'fontWeight',
  'font-weight': 'fontWeight',
  format: 'format',
  from: 'from',
  fx: 'fx',
  fy: 'fy',
  g1: 'g1',
  g2: 'g2',
  glyphname: 'glyphName',
  'glyph-name': 'glyphName',
  glyphorientationhorizontal: 'glyphOrientationHorizontal',
  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
  glyphorientationvertical: 'glyphOrientationVertical',
  'glyph-orientation-vertical': 'glyphOrientationVertical',
  glyphref: 'glyphRef',
  gradienttransform: 'gradientTransform',
  gradientunits: 'gradientUnits',
  hanging: 'hanging',
  horizadvx: 'horizAdvX',
  'horiz-adv-x': 'horizAdvX',
  horizoriginx: 'horizOriginX',
  'horiz-origin-x': 'horizOriginX',
  ideographic: 'ideographic',
  imagerendering: 'imageRendering',
  'image-rendering': 'imageRendering',
  in2: 'in2',
  in: 'in',
  inlist: 'inlist',
  intercept: 'intercept',
  k1: 'k1',
  k2: 'k2',
  k3: 'k3',
  k4: 'k4',
  k: 'k',
  kernelmatrix: 'kernelMatrix',
  kernelunitlength: 'kernelUnitLength',
  kerning: 'kerning',
  keypoints: 'keyPoints',
  keysplines: 'keySplines',
  keytimes: 'keyTimes',
  lengthadjust: 'lengthAdjust',
  letterspacing: 'letterSpacing',
  'letter-spacing': 'letterSpacing',
  lightingcolor: 'lightingColor',
  'lighting-color': 'lightingColor',
  limitingconeangle: 'limitingConeAngle',
  local: 'local',
  markerend: 'markerEnd',
  'marker-end': 'markerEnd',
  markerheight: 'markerHeight',
  markermid: 'markerMid',
  'marker-mid': 'markerMid',
  markerstart: 'markerStart',
  'marker-start': 'markerStart',
  markerunits: 'markerUnits',
  markerwidth: 'markerWidth',
  mask: 'mask',
  maskcontentunits: 'maskContentUnits',
  maskunits: 'maskUnits',
  mathematical: 'mathematical',
  mode: 'mode',
  numoctaves: 'numOctaves',
  offset: 'offset',
  opacity: 'opacity',
  operator: 'operator',
  order: 'order',
  orient: 'orient',
  orientation: 'orientation',
  origin: 'origin',
  overflow: 'overflow',
  overlineposition: 'overlinePosition',
  'overline-position': 'overlinePosition',
  overlinethickness: 'overlineThickness',
  'overline-thickness': 'overlineThickness',
  paintorder: 'paintOrder',
  'paint-order': 'paintOrder',
  panose1: 'panose1',
  'panose-1': 'panose1',
  pathlength: 'pathLength',
  patterncontentunits: 'patternContentUnits',
  patterntransform: 'patternTransform',
  patternunits: 'patternUnits',
  pointerevents: 'pointerEvents',
  'pointer-events': 'pointerEvents',
  points: 'points',
  pointsatx: 'pointsAtX',
  pointsaty: 'pointsAtY',
  pointsatz: 'pointsAtZ',
  prefix: 'prefix',
  preservealpha: 'preserveAlpha',
  preserveaspectratio: 'preserveAspectRatio',
  primitiveunits: 'primitiveUnits',
  property: 'property',
  r: 'r',
  radius: 'radius',
  refx: 'refX',
  refy: 'refY',
  renderingintent: 'renderingIntent',
  'rendering-intent': 'renderingIntent',
  repeatcount: 'repeatCount',
  repeatdur: 'repeatDur',
  requiredextensions: 'requiredExtensions',
  requiredfeatures: 'requiredFeatures',
  resource: 'resource',
  restart: 'restart',
  result: 'result',
  results: 'results',
  rotate: 'rotate',
  rx: 'rx',
  ry: 'ry',
  scale: 'scale',
  security: 'security',
  seed: 'seed',
  shaperendering: 'shapeRendering',
  'shape-rendering': 'shapeRendering',
  slope: 'slope',
  spacing: 'spacing',
  specularconstant: 'specularConstant',
  specularexponent: 'specularExponent',
  speed: 'speed',
  spreadmethod: 'spreadMethod',
  startoffset: 'startOffset',
  stddeviation: 'stdDeviation',
  stemh: 'stemh',
  stemv: 'stemv',
  stitchtiles: 'stitchTiles',
  stopcolor: 'stopColor',
  'stop-color': 'stopColor',
  stopopacity: 'stopOpacity',
  'stop-opacity': 'stopOpacity',
  strikethroughposition: 'strikethroughPosition',
  'strikethrough-position': 'strikethroughPosition',
  strikethroughthickness: 'strikethroughThickness',
  'strikethrough-thickness': 'strikethroughThickness',
  string: 'string',
  stroke: 'stroke',
  strokedasharray: 'strokeDasharray',
  'stroke-dasharray': 'strokeDasharray',
  strokedashoffset: 'strokeDashoffset',
  'stroke-dashoffset': 'strokeDashoffset',
  strokelinecap: 'strokeLinecap',
  'stroke-linecap': 'strokeLinecap',
  strokelinejoin: 'strokeLinejoin',
  'stroke-linejoin': 'strokeLinejoin',
  strokemiterlimit: 'strokeMiterlimit',
  'stroke-miterlimit': 'strokeMiterlimit',
  strokewidth: 'strokeWidth',
  'stroke-width': 'strokeWidth',
  strokeopacity: 'strokeOpacity',
  'stroke-opacity': 'strokeOpacity',
  suppresscontenteditablewarning: 'suppressContentEditableWarning',
  suppresshydrationwarning: 'suppressHydrationWarning',
  surfacescale: 'surfaceScale',
  systemlanguage: 'systemLanguage',
  tablevalues: 'tableValues',
  targetx: 'targetX',
  targety: 'targetY',
  textanchor: 'textAnchor',
  'text-anchor': 'textAnchor',
  textdecoration: 'textDecoration',
  'text-decoration': 'textDecoration',
  textlength: 'textLength',
  textrendering: 'textRendering',
  'text-rendering': 'textRendering',
  to: 'to',
  transform: 'transform',
  typeof: 'typeof',
  u1: 'u1',
  u2: 'u2',
  underlineposition: 'underlinePosition',
  'underline-position': 'underlinePosition',
  underlinethickness: 'underlineThickness',
  'underline-thickness': 'underlineThickness',
  unicode: 'unicode',
  unicodebidi: 'unicodeBidi',
  'unicode-bidi': 'unicodeBidi',
  unicoderange: 'unicodeRange',
  'unicode-range': 'unicodeRange',
  unitsperem: 'unitsPerEm',
  'units-per-em': 'unitsPerEm',
  unselectable: 'unselectable',
  valphabetic: 'vAlphabetic',
  'v-alphabetic': 'vAlphabetic',
  values: 'values',
  vectoreffect: 'vectorEffect',
  'vector-effect': 'vectorEffect',
  version: 'version',
  vertadvy: 'vertAdvY',
  'vert-adv-y': 'vertAdvY',
  vertoriginx: 'vertOriginX',
  'vert-origin-x': 'vertOriginX',
  vertoriginy: 'vertOriginY',
  'vert-origin-y': 'vertOriginY',
  vhanging: 'vHanging',
  'v-hanging': 'vHanging',
  videographic: 'vIdeographic',
  'v-ideographic': 'vIdeographic',
  viewbox: 'viewBox',
  viewtarget: 'viewTarget',
  visibility: 'visibility',
  vmathematical: 'vMathematical',
  'v-mathematical': 'vMathematical',
  vocab: 'vocab',
  widths: 'widths',
  wordspacing: 'wordSpacing',
  'word-spacing': 'wordSpacing',
  writingmode: 'writingMode',
  'writing-mode': 'writingMode',
  x1: 'x1',
  x2: 'x2',
  x: 'x',
  xchannelselector: 'xChannelSelector',
  xheight: 'xHeight',
  'x-height': 'xHeight',
  xlinkactuate: 'xlinkActuate',
  'xlink:actuate': 'xlinkActuate',
  xlinkarcrole: 'xlinkArcrole',
  'xlink:arcrole': 'xlinkArcrole',
  xlinkhref: 'xlinkHref',
  'xlink:href': 'xlinkHref',
  xlinkrole: 'xlinkRole',
  'xlink:role': 'xlinkRole',
  xlinkshow: 'xlinkShow',
  'xlink:show': 'xlinkShow',
  xlinktitle: 'xlinkTitle',
  'xlink:title': 'xlinkTitle',
  xlinktype: 'xlinkType',
  'xlink:type': 'xlinkType',
  xmlbase: 'xmlBase',
  'xml:base': 'xmlBase',
  xmllang: 'xmlLang',
  'xml:lang': 'xmlLang',
  xmlns: 'xmlns',
  'xml:space': 'xmlSpace',
  xmlnsxlink: 'xmlnsXlink',
  'xmlns:xlink': 'xmlnsXlink',
  xmlspace: 'xmlSpace',
  y1: 'y1',
  y2: 'y2',
  y: 'y',
  ychannelselector: 'yChannelSelector',
  z: 'z',
  zoomandpan: 'zoomAndPan'
};

var validateProperty$1 = function () {};

{
  var warnedProperties$1 = {};
  var _hasOwnProperty = Object.prototype.hasOwnProperty;
  var EVENT_NAME_REGEX = /^on./;
  var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
  var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
  var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');

  validateProperty$1 = function (tagName, name, value, canUseEventSystem) {
    if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
      return true;
    }

    var lowerCasedName = name.toLowerCase();

    if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
      error('React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');

      warnedProperties$1[name] = true;
      return true;
    } // We can't rely on the event system being injected on the server.


    if (canUseEventSystem) {
      if (registrationNameModules.hasOwnProperty(name)) {
        return true;
      }

      var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;

      if (registrationName != null) {
        error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);

        warnedProperties$1[name] = true;
        return true;
      }

      if (EVENT_NAME_REGEX.test(name)) {
        error('Unknown event handler property `%s`. It will be ignored.', name);

        warnedProperties$1[name] = true;
        return true;
      }
    } else if (EVENT_NAME_REGEX.test(name)) {
      // If no event plugins have been injected, we are in a server environment.
      // So we can't tell if the event name is correct for sure, but we can filter
      // out known bad ones like `onclick`. We can't suggest a specific replacement though.
      if (INVALID_EVENT_NAME_REGEX.test(name)) {
        error('Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.', name);
      }

      warnedProperties$1[name] = true;
      return true;
    } // Let the ARIA attribute hook validate ARIA attributes


    if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
      return true;
    }

    if (lowerCasedName === 'innerhtml') {
      error('Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');

      warnedProperties$1[name] = true;
      return true;
    }

    if (lowerCasedName === 'aria') {
      error('The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');

      warnedProperties$1[name] = true;
      return true;
    }

    if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
      error('Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.', typeof value);

      warnedProperties$1[name] = true;
      return true;
    }

    if (typeof value === 'number' && isNaN(value)) {
      error('Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.', name);

      warnedProperties$1[name] = true;
      return true;
    }

    var propertyInfo = getPropertyInfo(name);
    var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.

    if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
      var standardName = possibleStandardNames[lowerCasedName];

      if (standardName !== name) {
        error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);

        warnedProperties$1[name] = true;
        return true;
      }
    } else if (!isReserved && name !== lowerCasedName) {
      // Unknown attributes should have lowercase casing since that's how they
      // will be cased anyway with server rendering.
      error('React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.', name, lowerCasedName);

      warnedProperties$1[name] = true;
      return true;
    }

    if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
      if (value) {
        error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.', value, name, name, value, name);
      } else {
        error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
      }

      warnedProperties$1[name] = true;
      return true;
    } // Now that we've validated casing, do not validate
    // data types for reserved props


    if (isReserved) {
      return true;
    } // Warn when a known attribute is a bad type


    if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
      warnedProperties$1[name] = true;
      return false;
    } // Warn when passing the strings 'false' or 'true' into a boolean prop


    if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
      error('Received the string `%s` for the boolean attribute `%s`. ' + '%s ' + 'Did you mean %s={%s}?', value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);

      warnedProperties$1[name] = true;
      return true;
    }

    return true;
  };
}

var warnUnknownProperties = function (type, props, canUseEventSystem) {
  {
    var unknownProps = [];

    for (var key in props) {
      var isValid = validateProperty$1(type, key, props[key], canUseEventSystem);

      if (!isValid) {
        unknownProps.push(key);
      }
    }

    var unknownPropString = unknownProps.map(function (prop) {
      return '`' + prop + '`';
    }).join(', ');

    if (unknownProps.length === 1) {
      error('Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://fb.me/react-attribute-behavior', unknownPropString, type);
    } else if (unknownProps.length > 1) {
      error('Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://fb.me/react-attribute-behavior', unknownPropString, type);
    }
  }
};

function validateProperties$2(type, props, canUseEventSystem) {
  if (isCustomComponent(type, props)) {
    return;
  }

  warnUnknownProperties(type, props, canUseEventSystem);
}

var toArray = React$1.Children.toArray; // This is only used in DEV.
// Each entry is `this.stack` from a currently executing renderer instance.
// (There may be more than one because ReactDOMServer is reentrant).
// Each stack is an array of frames which may contain nested stacks of elements.

var currentDebugStacks = [];
var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
var ReactDebugCurrentFrame$4;
var prevGetCurrentStackImpl = null;

var getCurrentServerStackImpl = function () {
  return '';
};

var describeStackFrame = function (element) {
  return '';
};

var validatePropertiesInDevelopment = function (type, props) {};

var pushCurrentDebugStack = function (stack) {};

var pushElementToDebugStack = function (element) {};

var popCurrentDebugStack = function () {};

var hasWarnedAboutUsingContextAsConsumer = false;

{
  ReactDebugCurrentFrame$4 = ReactSharedInternals.ReactDebugCurrentFrame;

  validatePropertiesInDevelopment = function (type, props) {
    validateProperties(type, props);
    validateProperties$1(type, props);
    validateProperties$2(type, props,
    /* canUseEventSystem */
    false);
  };

  describeStackFrame = function (element) {
    var source = element._source;
    var type = element.type;
    var name = getComponentName(type);
    var ownerName = null;
    return describeComponentFrame(name, source, ownerName);
  };

  pushCurrentDebugStack = function (stack) {
    currentDebugStacks.push(stack);

    if (currentDebugStacks.length === 1) {
      // We are entering a server renderer.
      // Remember the previous (e.g. client) global stack implementation.
      prevGetCurrentStackImpl = ReactDebugCurrentFrame$4.getCurrentStack;
      ReactDebugCurrentFrame$4.getCurrentStack = getCurrentServerStackImpl;
    }
  };

  pushElementToDebugStack = function (element) {
    // For the innermost executing ReactDOMServer call,
    var stack = currentDebugStacks[currentDebugStacks.length - 1]; // Take the innermost executing frame (e.g. <Foo>),

    var frame = stack[stack.length - 1]; // and record that it has one more element associated with it.

    frame.debugElementStack.push(element); // We only need this because we tail-optimize single-element
    // children and directly handle them in an inner loop instead of
    // creating separate frames for them.
  };

  popCurrentDebugStack = function () {
    currentDebugStacks.pop();

    if (currentDebugStacks.length === 0) {
      // We are exiting the server renderer.
      // Restore the previous (e.g. client) global stack implementation.
      ReactDebugCurrentFrame$4.getCurrentStack = prevGetCurrentStackImpl;
      prevGetCurrentStackImpl = null;
    }
  };

  getCurrentServerStackImpl = function () {
    if (currentDebugStacks.length === 0) {
      // Nothing is currently rendering.
      return '';
    } // ReactDOMServer is reentrant so there may be multiple calls at the same time.
    // Take the frames from the innermost call which is the last in the array.


    var frames = currentDebugStacks[currentDebugStacks.length - 1];
    var stack = ''; // Go through every frame in the stack from the innermost one.

    for (var i = frames.length - 1; i >= 0; i--) {
      var frame = frames[i]; // Every frame might have more than one debug element stack entry associated with it.
      // This is because single-child nesting doesn't create materialized frames.
      // Instead it would push them through `pushElementToDebugStack()`.

      var debugElementStack = frame.debugElementStack;

      for (var ii = debugElementStack.length - 1; ii >= 0; ii--) {
        stack += describeStackFrame(debugElementStack[ii]);
      }
    }

    return stack;
  };
}

var didWarnDefaultInputValue = false;
var didWarnDefaultChecked = false;
var didWarnDefaultSelectValue = false;
var didWarnDefaultTextareaValue = false;
var didWarnInvalidOptionChildren = false;
var didWarnAboutNoopUpdateForComponent = {};
var didWarnAboutBadClass = {};
var didWarnAboutModulePatternComponent = {};
var didWarnAboutDeprecatedWillMount = {};
var didWarnAboutUndefinedDerivedState = {};
var didWarnAboutUninitializedState = {};
var valuePropNames = ['value', 'defaultValue'];
var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
}; // We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset

var validatedTagCache = {};

function validateDangerousTag(tag) {
  if (!validatedTagCache.hasOwnProperty(tag)) {
    if (!VALID_TAG_REGEX.test(tag)) {
      {
        throw Error( "Invalid tag: " + tag );
      }
    }

    validatedTagCache[tag] = true;
  }
}

var styleNameCache = {};

var processStyleName = function (styleName) {
  if (styleNameCache.hasOwnProperty(styleName)) {
    return styleNameCache[styleName];
  }

  var result = hyphenateStyleName(styleName);
  styleNameCache[styleName] = result;
  return result;
};

function createMarkupForStyles(styles) {
  var serialized = '';
  var delimiter = '';

  for (var styleName in styles) {
    if (!styles.hasOwnProperty(styleName)) {
      continue;
    }

    var isCustomProperty = styleName.indexOf('--') === 0;
    var styleValue = styles[styleName];

    {
      if (!isCustomProperty) {
        warnValidStyle$1(styleName, styleValue);
      }
    }

    if (styleValue != null) {
      serialized += delimiter + (isCustomProperty ? styleName : processStyleName(styleName)) + ':';
      serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
      delimiter = ';';
    }
  }

  return serialized || null;
}

function warnNoop(publicInstance, callerName) {
  {
    var _constructor = publicInstance.constructor;
    var componentName = _constructor && getComponentName(_constructor) || 'ReactClass';
    var warningKey = componentName + '.' + callerName;

    if (didWarnAboutNoopUpdateForComponent[warningKey]) {
      return;
    }

    error('%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op.\n\nPlease check the code for the %s component.', callerName, callerName, componentName);

    didWarnAboutNoopUpdateForComponent[warningKey] = true;
  }
}

function shouldConstruct(Component) {
  return Component.prototype && Component.prototype.isReactComponent;
}

function getNonChildrenInnerMarkup(props) {
  var innerHTML = props.dangerouslySetInnerHTML;

  if (innerHTML != null) {
    if (innerHTML.__html != null) {
      return innerHTML.__html;
    }
  } else {
    var content = props.children;

    if (typeof content === 'string' || typeof content === 'number') {
      return escapeTextForBrowser(content);
    }
  }

  return null;
}

function flattenTopLevelChildren(children) {
  if (!React$1.isValidElement(children)) {
    return toArray(children);
  }

  var element = children;

  if (element.type !== REACT_FRAGMENT_TYPE) {
    return [element];
  }

  var fragmentChildren = element.props.children;

  if (!React$1.isValidElement(fragmentChildren)) {
    return toArray(fragmentChildren);
  }

  var fragmentChildElement = fragmentChildren;
  return [fragmentChildElement];
}

function flattenOptionChildren(children) {
  if (children === undefined || children === null) {
    return children;
  }

  var content = ''; // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.

  React$1.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }

    content += child;

    {
      if (!didWarnInvalidOptionChildren && typeof child !== 'string' && typeof child !== 'number') {
        didWarnInvalidOptionChildren = true;

        error('Only strings and numbers are supported as <option> children.');
      }
    }
  });
  return content;
}

var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
var STYLE = 'style';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null,
  suppressHydrationWarning: null
};

function createOpenTagMarkup(tagVerbatim, tagLowercase, props, namespace, makeStaticMarkup, isRootElement) {
  var ret = '<' + tagVerbatim;

  for (var propKey in props) {
    if (!hasOwnProperty$2.call(props, propKey)) {
      continue;
    }

    var propValue = props[propKey];

    if (propValue == null) {
      continue;
    }

    if (propKey === STYLE) {
      propValue = createMarkupForStyles(propValue);
    }

    var markup = null;

    if (isCustomComponent(tagLowercase, props)) {
      if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
        markup = createMarkupForCustomAttribute(propKey, propValue);
      }
    } else {
      markup = createMarkupForProperty(propKey, propValue);
    }

    if (markup) {
      ret += ' ' + markup;
    }
  } // For static pages, no need to put React ID and checksum. Saves lots of
  // bytes.


  if (makeStaticMarkup) {
    return ret;
  }

  if (isRootElement) {
    ret += ' ' + createMarkupForRoot();
  }

  return ret;
}

function validateRenderResult(child, type) {
  if (child === undefined) {
    {
      {
        throw Error( (getComponentName(type) || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null." );
      }
    }
  }
}

function resolve(child, context, threadID) {
  while (React$1.isValidElement(child)) {
    // Safe because we just checked it's an element.
    var element = child;
    var Component = element.type;

    {
      pushElementToDebugStack(element);
    }

    if (typeof Component !== 'function') {
      break;
    }

    processChild(element, Component);
  } // Extra closure so queue and replace can be captured properly


  function processChild(element, Component) {
    var isClass = shouldConstruct(Component);
    var publicContext = processContext(Component, context, threadID, isClass);
    var queue = [];
    var replace = false;
    var updater = {
      isMounted: function (publicInstance) {
        return false;
      },
      enqueueForceUpdate: function (publicInstance) {
        if (queue === null) {
          warnNoop(publicInstance, 'forceUpdate');
          return null;
        }
      },
      enqueueReplaceState: function (publicInstance, completeState) {
        replace = true;
        queue = [completeState];
      },
      enqueueSetState: function (publicInstance, currentPartialState) {
        if (queue === null) {
          warnNoop(publicInstance, 'setState');
          return null;
        }

        queue.push(currentPartialState);
      }
    };
    var inst;

    if (isClass) {
      inst = new Component(element.props, publicContext, updater);

      if (typeof Component.getDerivedStateFromProps === 'function') {
        {
          if (inst.state === null || inst.state === undefined) {
            var componentName = getComponentName(Component) || 'Unknown';

            if (!didWarnAboutUninitializedState[componentName]) {
              error('`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, inst.state === null ? 'null' : 'undefined', componentName);

              didWarnAboutUninitializedState[componentName] = true;
            }
          }
        }

        var partialState = Component.getDerivedStateFromProps.call(null, element.props, inst.state);

        {
          if (partialState === undefined) {
            var _componentName = getComponentName(Component) || 'Unknown';

            if (!didWarnAboutUndefinedDerivedState[_componentName]) {
              error('%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', _componentName);

              didWarnAboutUndefinedDerivedState[_componentName] = true;
            }
          }
        }

        if (partialState != null) {
          inst.state = _assign({}, inst.state, partialState);
        }
      }
    } else {
      {
        if (Component.prototype && typeof Component.prototype.render === 'function') {
          var _componentName2 = getComponentName(Component) || 'Unknown';

          if (!didWarnAboutBadClass[_componentName2]) {
            error("The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', _componentName2, _componentName2);

            didWarnAboutBadClass[_componentName2] = true;
          }
        }
      }

      var componentIdentity = {};
      prepareToUseHooks(componentIdentity);
      inst = Component(element.props, publicContext, updater);
      inst = finishHooks(Component, element.props, inst, publicContext);

      if (inst == null || inst.render == null) {
        child = inst;
        validateRenderResult(child, Component);
        return;
      }

      {
        var _componentName3 = getComponentName(Component) || 'Unknown';

        if (!didWarnAboutModulePatternComponent[_componentName3]) {
          error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName3, _componentName3, _componentName3);

          didWarnAboutModulePatternComponent[_componentName3] = true;
        }
      }
    }

    inst.props = element.props;
    inst.context = publicContext;
    inst.updater = updater;
    var initialState = inst.state;

    if (initialState === undefined) {
      inst.state = initialState = null;
    }

    if (typeof inst.UNSAFE_componentWillMount === 'function' || typeof inst.componentWillMount === 'function') {
      if (typeof inst.componentWillMount === 'function') {
        {
          if ( inst.componentWillMount.__suppressDeprecationWarning !== true) {
            var _componentName4 = getComponentName(Component) || 'Unknown';

            if (!didWarnAboutDeprecatedWillMount[_componentName4]) {
              warn( // keep this warning in sync with ReactStrictModeWarning.js
              'componentWillMount has been renamed, and is not recommended for use. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move code from componentWillMount to componentDidMount (preferred in most cases) ' + 'or the constructor.\n' + '\nPlease update the following components: %s', _componentName4);

              didWarnAboutDeprecatedWillMount[_componentName4] = true;
            }
          }
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for any component with the new gDSFP.


        if (typeof Component.getDerivedStateFromProps !== 'function') {
          inst.componentWillMount();
        }
      }

      if (typeof inst.UNSAFE_componentWillMount === 'function' && typeof Component.getDerivedStateFromProps !== 'function') {
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for any component with the new gDSFP.
        inst.UNSAFE_componentWillMount();
      }

      if (queue.length) {
        var oldQueue = queue;
        var oldReplace = replace;
        queue = null;
        replace = false;

        if (oldReplace && oldQueue.length === 1) {
          inst.state = oldQueue[0];
        } else {
          var nextState = oldReplace ? oldQueue[0] : inst.state;
          var dontMutate = true;

          for (var i = oldReplace ? 1 : 0; i < oldQueue.length; i++) {
            var partial = oldQueue[i];

            var _partialState = typeof partial === 'function' ? partial.call(inst, nextState, element.props, publicContext) : partial;

            if (_partialState != null) {
              if (dontMutate) {
                dontMutate = false;
                nextState = _assign({}, nextState, _partialState);
              } else {
                _assign(nextState, _partialState);
              }
            }
          }

          inst.state = nextState;
        }
      } else {
        queue = null;
      }
    }

    child = inst.render();

    {
      if (child === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        child = null;
      }
    }

    validateRenderResult(child, Component);
    var childContext;

    {
      if (typeof inst.getChildContext === 'function') {
        var _childContextTypes = Component.childContextTypes;

        if (typeof _childContextTypes === 'object') {
          childContext = inst.getChildContext();

          for (var contextKey in childContext) {
            if (!(contextKey in _childContextTypes)) {
              {
                throw Error( (getComponentName(Component) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes." );
              }
            }
          }
        } else {
          {
            error('%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', getComponentName(Component) || 'Unknown');
          }
        }
      }

      if (childContext) {
        context = _assign({}, context, childContext);
      }
    }
  }

  return {
    child: child,
    context: context
  };
}

var ReactDOMServerRenderer =
/*#__PURE__*/
function () {
  // TODO: type this more strictly:
  // DEV-only
  function ReactDOMServerRenderer(children, makeStaticMarkup) {
    var flatChildren = flattenTopLevelChildren(children);
    var topFrame = {
      type: null,
      // Assume all trees start in the HTML namespace (not totally true, but
      // this is what we did historically)
      domNamespace: Namespaces.html,
      children: flatChildren,
      childIndex: 0,
      context: emptyObject,
      footer: ''
    };

    {
      topFrame.debugElementStack = [];
    }

    this.threadID = allocThreadID();
    this.stack = [topFrame];
    this.exhausted = false;
    this.currentSelectValue = null;
    this.previousWasTextNode = false;
    this.makeStaticMarkup = makeStaticMarkup;
    this.suspenseDepth = 0; // Context (new API)

    this.contextIndex = -1;
    this.contextStack = [];
    this.contextValueStack = [];

    {
      this.contextProviderStack = [];
    }
  }

  var _proto = ReactDOMServerRenderer.prototype;

  _proto.destroy = function destroy() {
    if (!this.exhausted) {
      this.exhausted = true;
      this.clearProviders();
      freeThreadID(this.threadID);
    }
  }
  /**
   * Note: We use just two stacks regardless of how many context providers you have.
   * Providers are always popped in the reverse order to how they were pushed
   * so we always know on the way down which provider you'll encounter next on the way up.
   * On the way down, we push the current provider, and its context value *before*
   * we mutated it, onto the stacks. Therefore, on the way up, we always know which
   * provider needs to be "restored" to which value.
   * https://github.com/facebook/react/pull/12985#issuecomment-396301248
   */
  ;

  _proto.pushProvider = function pushProvider(provider) {
    var index = ++this.contextIndex;
    var context = provider.type._context;
    var threadID = this.threadID;
    validateContextBounds(context, threadID);
    var previousValue = context[threadID]; // Remember which value to restore this context to on our way up.

    this.contextStack[index] = context;
    this.contextValueStack[index] = previousValue;

    {
      // Only used for push/pop mismatch warnings.
      this.contextProviderStack[index] = provider;
    } // Mutate the current value.


    context[threadID] = provider.props.value;
  };

  _proto.popProvider = function popProvider(provider) {
    var index = this.contextIndex;

    {
      if (index < 0 || provider !== this.contextProviderStack[index]) {
        error('Unexpected pop.');
      }
    }

    var context = this.contextStack[index];
    var previousValue = this.contextValueStack[index]; // "Hide" these null assignments from Flow by using `any`
    // because conceptually they are deletions--as long as we
    // promise to never access values beyond `this.contextIndex`.

    this.contextStack[index] = null;
    this.contextValueStack[index] = null;

    {
      this.contextProviderStack[index] = null;
    }

    this.contextIndex--; // Restore to the previous value we stored as we were walking down.
    // We've already verified that this context has been expanded to accommodate
    // this thread id, so we don't need to do it again.

    context[this.threadID] = previousValue;
  };

  _proto.clearProviders = function clearProviders() {
    // Restore any remaining providers on the stack to previous values
    for (var index = this.contextIndex; index >= 0; index--) {
      var context = this.contextStack[index];
      var previousValue = this.contextValueStack[index];
      context[this.threadID] = previousValue;
    }
  };

  _proto.read = function read(bytes) {
    if (this.exhausted) {
      return null;
    }

    var prevThreadID = currentThreadID;
    setCurrentThreadID(this.threadID);
    var prevDispatcher = ReactCurrentDispatcher.current;
    ReactCurrentDispatcher.current = Dispatcher;

    try {
      // Markup generated within <Suspense> ends up buffered until we know
      // nothing in that boundary suspended
      var out = [''];
      var suspended = false;

      while (out[0].length < bytes) {
        if (this.stack.length === 0) {
          this.exhausted = true;
          freeThreadID(this.threadID);
          break;
        }

        var frame = this.stack[this.stack.length - 1];

        if (suspended || frame.childIndex >= frame.children.length) {
          var footer = frame.footer;

          if (footer !== '') {
            this.previousWasTextNode = false;
          }

          this.stack.pop();

          if (frame.type === 'select') {
            this.currentSelectValue = null;
          } else if (frame.type != null && frame.type.type != null && frame.type.type.$$typeof === REACT_PROVIDER_TYPE) {
            var provider = frame.type;
            this.popProvider(provider);
          } else if (frame.type === REACT_SUSPENSE_TYPE) {
            this.suspenseDepth--;
            var buffered = out.pop();

            if (suspended) {
              suspended = false; // If rendering was suspended at this boundary, render the fallbackFrame

              var fallbackFrame = frame.fallbackFrame;

              if (!fallbackFrame) {
                {
                  throw Error(true ? "ReactDOMServer did not find an internal fallback frame for Suspense. This is a bug in React. Please file an issue." : formatProdErrorMessage(303));
                }
              }

              this.stack.push(fallbackFrame);
              out[this.suspenseDepth] += '<!--$!-->'; // Skip flushing output since we're switching to the fallback

              continue;
            } else {
              out[this.suspenseDepth] += buffered;
            }
          } // Flush output


          out[this.suspenseDepth] += footer;
          continue;
        }

        var child = frame.children[frame.childIndex++];
        var outBuffer = '';

        if (true) {
          pushCurrentDebugStack(this.stack); // We're starting work on this frame, so reset its inner stack.

          frame.debugElementStack.length = 0;
        }

        try {
          outBuffer += this.render(child, frame.context, frame.domNamespace);
        } catch (err) {
          if (err != null && typeof err.then === 'function') {
            if (enableSuspenseServerRenderer) ; else {
              if (!false) {
                {
                  throw Error(true ? "ReactDOMServer does not yet support Suspense." : formatProdErrorMessage(294));
                }
              }
            }
          } else {
            throw err;
          }
        } finally {
          if (true) {
            popCurrentDebugStack();
          }
        }

        if (out.length <= this.suspenseDepth) {
          out.push('');
        }

        out[this.suspenseDepth] += outBuffer;
      }

      return out[0];
    } finally {
      ReactCurrentDispatcher.current = prevDispatcher;
      setCurrentThreadID(prevThreadID);
    }
  };

  _proto.render = function render(child, context, parentNamespace) {
    if (typeof child === 'string' || typeof child === 'number') {
      var text = '' + child;

      if (text === '') {
        return '';
      }

      if (this.makeStaticMarkup) {
        return escapeTextForBrowser(text);
      }

      if (this.previousWasTextNode) {
        return '<!-- -->' + escapeTextForBrowser(text);
      }

      this.previousWasTextNode = true;
      return escapeTextForBrowser(text);
    } else {
      var nextChild;

      var _resolve = resolve(child, context, this.threadID);

      nextChild = _resolve.child;
      context = _resolve.context;

      if (nextChild === null || nextChild === false) {
        return '';
      } else if (!React$1.isValidElement(nextChild)) {
        if (nextChild != null && nextChild.$$typeof != null) {
          // Catch unexpected special types early.
          var $$typeof = nextChild.$$typeof;

          if (!($$typeof !== REACT_PORTAL_TYPE)) {
            {
              throw Error( "Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render." );
            }
          } // Catch-all to prevent an infinite loop if React.Children.toArray() supports some new type.


          {
            {
              throw Error( "Unknown element-like object type: " + $$typeof.toString() + ". This is likely a bug in React. Please file an issue." );
            }
          }
        }

        var nextChildren = toArray(nextChild);
        var frame = {
          type: null,
          domNamespace: parentNamespace,
          children: nextChildren,
          childIndex: 0,
          context: context,
          footer: ''
        };

        {
          frame.debugElementStack = [];
        }

        this.stack.push(frame);
        return '';
      } // Safe because we just checked it's an element.


      var nextElement = nextChild;
      var elementType = nextElement.type;

      if (typeof elementType === 'string') {
        return this.renderDOM(nextElement, context, parentNamespace);
      }

      switch (elementType) {
        case REACT_STRICT_MODE_TYPE:
        case REACT_CONCURRENT_MODE_TYPE:
        case REACT_PROFILER_TYPE:
        case REACT_SUSPENSE_LIST_TYPE:
        case REACT_FRAGMENT_TYPE:
          {
            var _nextChildren = toArray(nextChild.props.children);

            var _frame = {
              type: null,
              domNamespace: parentNamespace,
              children: _nextChildren,
              childIndex: 0,
              context: context,
              footer: ''
            };

            {
              _frame.debugElementStack = [];
            }

            this.stack.push(_frame);
            return '';
          }

        case REACT_SUSPENSE_TYPE:
          {
            {
              {
                {
                  throw Error( "ReactDOMServer does not yet support Suspense." );
                }
              }
            }
          }
      }

      if (typeof elementType === 'object' && elementType !== null) {
        switch (elementType.$$typeof) {
          case REACT_FORWARD_REF_TYPE:
            {
              var element = nextChild;

              var _nextChildren4;

              var componentIdentity = {};
              prepareToUseHooks(componentIdentity);
              _nextChildren4 = elementType.render(element.props, element.ref);
              _nextChildren4 = finishHooks(elementType.render, element.props, _nextChildren4, element.ref);
              _nextChildren4 = toArray(_nextChildren4);
              var _frame4 = {
                type: null,
                domNamespace: parentNamespace,
                children: _nextChildren4,
                childIndex: 0,
                context: context,
                footer: ''
              };

              {
                _frame4.debugElementStack = [];
              }

              this.stack.push(_frame4);
              return '';
            }

          case REACT_MEMO_TYPE:
            {
              var _element = nextChild;
              var _nextChildren5 = [React$1.createElement(elementType.type, _assign({
                ref: _element.ref
              }, _element.props))];
              var _frame5 = {
                type: null,
                domNamespace: parentNamespace,
                children: _nextChildren5,
                childIndex: 0,
                context: context,
                footer: ''
              };

              {
                _frame5.debugElementStack = [];
              }

              this.stack.push(_frame5);
              return '';
            }

          case REACT_PROVIDER_TYPE:
            {
              var provider = nextChild;
              var nextProps = provider.props;

              var _nextChildren6 = toArray(nextProps.children);

              var _frame6 = {
                type: provider,
                domNamespace: parentNamespace,
                children: _nextChildren6,
                childIndex: 0,
                context: context,
                footer: ''
              };

              {
                _frame6.debugElementStack = [];
              }

              this.pushProvider(provider);
              this.stack.push(_frame6);
              return '';
            }

          case REACT_CONTEXT_TYPE:
            {
              var reactContext = nextChild.type; // The logic below for Context differs depending on PROD or DEV mode. In
              // DEV mode, we create a separate object for Context.Consumer that acts
              // like a proxy to Context. This proxy object adds unnecessary code in PROD
              // so we use the old behaviour (Context.Consumer references Context) to
              // reduce size and overhead. The separate object references context via
              // a property called "_context", which also gives us the ability to check
              // in DEV mode if this property exists or not and warn if it does not.

              {
                if (reactContext._context === undefined) {
                  // This may be because it's a Context (rather than a Consumer).
                  // Or it may be because it's older React where they're the same thing.
                  // We only want to warn if we're sure it's a new React.
                  if (reactContext !== reactContext.Consumer) {
                    if (!hasWarnedAboutUsingContextAsConsumer) {
                      hasWarnedAboutUsingContextAsConsumer = true;

                      error('Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
                    }
                  }
                } else {
                  reactContext = reactContext._context;
                }
              }

              var _nextProps = nextChild.props;
              var threadID = this.threadID;
              validateContextBounds(reactContext, threadID);
              var nextValue = reactContext[threadID];

              var _nextChildren7 = toArray(_nextProps.children(nextValue));

              var _frame7 = {
                type: nextChild,
                domNamespace: parentNamespace,
                children: _nextChildren7,
                childIndex: 0,
                context: context,
                footer: ''
              };

              {
                _frame7.debugElementStack = [];
              }

              this.stack.push(_frame7);
              return '';
            }
          // eslint-disable-next-line-no-fallthrough

          case REACT_FUNDAMENTAL_TYPE:
            {

              {
                {
                  throw Error( "ReactDOMServer does not yet support the fundamental API." );
                }
              }
            }
          // eslint-disable-next-line-no-fallthrough

          case REACT_LAZY_TYPE:
            {
              var _element2 = nextChild;
              var lazyComponent = nextChild.type; // Attempt to initialize lazy component regardless of whether the
              // suspense server-side renderer is enabled so synchronously
              // resolved constructors are supported.

              initializeLazyComponentType(lazyComponent);

              switch (lazyComponent._status) {
                case Resolved:
                  {
                    var _nextChildren9 = [React$1.createElement(lazyComponent._result, _assign({
                      ref: _element2.ref
                    }, _element2.props))];
                    var _frame9 = {
                      type: null,
                      domNamespace: parentNamespace,
                      children: _nextChildren9,
                      childIndex: 0,
                      context: context,
                      footer: ''
                    };

                    {
                      _frame9.debugElementStack = [];
                    }

                    this.stack.push(_frame9);
                    return '';
                  }

                case Rejected:
                  throw lazyComponent._result;

                case Pending:
                default:
                  {
                    {
                      throw Error( "ReactDOMServer does not yet support lazy-loaded components." );
                    }
                  }

              }
            }
          // eslint-disable-next-line-no-fallthrough

          case REACT_SCOPE_TYPE:
            {

              {
                {
                  throw Error( "ReactDOMServer does not yet support scope components." );
                }
              }
            }
        }
      }

      var info = '';

      {
        var owner = nextElement._owner;

        if (elementType === undefined || typeof elementType === 'object' && elementType !== null && Object.keys(elementType).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
        }

        var ownerName = owner ? getComponentName(owner) : null;

        if (ownerName) {
          info += '\n\nCheck the render method of `' + ownerName + '`.';
        }
      }

      {
        {
          throw Error( "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (elementType == null ? elementType : typeof elementType) + "." + info );
        }
      }
    }
  };

  _proto.renderDOM = function renderDOM(element, context, parentNamespace) {
    var tag = element.type.toLowerCase();
    var namespace = parentNamespace;

    if (parentNamespace === Namespaces.html) {
      namespace = getIntrinsicNamespace(tag);
    }

    {
      if (namespace === Namespaces.html) {
        // Should this check be gated by parent namespace? Not sure we want to
        // allow <SVG> or <mATH>.
        if (tag !== element.type) {
          error('<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', element.type);
        }
      }
    }

    validateDangerousTag(tag);
    var props = element.props;

    if (tag === 'input') {
      {
        ReactControlledValuePropTypes.checkPropTypes('input', props);

        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnDefaultChecked) {
          error('%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', 'A component', props.type);

          didWarnDefaultChecked = true;
        }

        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultInputValue) {
          error('%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', 'A component', props.type);

          didWarnDefaultInputValue = true;
        }
      }

      props = _assign({
        type: undefined
      }, props, {
        defaultChecked: undefined,
        defaultValue: undefined,
        value: props.value != null ? props.value : props.defaultValue,
        checked: props.checked != null ? props.checked : props.defaultChecked
      });
    } else if (tag === 'textarea') {
      {
        ReactControlledValuePropTypes.checkPropTypes('textarea', props);

        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultTextareaValue) {
          error('Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components');

          didWarnDefaultTextareaValue = true;
        }
      }

      var initialValue = props.value;

      if (initialValue == null) {
        var defaultValue = props.defaultValue; // TODO (yungsters): Remove support for children content in <textarea>.

        var textareaChildren = props.children;

        if (textareaChildren != null) {
          {
            error('Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
          }

          if (!(defaultValue == null)) {
            {
              throw Error( "If you supply `defaultValue` on a <textarea>, do not pass children." );
            }
          }

          if (Array.isArray(textareaChildren)) {
            if (!(textareaChildren.length <= 1)) {
              {
                throw Error( "<textarea> can only have at most one child." );
              }
            }

            textareaChildren = textareaChildren[0];
          }

          defaultValue = '' + textareaChildren;
        }

        if (defaultValue == null) {
          defaultValue = '';
        }

        initialValue = defaultValue;
      }

      props = _assign({}, props, {
        value: undefined,
        children: '' + initialValue
      });
    } else if (tag === 'select') {
      {
        ReactControlledValuePropTypes.checkPropTypes('select', props);

        for (var i = 0; i < valuePropNames.length; i++) {
          var propName = valuePropNames[i];

          if (props[propName] == null) {
            continue;
          }

          var isArray = Array.isArray(props[propName]);

          if (props.multiple && !isArray) {
            error('The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.', propName);
          } else if (!props.multiple && isArray) {
            error('The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.', propName);
          }
        }

        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultSelectValue) {
          error('Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components');

          didWarnDefaultSelectValue = true;
        }
      }

      this.currentSelectValue = props.value != null ? props.value : props.defaultValue;
      props = _assign({}, props, {
        value: undefined
      });
    } else if (tag === 'option') {
      var selected = null;
      var selectValue = this.currentSelectValue;
      var optionChildren = flattenOptionChildren(props.children);

      if (selectValue != null) {
        var value;

        if (props.value != null) {
          value = props.value + '';
        } else {
          value = optionChildren;
        }

        selected = false;

        if (Array.isArray(selectValue)) {
          // multiple
          for (var j = 0; j < selectValue.length; j++) {
            if ('' + selectValue[j] === value) {
              selected = true;
              break;
            }
          }
        } else {
          selected = '' + selectValue === value;
        }

        props = _assign({
          selected: undefined,
          children: undefined
        }, props, {
          selected: selected,
          children: optionChildren
        });
      }
    }

    {
      validatePropertiesInDevelopment(tag, props);
    }

    assertValidProps(tag, props);
    var out = createOpenTagMarkup(element.type, tag, props, namespace, this.makeStaticMarkup, this.stack.length === 1);
    var footer = '';

    if (omittedCloseTags.hasOwnProperty(tag)) {
      out += '/>';
    } else {
      out += '>';
      footer = '</' + element.type + '>';
    }

    var children;
    var innerMarkup = getNonChildrenInnerMarkup(props);

    if (innerMarkup != null) {
      children = [];

      if (newlineEatingTags.hasOwnProperty(tag) && innerMarkup.charAt(0) === '\n') {
        // text/html ignores the first character in these tags if it's a newline
        // Prefer to break application/xml over text/html (for now) by adding
        // a newline specifically to get eaten by the parser. (Alternately for
        // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
        // \r is normalized out by HTMLTextAreaElement#value.)
        // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
        // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
        // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
        // See: Parsing of "textarea" "listing" and "pre" elements
        //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
        out += '\n';
      }

      out += innerMarkup;
    } else {
      children = toArray(props.children);
    }

    var frame = {
      domNamespace: getChildNamespace(parentNamespace, element.type),
      type: tag,
      children: children,
      childIndex: 0,
      context: context,
      footer: footer
    };

    {
      frame.debugElementStack = [];
    }

    this.stack.push(frame);
    this.previousWasTextNode = false;
    return out;
  };

  return ReactDOMServerRenderer;
}();

/**
 * Render a ReactElement to its initial HTML. This should only be used on the
 * server.
 * See https://reactjs.org/docs/react-dom-server.html#rendertostring
 */

function renderToString(element) {
  var renderer = new ReactDOMServerRenderer(element, false);

  try {
    var markup = renderer.read(Infinity);
    return markup;
  } finally {
    renderer.destroy();
  }
}
/**
 * Similar to renderToString, except this doesn't create extra DOM attributes
 * such as data-react-id that React uses internally.
 * See https://reactjs.org/docs/react-dom-server.html#rendertostaticmarkup
 */

function renderToStaticMarkup(element) {
  var renderer = new ReactDOMServerRenderer(element, true);

  try {
    var markup = renderer.read(Infinity);
    return markup;
  } finally {
    renderer.destroy();
  }
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var ReactMarkupReadableStream =
/*#__PURE__*/
function (_Readable) {
  _inheritsLoose(ReactMarkupReadableStream, _Readable);

  function ReactMarkupReadableStream(element, makeStaticMarkup) {
    var _this;

    // Calls the stream.Readable(options) constructor. Consider exposing built-in
    // features like highWaterMark in the future.
    _this = _Readable.call(this, {}) || this;
    _this.partialRenderer = new ReactDOMServerRenderer(element, makeStaticMarkup);
    return _this;
  }

  var _proto = ReactMarkupReadableStream.prototype;

  _proto._destroy = function _destroy(err, callback) {
    this.partialRenderer.destroy();
    callback(err);
  };

  _proto._read = function _read(size) {
    try {
      this.push(this.partialRenderer.read(size));
    } catch (err) {
      this.destroy(err);
    }
  };

  return ReactMarkupReadableStream;
}(stream.Readable);
/**
 * Render a ReactElement to its initial HTML. This should only be used on the
 * server.
 * See https://reactjs.org/docs/react-dom-server.html#rendertonodestream
 */


function renderToNodeStream(element) {
  return new ReactMarkupReadableStream(element, false);
}
/**
 * Similar to renderToNodeStream, except this doesn't create extra DOM attributes
 * such as data-react-id that React uses internally.
 * See https://reactjs.org/docs/react-dom-server.html#rendertostaticnodestream
 */

function renderToStaticNodeStream(element) {
  return new ReactMarkupReadableStream(element, true);
}

var ReactDOMServer = {
  renderToString: renderToString,
  renderToStaticMarkup: renderToStaticMarkup,
  renderToNodeStream: renderToNodeStream,
  renderToStaticNodeStream: renderToStaticNodeStream,
  version: ReactVersion
};

// TODO: decide on the top-level export form.
// This is hacky but makes it work with both Rollup and Jest


var server_node = ReactDOMServer.default || ReactDOMServer;

reactDomServer_node_development.exports = server_node;
  })();
}

if (process.env.NODE_ENV === 'production') {
  server_node.exports = reactDomServer_node_production_min;
} else {
  server_node.exports = reactDomServer_node_development.exports;
}

var server = server_node.exports;

function Banner(props) {
    const { url, mode, link, name, height, width, templateStyle, isDisclaimerNextActive, } = props;
    if (!url) {
        return null;
    }
    const bgClass = mode.type === 'XSLT' ? 'TMPL TMPL_BGCOLOUR_#ffffff' : '';
    const bgStyle = mode.type === 'REACT'
        ? {
            background: '#ffffff',
            padding: `0 24px ${getCorrectSpacing(isDisclaimerNextActive, templateStyle.spacing)}px`,
        }
        : {
            padding: `0 24px ${getCorrectSpacing(isDisclaimerNextActive, templateStyle.spacing)}px`,
        };
    const widthRatio = width !== null ? maxTemplateComponentWidth / width : 0.5;
    const heightCalc = height === null ? '' : widthRatio * height;
    const trackingReference = name && name.toLowerCase().trim() === 'image at top'
        ? 'headerbanner'
        : name && name.toLowerCase().trim() === 'image above signature'
            ? 'middlebanner'
            : name && name.toLowerCase().trim() === 'image below signature'
                ? 'footerbanner'
                : '';
    const style = {
        width: `${templateStyle.kind === 'fixed' ? '100%' : `${maxTemplateComponentWidth}px`}`,
        height: `${heightCalc}px`,
        maxWidth: `${maxTemplateComponentWidth}px`,
        border: '0',
        display: 'block',
    };
    if (props.mode.type === 'XSLT' && link && link.length > 0) {
        return (React.createElement("td", { style: bgStyle, className: `${bgClass} ${isDisclaimerNextActive ? 'disclaimer-bottom' : 'padding-bottom'} ${templateStyle.kind === 'fixed' ? 'alignCenter' : 'alignLeft'}` },
            React.createElement("a", { href: link, "data-tracking": trackingReference, target: '_blank' },
                React.createElement("img", { src: url, width: maxTemplateComponentWidth, className: `noBorder fluid savable`, height: heightCalc, style: { ...style }, alt: '{account/default/orgname}' }))));
    }
    return (React.createElement("td", { style: bgStyle, className: `noBorder ${bgClass} padding-bottom ${templateStyle.kind === 'fixed' ? 'alignCenter' : 'alignLeft'}` },
        React.createElement("img", { src: url, width: `${maxTemplateComponentWidth}`, className: `noBorder fluid savable`, height: heightCalc, style: { ...style }, alt: '{account/default/orgname}' })));
}

function Content$2(props) {
    const { fontSize, lineHeight, fontColour, fontFamily, mode, templateStyle, sampleContent, } = props;
    const styles = {
        padding: `0 24px ${templateStyle.spacing}px`,
        fontSize: `${fontSize}px`,
        lineHeight: `${lineHeight ? `${lineHeight}px` : 'normal'}`,
        color: fontColour,
        fontFamily: getFontHtmlCode(fontFamily),
    };
    const bStyles = {
        padding: `0 24px ${templateStyle.spacing}px`,
    };
    const bgClass = mode.type === 'XSLT' ? 'TMPL TMPL_BGCOLOUR_#ffffff' : '';
    const bgStyle = mode.type === 'REACT' ? { background: '#ffffff' } : undefined;
    switch (mode.type) {
        case 'XSLT': {
            return (React.createElement("td", { id: 'BodyContent', style: { ...bStyles, ...bgStyle }, className: `${bgClass} padding-bottom` }));
        }
        case 'REACT': {
            const phs = {
                height: `18px`,
                margin: `8px 0`,
                background: '#f3f4f5',
            };
            return (React.createElement("td", { style: { ...styles, ...bgStyle }, className: `${bgClass} padding-bottom` }, !sampleContent ? (React.createElement(React.Fragment, null,
                React.createElement("div", { style: { ...phs, marginTop: 0, maxWidth: '200px' } }),
                React.createElement("div", { style: { ...phs, maxWidth: '100%' } }),
                React.createElement("div", { style: { ...phs, maxWidth: '100%' } }))) : (React.createElement("div", { dangerouslySetInnerHTML: { __html: sampleContent } }))));
        }
        default: {
            throw new Error('no mode supplied for content component');
        }
    }
}

function Disclaimer(props) {
    const { alignment, content, fontSize, fontFamily, fontColour } = props.element;
    const { templateStyle } = props;
    const styles = {
        textAlign: alignment,
        fontFamily: getFontHtmlCode(fontFamily),
        fontSize,
        color: fontColour,
        padding: `0 24px ${templateStyle.spacing}px`,
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        backgroundColor: '#ffffff',
    };
    const bgClass = props.mode.type === 'XSLT' ? 'TMPL TMPL_BGCOLOUR_#ffffff' : '';
    return (React.createElement("td", { style: styles, className: `${bgClass} padding-bottom fluid` }, content));
}

// declare const SubscriptionName: string
function Freemium(props) {
    const { mode } = props;
    const hostname = 'https://admin.blackpearlmail.com';
    const styles = {
        textAlign: 'center',
        fontFamily: 'sans-serif',
        fontSize: '14px',
        color: '#888888',
        padding: '0 24px 48px',
    };
    const spanStyle = {
        padding: '0 10px',
        verticalAlign: 'middle',
    };
    const imgStyle = { verticalAlign: 'middle' };
    switch (mode.type) {
        case 'REACT': {
            // @ts-ignore
            {
                return null;
            }
        }
        case 'XSLT': {
            return (React.createElement("td", { style: styles, className: "padding-bottom" },
                React.createElement("img", { style: imgStyle, width: "30", src: `{concat('${hostname}/blackpearl/freemiumimage?tag=1&orgid=', /data/account/@organisationid)}`, alt: "Branding provided by Black Pearl Mail" }),
                React.createElement("span", { style: spanStyle },
                    "Harness the power of stunning emails with",
                    React.createElement("a", { href: `{concat('${hostname}/blackpearl/freemiumlink?tag=1&orgid=', /data/account/@organisationid)}` }, "Black Pearl Mail"))));
        }
        default: {
            return null;
        }
    }
}

function HtmlComment(props) {
    const { children, mode } = props;
    switch (mode.type) {
        case 'XSLT': {
            return React.createElement("div", { className: 'Cerberus_Comment' }, children);
        }
        case 'REACT': {
            return null;
        }
        default: {
            return null;
        }
    }
}

function Logo(props) {
    const { name, url, linkUrl, alignment, backgroundColour, height, width } = props.data;
    const { mode, templateStyle, isDisclaimerNextActive } = props;
    if (url === null) {
        return null;
    }
    const imgStyle = {
        height: height === null ? '' : `${height / 2}px`,
    };
    const bgColour = getBackgroundColour(templateStyle, backgroundColour);
    const bgClass = mode.type === 'XSLT' ? `TMPL TMPL_BGCOLOUR_${bgColour}` : '';
    const bgStyle = mode.type === 'REACT' ? { background: bgColour } : undefined;
    const style = {
        padding: `0 24px ${getCorrectSpacing(isDisclaimerNextActive, templateStyle.spacing)}px`,
        textAlign: alignment.type,
    };
    const trackingReference = name && name.toLowerCase().trim() === 'image at top'
        ? 'headerlogo'
        : name && name.toLowerCase().trim() === 'image above signature'
            ? 'middlelogo'
            : name && name.toLowerCase().trim() === 'image below signature'
                ? 'footerlogo'
                : '';
    if (mode.type === 'XSLT' && linkUrl && linkUrl.length > 0) {
        return (React.createElement("td", { className: `noBorder ${bgClass} ${isDisclaimerNextActive ? 'disclaimer-bottom' : 'padding-bottom'}`, "data-width": '100%', style: { ...style, ...bgStyle, width: '100%' } },
            React.createElement("a", { href: linkUrl, "data-tracking": trackingReference, target: '_blank' },
                React.createElement("img", { src: url, alt: '{account/default/orgname}', width: width === null ? '' : width / 2, height: height === null ? '' : height / 2, style: imgStyle, className: `noBorder savable` }))));
    }
    return (React.createElement("td", { className: `noBorder ${bgClass} padding-bottom`, "data-width": '100%', style: { ...style, ...bgStyle, width: '100%' } },
        React.createElement("img", { src: url, alt: '{account/default/orgname}', height: height === null ? '' : height / 2, width: width === null ? '' : width / 2, style: imgStyle, className: `noBorder savable` })));
}

function FacebookBlockIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#3b5998' : color;
    return (React.createElement("svg", { name: "facebook", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M40.3443 27.3305V37.5152H33V49.9905H40.3536V87H55.4337V49.9905H65.5647C65.5647 49.9905 66.4967 44.0179 66.9627 37.4963H55.4803V28.9775C55.6165 28.1761 56.0141 27.4446 56.6091 26.9004C57.2041 26.3562 57.962 26.0309 58.761 25.977H67V13H55.8158C39.9715 13 40.3443 25.4753 40.3443 27.3305Z", style: { fill: fillColor } })));
}

function GooglePlusBlockIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#DC4E41' : color;
    return (React.createElement("svg", { name: "googleplus", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 491.858 491.858", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("g", null,
            React.createElement("path", { style: { fill: fillColor }, d: "M377.472,224.957H201.319v58.718H308.79c-16.032,51.048-63.714,88.077-120.055,88.077     c-69.492,0-125.823-56.335-125.823-125.824c0-69.492,56.333-125.823,125.823-125.823c34.994,0,66.645,14.289,89.452,37.346     l42.622-46.328c-34.04-33.355-80.65-53.929-132.074-53.929C84.5,57.193,0,141.693,0,245.928s84.5,188.737,188.736,188.737     c91.307,0,171.248-64.844,188.737-150.989v-58.718L377.472,224.957L377.472,224.957z" }),
            React.createElement("polygon", { points: "491.858,224.857 455.827,224.857 455.827,188.826 424.941,188.826 424.941,224.857 388.91,224.857      388.91,255.74 424.941,255.74 424.941,291.772 455.827,291.772 455.827,255.74 491.858,255.74    ", style: { fill: fillColor } }))));
}

function InstagramBlockIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#ff0075' : color;
    return (React.createElement("svg", { name: "instagram", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M50,34.89A15.11,15.11,0,1,0,65.12,50,15.09,15.09,0,0,0,50,34.89Zm0,24.94A9.83,9.83,0,1,1,59.83,50,9.85,9.85,0,0,1,50,59.83ZM69.26,34.27a3.53,3.53,0,1,1-3.52-3.53A3.51,3.51,0,0,1,69.26,34.27Zm10,3.58c-.22-4.73-1.3-8.91-4.76-12.36S66.88,21,62.16,20.73s-19.45-.27-24.32,0C33.13,21,29,22,25.49,25.48S21,33.11,20.73,37.83c-.28,4.87-.28,19.46,0,24.32s1.3,8.91,4.76,12.36S33.12,79,37.84,79.27s19.45.27,24.32,0c4.72-.23,8.91-1.3,12.35-4.76S79,66.88,79.27,62.15s.28-19.44,0-24.3ZM73,67.38A10,10,0,0,1,67.38,73C63.5,74.52,54.29,74.16,50,74.16S36.5,74.51,32.63,73a10,10,0,0,1-5.6-5.6C25.49,63.5,25.84,54.29,25.84,50S25.5,36.49,27,32.62a10,10,0,0,1,5.6-5.6c3.88-1.54,13.09-1.18,17.38-1.18S63.52,25.49,67.38,27A10,10,0,0,1,73,32.62C74.53,36.5,74.17,45.71,74.17,50S74.53,63.51,73,67.38Z", style: { fill: fillColor } })));
}

function LinkedinBlockIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#007AB9' : color;
    return (React.createElement("svg", { name: "linkedin", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M35.78,75.75H25.1V41.37H35.78ZM30.43,36.67a6.21,6.21,0,1,1,6.19-6.24A6.23,6.23,0,0,1,30.43,36.67ZM75.74,75.75H65.09V59c0-4-.09-9.1-5.56-9.1s-6.4,4.33-6.4,8.81v17H42.47V41.37H52.71v4.69h.15A11.19,11.19,0,0,1,63,40.5c10.8,0,12.79,7.12,12.79,16.36V75.75Z", style: { fill: fillColor } })));
}

function PinterestBlockIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#CB2027' : color;
    return (React.createElement("svg", { name: "pinterest", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M51.69,14.93C37.27,14.93,23,24.55,23,40.1,23,50,28.59,55.61,32,55.61c1.39,0,2.19-3.88,2.19-5,0-1.31-3.33-4.09-3.33-9.53,0-11.3,8.6-19.3,19.73-19.3,9.57,0,16.65,5.43,16.65,15.42,0,7.47-3,21.46-12.69,21.46A6.24,6.24,0,0,1,48,52.54c0-5.32,3.71-10.46,3.71-15.94,0-9.3-13.2-7.61-13.2,3.63a16.55,16.55,0,0,0,1.35,7.12C37.94,55.7,34,68.13,34,76.73c0,2.66.38,5.27.63,7.93.48.53.24.47,1,.21,7.09-9.7,6.83-11.59,10-24.28,1.72,3.29,6.19,5.06,9.73,5.06C70.28,65.65,77,51.1,77,38,77,24,64.92,14.93,51.69,14.93Z", style: { fill: fillColor } })));
}

function TiktokBlockIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#000000' : color;
    return (React.createElement("svg", { name: "tiktok", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M71.0383 29.6302C67.3323 27.2414 64.6568 23.4208 63.8228 18.9667C63.6424 18.0039 63.5436 17.0139 63.5436 16H51.7146L51.695 62.8525C51.4963 68.099 47.1275 72.3102 41.7707 72.3102C40.1061 72.3102 38.538 71.8992 37.1583 71.1805C33.9934 69.5342 31.8279 66.2552 31.8279 62.4823C31.8279 57.0632 36.2887 52.6545 41.7707 52.6545C42.7942 52.6545 43.7753 52.8214 44.7047 53.1087V41.1736C43.7431 41.0441 42.7667 40.9635 41.7707 40.9635C29.767 40.9647 20 50.6176 20 62.4823C20 69.7624 23.6807 76.2045 29.2948 80.1C32.8308 82.5535 37.133 84 41.7718 84C53.7766 84 63.5436 74.347 63.5436 62.4823V38.7246C68.1824 42.016 73.8666 43.9553 80 43.9553V32.2643C76.6961 32.2643 73.6185 31.2935 71.0383 29.6302Z", style: { fill: fillColor } })));
}

function TwitterBlockIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#55ACEE' : color;
    return (React.createElement("svg", { name: "twitter", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M73.2,38.1c0,.52,0,1,0,1.56,0,15.83-12,34.06-34.06,34.06a33.83,33.83,0,0,1-18.39-5.37,25,25,0,0,0,2.89.15,24,24,0,0,0,14.87-5.12,12,12,0,0,1-11.2-8.3,15.2,15.2,0,0,0,2.26.18,12.59,12.59,0,0,0,3.15-.4,12,12,0,0,1-9.6-11.75V43a12.16,12.16,0,0,0,5.41,1.52,12,12,0,0,1-3.7-16A34,34,0,0,0,49.56,41a13.14,13.14,0,0,1-.3-2.74A12,12,0,0,1,70,30.06a23.61,23.61,0,0,0,7.6-2.89,11.9,11.9,0,0,1-5.27,6.59,23.63,23.63,0,0,0,6.9-1.85,25.6,25.6,0,0,1-6,6.19Z", style: { fill: fillColor } })));
}

function YelpBlockIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#ff1a1a' : color;
    return (React.createElement("svg", { name: "yelp", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("g", null,
            React.createElement("path", { d: "M40.46,59.08l3.2-.74.31-.08a3.56,3.56,0,0,0,2.11-1.59,3.51,3.51,0,0,0,.41-2.61V54a3.67,3.67,0,0,0-.54-1.19,4.27,4.27,0,0,0-1.31-1.12,11.5,11.5,0,0,0-1.85-.86l-3.5-1.28c-2-.73-3.93-1.44-5.92-2.14C32.08,47,31,46.57,30,46.27l-.54-.16a9.12,9.12,0,0,0-2.63-.5,3,3,0,0,0-1.32.24,3.5,3.5,0,0,0-1.16.82,6.26,6.26,0,0,0-.45.57c-.13.2-.25.41-.36.62a4.6,4.6,0,0,0-.31.72,18.06,18.06,0,0,0-1,6c0,1.84.06,4.19,1.07,5.79a3.37,3.37,0,0,0,1,1,4,4,0,0,0,2.19.62,11.25,11.25,0,0,0,3.31-.45l10.62-2.45Z", style: { fill: fillColor } }),
            React.createElement("path", { d: "M76.1,42.13a18.19,18.19,0,0,0-3.47-5,4.72,4.72,0,0,0-.59-.5,6.34,6.34,0,0,0-.6-.41,6.67,6.67,0,0,0-.66-.31,3.2,3.2,0,0,0-2.69.13A9.08,9.08,0,0,0,66,37.7l-.41.38c-.73.68-1.53,1.52-2.49,2.5-1.48,1.49-2.93,3-4.38,4.51l-2.59,2.69a11.42,11.42,0,0,0-1.29,1.58,4.64,4.64,0,0,0-.69,1.58,3.61,3.61,0,0,0,0,1.31l0,0A3.51,3.51,0,0,0,58.25,55l.32-.06,13.81-3.19a11.15,11.15,0,0,0,3.17-1,4,4,0,0,0,1.7-1.52,3.42,3.42,0,0,0,.41-1.35C77.87,45.92,76.89,43.78,76.1,42.13Z", style: { fill: fillColor } }),
            React.createElement("path", { d: "M51.38,47.93c1-1.25,1-3.13,1.09-4.66.3-5.12.62-10.24.87-15.36a53.54,53.54,0,0,0,.19-5.81c-.1-1.61-.11-3.46-1.13-4.78-1.79-2.34-5.62-2.15-8.24-1.78q-1.2.17-2.4.45c-.79.19-1.58.4-2.35.64-2.51.83-6,2.33-6.64,5.22-.33,1.64.47,3.31,1.08,4.8a53.5,53.5,0,0,0,2.71,5.14c2.47,4.49,5,9,7.5,13.43.74,1.33,1.56,3,3,3.71l.29.11a3.47,3.47,0,0,0,2,.14l.12,0a3.51,3.51,0,0,0,1.63-1A2.61,2.61,0,0,0,51.38,47.93Z", style: { fill: fillColor } }),
            React.createElement("path", { d: "M50.18,61.64a3.17,3.17,0,0,0-3.55-1.2,3.38,3.38,0,0,0-.44.18,4.12,4.12,0,0,0-.63.39,8.1,8.1,0,0,0-1.5,1.54,5.37,5.37,0,0,1-.35.45l-2.22,3.06c-1.26,1.71-2.5,3.42-3.73,5.17-.81,1.12-1.5,2.07-2,2.91-.11.16-.21.34-.31.48A9.35,9.35,0,0,0,34.18,77,3.18,3.18,0,0,0,34,78.41a3.53,3.53,0,0,0,.48,1.35,5.9,5.9,0,0,0,.43.59,4.18,4.18,0,0,0,.5.53,5.79,5.79,0,0,0,.61.5,19.33,19.33,0,0,0,5,2.43,17.62,17.62,0,0,0,4.54.87,7,7,0,0,0,.79,0c.24,0,.48-.06.72-.1s.48-.13.71-.21A3.52,3.52,0,0,0,49,83.58a3.22,3.22,0,0,0,.73-1.15,9.28,9.28,0,0,0,.54-2.66c0-.17,0-.38,0-.56.09-1,.13-2.18.19-3.56q.16-3.2.26-6.37l.15-3.77a9.13,9.13,0,0,0-.24-2.7A3.82,3.82,0,0,0,50.18,61.64Z", style: { fill: fillColor } }),
            React.createElement("path", { d: "M75.26,67.54A9.68,9.68,0,0,0,73.1,65.9l-.49-.29c-.86-.52-1.9-1.07-3.11-1.72-1.87-1-3.73-2-5.62-3l-3.32-1.76a3.06,3.06,0,0,1-.51-.26,8.46,8.46,0,0,0-2-.72,4.4,4.4,0,0,0-.73-.07,1.94,1.94,0,0,0-.48,0,3.17,3.17,0,0,0-2.66,2.63,3.85,3.85,0,0,0,0,1.27,8.79,8.79,0,0,0,1,2.53l1.78,3.33c1,1.88,2,3.75,3,5.61.66,1.22,1.21,2.26,1.73,3.12.1.16.21.33.29.48a9.67,9.67,0,0,0,1.65,2.16,3.16,3.16,0,0,0,1.16.71,3.27,3.27,0,0,0,1.42.16c.25,0,.49-.07.73-.12s.47-.14.69-.23a4.69,4.69,0,0,0,.72-.33,17.94,17.94,0,0,0,3.71-2.77,19.79,19.79,0,0,0,3.41-4.37,4.69,4.69,0,0,0,.33-.72,6.12,6.12,0,0,0,.22-.69,6.21,6.21,0,0,0,.13-.73A3.43,3.43,0,0,0,76,68.71,3.12,3.12,0,0,0,75.26,67.54Z", style: { fill: fillColor } }))));
}

function YoutubeBlockIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#ff0000' : color;
    return (React.createElement("svg", { name: "youtube", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M76.93,36.42a7.05,7.05,0,0,0-5-5c-4.38-1.18-22-1.18-22-1.18s-17.58,0-22,1.18a7.05,7.05,0,0,0-5,5C21.89,40.83,21.89,50,21.89,50s0,9.21,1.18,13.62a7,7,0,0,0,5,4.92c4.38,1.18,22,1.18,22,1.18s17.58,0,22-1.18a7,7,0,0,0,5-4.92C78.11,59.25,78.11,50,78.11,50S78.11,40.83,76.93,36.42Zm-32.68,22V41.68L58.94,50,44.25,58.4Z", style: { fill: fillColor } }),
        React.createElement("polygon", { points: "44.25 58.4 44.25 41.68 58.94 50.04 44.25 58.4 44.25 58.4", style: { fill: '#ffffff' } })));
}

function FacebookCircleOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#3B5998' : color;
    return (React.createElement("svg", { name: "facebook", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M40.3443 27.9432V37.8526H33V49.9908H40.3536V86H55.4337V49.9908H65.5647C65.5647 49.9908 66.4967 44.1796 66.9627 37.8342H55.4803V29.5457C55.6165 28.766 56.0141 28.0542 56.6091 27.5247C57.2041 26.9952 57.962 26.6788 58.761 26.6262H67V14H55.8158C39.9715 14 40.3443 26.1381 40.3443 27.9432Z", style: { fill: fillColor } }),
        React.createElement("path", { d: "M50 4.35C59.0287 4.35 67.8547 7.02732 75.3618 12.0434C82.8689 17.0595 88.72 24.1891 92.1751 32.5305C95.6302 40.8719 96.5343 50.0506 94.7729 58.9059C93.0114 67.7611 88.6637 75.8952 82.2794 82.2794C75.8952 88.6637 67.7611 93.0114 58.9059 94.7729C50.0506 96.5343 40.8719 95.6302 32.5305 92.1751C24.1891 88.72 17.0595 82.8689 12.0434 75.3618C7.02733 67.8547 4.35 59.0287 4.35 50C4.36323 37.8969 9.17702 26.2934 17.7352 17.7352C26.2934 9.17702 37.8969 4.36323 50 4.35M50 0.349998C40.1802 0.349998 30.5808 3.26192 22.4159 8.71753C14.251 14.1731 7.88727 21.9274 4.12938 30.9998C0.37149 40.0721 -0.611746 50.0551 1.30401 59.6862C3.21977 69.3174 7.94847 78.1642 14.8921 85.1078C21.8358 92.0515 30.6826 96.7802 40.3138 98.696C49.9449 100.612 59.9279 99.6285 69.0002 95.8706C78.0726 92.1127 85.8269 85.749 91.2825 77.5841C96.7381 69.4192 99.65 59.8198 99.65 50C99.65 43.4799 98.3658 37.0236 95.8706 30.9998C93.3755 24.9759 89.7183 19.5026 85.1079 14.8921C80.4974 10.2817 75.024 6.62453 69.0002 4.12938C62.9764 1.63423 56.5201 0.349998 50 0.349998V0.349998Z", style: { fill: fillColor } })));
}

function InstagramCircleOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#ff0075' : color;
    return (React.createElement("svg", { name: "instagram", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M50,34.89A15.11,15.11,0,1,0,65.12,50,15.09,15.09,0,0,0,50,34.89Zm0,24.94A9.83,9.83,0,1,1,59.83,50,9.85,9.85,0,0,1,50,59.83ZM69.26,34.27a3.53,3.53,0,1,1-3.52-3.53A3.51,3.51,0,0,1,69.26,34.27Zm10,3.58c-.22-4.73-1.3-8.91-4.76-12.36S66.88,21,62.16,20.73s-19.45-.27-24.32,0C33.13,21,29,22,25.49,25.48S21,33.11,20.73,37.83c-.28,4.87-.28,19.46,0,24.32s1.3,8.91,4.76,12.36S33.12,79,37.84,79.27s19.45.27,24.32,0c4.72-.23,8.91-1.3,12.35-4.76S79,66.88,79.27,62.15s.28-19.44,0-24.3ZM73,67.38A10,10,0,0,1,67.38,73C63.5,74.52,54.29,74.16,50,74.16S36.5,74.51,32.63,73a10,10,0,0,1-5.6-5.6C25.49,63.5,25.84,54.29,25.84,50S25.5,36.49,27,32.62a10,10,0,0,1,5.6-5.6c3.88-1.54,13.09-1.18,17.38-1.18S63.52,25.49,67.38,27A10,10,0,0,1,73,32.62C74.53,36.5,74.17,45.71,74.17,50S74.53,63.51,73,67.38Z", style: { fill: fillColor } }),
        React.createElement("path", { d: "M50,4.35A45.65,45.65,0,1,1,4.35,50,45.7,45.7,0,0,1,50,4.35m0-4A49.65,49.65,0,1,0,99.65,50,49.65,49.65,0,0,0,50,.35Z", style: { fill: fillColor } })));
}

function LinkedinCircleOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#007AB9' : color;
    return (React.createElement("svg", { name: "linkedin", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M35.78,75.75H25.1V41.37H35.78ZM30.43,36.67a6.21,6.21,0,1,1,6.19-6.24A6.23,6.23,0,0,1,30.43,36.67ZM75.74,75.75H65.09V59c0-4-.09-9.1-5.56-9.1s-6.4,4.33-6.4,8.81v17H42.47V41.37H52.71v4.69h.15A11.19,11.19,0,0,1,63,40.5c10.8,0,12.79,7.12,12.79,16.36V75.75Z", style: { fill: fillColor } }),
        React.createElement("path", { d: "M50,4.35A45.65,45.65,0,1,1,4.35,50,45.7,45.7,0,0,1,50,4.35m0-4A49.65,49.65,0,1,0,99.65,50,49.65,49.65,0,0,0,50,.35Z", style: { fill: fillColor } })));
}

function PinterestCircleOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#CB2027' : color;
    return (React.createElement("svg", { name: "pinterest", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M51.69,14.93C37.27,14.93,23,24.55,23,40.1,23,50,28.59,55.61,32,55.61c1.39,0,2.19-3.88,2.19-5,0-1.31-3.33-4.09-3.33-9.53,0-11.3,8.6-19.3,19.73-19.3,9.57,0,16.65,5.43,16.65,15.42,0,7.47-3,21.46-12.69,21.46A6.24,6.24,0,0,1,48,52.54c0-5.32,3.71-10.46,3.71-15.94,0-9.3-13.2-7.61-13.2,3.63a16.55,16.55,0,0,0,1.35,7.12C37.94,55.7,34,68.13,34,76.73c0,2.66.38,5.27.63,7.93.48.53.24.47,1,.21,7.09-9.7,6.83-11.59,10-24.28,1.72,3.29,6.19,5.06,9.73,5.06C70.28,65.65,77,51.1,77,38,77,24,64.92,14.93,51.69,14.93Z", style: { fill: fillColor } }),
        React.createElement("path", { d: "M50,4.35A45.65,45.65,0,1,1,4.35,50,45.7,45.7,0,0,1,50,4.35m0-4A49.65,49.65,0,1,0,99.65,50,49.65,49.65,0,0,0,50,.35Z", style: { fill: fillColor } })));
}

function TiktokCircleOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#000000' : color;
    return (React.createElement("svg", { name: "tiktok", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M50 4.35001C59.0287 4.35001 67.8547 7.02733 75.3618 12.0434C82.8689 17.0595 88.72 24.1891 92.1751 32.5305C95.6302 40.872 96.5343 50.0506 94.7729 58.9059C93.0114 67.7611 88.6637 75.8952 82.2794 82.2794C75.8952 88.6637 67.7611 93.0114 58.9059 94.7729C50.0506 96.5343 40.8719 95.6303 32.5305 92.1751C24.1891 88.72 17.0595 82.8689 12.0434 75.3618C7.02733 67.8547 4.35 59.0287 4.35 50C4.36323 37.8969 9.17702 26.2934 17.7352 17.7352C26.2934 9.17703 37.8969 4.36324 50 4.35001M50 0.350006C40.1802 0.350006 30.5808 3.26193 22.4159 8.71754C14.251 14.1732 7.88727 21.9274 4.12938 30.9998C0.37149 40.0721 -0.611746 50.0551 1.30401 59.6862C3.21977 69.3174 7.94847 78.1642 14.8921 85.1079C21.8358 92.0515 30.6826 96.7802 40.3138 98.696C49.9449 100.612 59.9279 99.6285 69.0002 95.8706C78.0726 92.1127 85.8269 85.749 91.2825 77.5841C96.7381 69.4192 99.65 59.8198 99.65 50C99.65 43.4799 98.3658 37.0236 95.8706 30.9998C93.3755 24.976 89.7183 19.5026 85.1079 14.8922C80.4974 10.2817 75.024 6.62453 69.0002 4.12939C62.9764 1.63424 56.5201 0.350006 50 0.350006V0.350006Z", style: { fill: fillColor } }),
        React.createElement("path", { d: "M71.0383 29.6302C67.3323 27.2414 64.6568 23.4208 63.8228 18.9667C63.6424 18.0039 63.5436 17.0139 63.5436 16H51.7146L51.695 62.8525C51.4963 68.099 47.1275 72.3102 41.7707 72.3102C40.1061 72.3102 38.538 71.8992 37.1583 71.1805C33.9934 69.5342 31.8279 66.2552 31.8279 62.4823C31.8279 57.0632 36.2887 52.6545 41.7707 52.6545C42.7942 52.6545 43.7753 52.8214 44.7047 53.1087V41.1736C43.7431 41.0441 42.7667 40.9635 41.7707 40.9635C29.767 40.9647 20 50.6176 20 62.4823C20 69.7624 23.6807 76.2045 29.2948 80.1C32.8308 82.5535 37.133 84 41.7718 84C53.7766 84 63.5436 74.347 63.5436 62.4823V38.7246C68.1824 42.016 73.8666 43.9553 80 43.9553V32.2643C76.6961 32.2643 73.6185 31.2935 71.0383 29.6302Z", style: { fill: fillColor } })));
}

function TwitterCircleOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#55ACEE' : color;
    return (React.createElement("svg", { name: "twitter", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M73.2,38.1c0,.52,0,1,0,1.56,0,15.83-12,34.06-34.06,34.06a33.83,33.83,0,0,1-18.39-5.37,25,25,0,0,0,2.89.15,24,24,0,0,0,14.87-5.12,12,12,0,0,1-11.2-8.3,15.2,15.2,0,0,0,2.26.18,12.59,12.59,0,0,0,3.15-.4,12,12,0,0,1-9.6-11.75V43a12.16,12.16,0,0,0,5.41,1.52,12,12,0,0,1-3.7-16A34,34,0,0,0,49.56,41a13.14,13.14,0,0,1-.3-2.74A12,12,0,0,1,70,30.06a23.61,23.61,0,0,0,7.6-2.89,11.9,11.9,0,0,1-5.27,6.59,23.63,23.63,0,0,0,6.9-1.85,25.6,25.6,0,0,1-6,6.19Z", style: { fill: fillColor } }),
        React.createElement("path", { d: "M50,4.35A45.65,45.65,0,1,1,4.35,50,45.7,45.7,0,0,1,50,4.35m0-4A49.65,49.65,0,1,0,99.65,50,49.65,49.65,0,0,0,50,.35Z", style: { fill: fillColor } })));
}

function YelpCircleOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#ff1a1a' : color;
    return (React.createElement("svg", { name: "yelp", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("g", null,
            React.createElement("path", { d: "M40.46,59.08l3.2-.74.31-.08a3.56,3.56,0,0,0,2.11-1.59,3.51,3.51,0,0,0,.41-2.61V54a3.67,3.67,0,0,0-.54-1.19,4.27,4.27,0,0,0-1.31-1.12,11.5,11.5,0,0,0-1.85-.86l-3.5-1.28c-2-.73-3.93-1.44-5.92-2.14C32.08,47,31,46.57,30,46.27l-.54-.16a9.12,9.12,0,0,0-2.63-.5,3,3,0,0,0-1.32.24,3.5,3.5,0,0,0-1.16.82,6.26,6.26,0,0,0-.45.57c-.13.2-.25.41-.36.62a4.6,4.6,0,0,0-.31.72,18.06,18.06,0,0,0-1,6c0,1.84.06,4.19,1.07,5.79a3.37,3.37,0,0,0,1,1,4,4,0,0,0,2.19.62,11.25,11.25,0,0,0,3.31-.45l10.62-2.45Z", style: { fill: fillColor } }),
            React.createElement("path", { d: "M76.1,42.13a18.19,18.19,0,0,0-3.47-5,4.72,4.72,0,0,0-.59-.5,6.34,6.34,0,0,0-.6-.41,6.67,6.67,0,0,0-.66-.31,3.2,3.2,0,0,0-2.69.13A9.08,9.08,0,0,0,66,37.7l-.41.38c-.73.68-1.53,1.52-2.49,2.5-1.48,1.49-2.93,3-4.38,4.51l-2.59,2.69a11.42,11.42,0,0,0-1.29,1.58,4.64,4.64,0,0,0-.69,1.58,3.61,3.61,0,0,0,0,1.31l0,0A3.51,3.51,0,0,0,58.25,55l.32-.06,13.81-3.19a11.15,11.15,0,0,0,3.17-1,4,4,0,0,0,1.7-1.52,3.42,3.42,0,0,0,.41-1.35C77.87,45.92,76.89,43.78,76.1,42.13Z", style: { fill: fillColor } }),
            React.createElement("path", { d: "M51.38,47.93c1-1.25,1-3.13,1.09-4.66.3-5.12.62-10.24.87-15.36a53.54,53.54,0,0,0,.19-5.81c-.1-1.61-.11-3.46-1.13-4.78-1.79-2.34-5.62-2.15-8.24-1.78q-1.2.17-2.4.45c-.79.19-1.58.4-2.35.64-2.51.83-6,2.33-6.64,5.22-.33,1.64.47,3.31,1.08,4.8a53.5,53.5,0,0,0,2.71,5.14c2.47,4.49,5,9,7.5,13.43.74,1.33,1.56,3,3,3.71l.29.11a3.47,3.47,0,0,0,2,.14l.12,0a3.51,3.51,0,0,0,1.63-1A2.61,2.61,0,0,0,51.38,47.93Z", style: { fill: fillColor } }),
            React.createElement("path", { d: "M50.18,61.64a3.17,3.17,0,0,0-3.55-1.2,3.38,3.38,0,0,0-.44.18,4.12,4.12,0,0,0-.63.39,8.1,8.1,0,0,0-1.5,1.54,5.37,5.37,0,0,1-.35.45l-2.22,3.06c-1.26,1.71-2.5,3.42-3.73,5.17-.81,1.12-1.5,2.07-2,2.91-.11.16-.21.34-.31.48A9.35,9.35,0,0,0,34.18,77,3.18,3.18,0,0,0,34,78.41a3.53,3.53,0,0,0,.48,1.35,5.9,5.9,0,0,0,.43.59,4.18,4.18,0,0,0,.5.53,5.79,5.79,0,0,0,.61.5,19.33,19.33,0,0,0,5,2.43,17.62,17.62,0,0,0,4.54.87,7,7,0,0,0,.79,0c.24,0,.48-.06.72-.1s.48-.13.71-.21A3.52,3.52,0,0,0,49,83.58a3.22,3.22,0,0,0,.73-1.15,9.28,9.28,0,0,0,.54-2.66c0-.17,0-.38,0-.56.09-1,.13-2.18.19-3.56q.16-3.2.26-6.37l.15-3.77a9.13,9.13,0,0,0-.24-2.7A3.82,3.82,0,0,0,50.18,61.64Z", style: { fill: fillColor } }),
            React.createElement("path", { d: "M75.26,67.54A9.68,9.68,0,0,0,73.1,65.9l-.49-.29c-.86-.52-1.9-1.07-3.11-1.72-1.87-1-3.73-2-5.62-3l-3.32-1.76a3.06,3.06,0,0,1-.51-.26,8.46,8.46,0,0,0-2-.72,4.4,4.4,0,0,0-.73-.07,1.94,1.94,0,0,0-.48,0,3.17,3.17,0,0,0-2.66,2.63,3.85,3.85,0,0,0,0,1.27,8.79,8.79,0,0,0,1,2.53l1.78,3.33c1,1.88,2,3.75,3,5.61.66,1.22,1.21,2.26,1.73,3.12.1.16.21.33.29.48a9.67,9.67,0,0,0,1.65,2.16,3.16,3.16,0,0,0,1.16.71,3.27,3.27,0,0,0,1.42.16c.25,0,.49-.07.73-.12s.47-.14.69-.23a4.69,4.69,0,0,0,.72-.33,17.94,17.94,0,0,0,3.71-2.77,19.79,19.79,0,0,0,3.41-4.37,4.69,4.69,0,0,0,.33-.72,6.12,6.12,0,0,0,.22-.69,6.21,6.21,0,0,0,.13-.73A3.43,3.43,0,0,0,76,68.71,3.12,3.12,0,0,0,75.26,67.54Z", style: { fill: fillColor } })),
        React.createElement("path", { d: "M50,4.35A45.65,45.65,0,1,1,4.35,50,45.7,45.7,0,0,1,50,4.35m0-4A49.65,49.65,0,1,0,99.65,50,49.65,49.65,0,0,0,50,.35Z", style: { fill: fillColor } })));
}

function YoutubeCircleOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#ff0000' : color;
    return (React.createElement("svg", { name: "youtube", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M76.93,36.42a7.05,7.05,0,0,0-5-5c-4.38-1.18-22-1.18-22-1.18s-17.58,0-22,1.18a7.05,7.05,0,0,0-5,5C21.89,40.83,21.89,50,21.89,50s0,9.21,1.18,13.62a7,7,0,0,0,5,4.92c4.38,1.18,22,1.18,22,1.18s17.58,0,22-1.18a7,7,0,0,0,5-4.92C78.11,59.25,78.11,50,78.11,50S78.11,40.83,76.93,36.42Zm-32.68,22V41.68L58.94,50,44.25,58.4Z", style: { fill: fillColor } }),
        React.createElement("polygon", { points: "44.25 58.4 44.25 41.68 58.94 50.04 44.25 58.4 44.25 58.4", style: { fill: '#ffffff' } }),
        React.createElement("path", { d: "M50,4.35A45.65,45.65,0,1,1,4.35,50,45.7,45.7,0,0,1,50,4.35m0-4A49.65,49.65,0,1,0,99.65,50,49.65,49.65,0,0,0,50,.35Z", style: { fill: fillColor } })));
}

function FacebookCircleSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#3B5998' : color;
    return (React.createElement("svg", { name: "facebook", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 99.3 99.3", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("g", null,
            React.createElement("path", { d: "M99.3,49.65A49.65,49.65,0,1,0,37.52,97.8V60.31H29.63V47.15h7.88V36.39c0-2-.4-15.13,16.6-15.13h12V35H57.28a3.83,3.83,0,0,0-3.53,3.17v9H66.07c-.49,6.89-1.5,13.2-1.5,13.2H53.7V99.12A49.65,49.65,0,0,0,99.3,49.65Z", style: { fill: fillColor } }),
            React.createElement("path", { d: "M64.57,60.31s1-6.31,1.5-13.2H53.75v-9A3.83,3.83,0,0,1,57.28,35h8.83V21.26h-12c-17,0-16.6,13.17-16.6,15.13V47.15H29.63V60.31h7.89V97.8a49.94,49.94,0,0,0,12.13,1.5c1.37,0,2.71-.07,4.05-.18V60.31Z", style: { fill: '#ffffff' } }))));
}

function GooglePlusCircleSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#DC4E41' : color;
    return (React.createElement("svg", { name: "googleplus", version: "1.1", xmlns: "http://www.w3.org/2000/svg", style: {
            width: `${size}px`,
            height: `${size}px`,
        }, x: "0px", y: "0px", viewBox: "0 0 112.196 112.196" },
        React.createElement("path", { style: { fill: fillColor }, d: `M56.1,0C25.1,0,0,25.1,0,56.1s25.1,56.1,56.1,56.1c31,0,56.1-25.1,56.1-56.1S87.1,0,56.1,0z M60.1,73.8
	c-5.7,7.4-16.3,9.5-24.9,6.6c-9.1-3-15.8-12.2-15.6-21.9c-0.5-11.9,10-22.9,21.9-23.1c6.1-0.5,12,1.8,16.6,5.7
	c-1.9,2.1-3.8,4.1-5.9,6.1c-4.1-2.5-8.9-4.3-13.7-2.7c-7.6,2.2-12.3,11.2-9.4,18.7c2.3,7.8,11.8,12.1,19.3,8.8
	c3.9-1.4,6.4-4.9,7.5-8.8c-4.4-0.1-8.8,0-13.3-0.2c0-2.6,0-5.2,0-7.9c7.4,0,14.7,0,22.1,0C65.2,61.8,64.2,68.7,60.1,73.8z
	 M92.3,61.9c-2.2,0-4.4,0-6.6,0c0,2.2,0,4.4,0,6.6c-2.2,0-4.4,0-6.6,0c0-2.2,0-4.4,0-6.6c-2.2,0-4.4,0-6.6,0c0-2.2,0-4.4,0-6.6
	c2.2,0,4.4,0,6.6,0c0-2.2,0-4.4,0.1-6.6c2.2,0,4.4,0,6.6,0c0,2.2,0,4.4,0,6.6c2.2,0,4.4,0,6.6,0C92.3,57.5,92.3,59.7,92.3,61.9z` })));
}

function InstagramCircleSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#ff0075' : color;
    return (React.createElement("svg", { name: "instagram", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("circle", { cx: "50", cy: "50", r: "49.65", style: { fill: fillColor } }),
        React.createElement("path", { d: "M50.88,34.53A15.12,15.12,0,1,0,66,49.65,15.1,15.1,0,0,0,50.88,34.53Zm0,24.94a9.83,9.83,0,1,1,9.82-9.82,9.84,9.84,0,0,1-9.82,9.82ZM70.14,33.92a3.53,3.53,0,1,1-3.53-3.53A3.51,3.51,0,0,1,70.14,33.92Zm10,3.57c-.23-4.72-1.31-8.9-4.77-12.35S67.75,20.62,63,20.38s-19.45-.28-24.32,0c-4.71.22-8.89,1.3-12.35,4.75s-4.53,7.63-4.76,12.35c-.28,4.87-.28,19.46,0,24.32s1.3,8.91,4.76,12.35S34,78.68,38.71,78.92s19.46.27,24.32,0,8.91-1.31,12.35-4.77,4.53-7.62,4.77-12.35.27-19.44,0-24.31ZM73.86,67a10,10,0,0,1-5.61,5.61c-3.88,1.54-13.08,1.18-17.37,1.18s-13.51.34-17.38-1.18A9.94,9.94,0,0,1,27.9,67c-1.54-3.88-1.19-13.08-1.19-17.37s-.34-13.51,1.19-17.38a9.92,9.92,0,0,1,5.6-5.6c3.88-1.54,13.09-1.19,17.38-1.19s13.51-.34,17.37,1.19a9.94,9.94,0,0,1,5.61,5.6C75.4,36.15,75,45.36,75,49.65S75.4,63.16,73.86,67Z", style: { fill: '#ffffff' } })));
}

function LinkedinCircleSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#007AB9' : color;
    return (React.createElement("svg", { name: "linkedin", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("circle", { cx: "49.65", cy: "49.65", r: "49.65", style: { fill: fillColor } }),
        React.createElement("path", { d: "M35.29,74.33H24.61V39.94H35.29ZM30,35.25A6.21,6.21,0,1,1,36.13,29,6.24,6.24,0,0,1,30,35.25ZM75.26,74.33H64.6V57.59c0-4-.08-9.11-5.55-9.11s-6.4,4.34-6.4,8.82v17H42V39.94H52.22v4.69h.15a11.23,11.23,0,0,1,10.1-5.55c10.81,0,12.8,7.12,12.8,16.36V74.33Z", style: { fill: '#ffffff' } })));
}

function PinterestCircleSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#CB2027' : color;
    return (React.createElement("svg", { name: "pinterest", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("circle", { cx: "50", cy: "50", r: "49.65", style: { fill: fillColor } }),
        React.createElement("path", { d: "M53.06,14.62c-14.42,0-28.67,9.61-28.67,25.17,0,9.89,5.57,15.51,8.94,15.51,1.39,0,2.19-3.88,2.19-5,0-1.31-3.33-4.09-3.33-9.53,0-11.3,8.6-19.31,19.73-19.31,9.57,0,16.65,5.44,16.65,15.43,0,7.46-3,21.46-12.69,21.46a6.24,6.24,0,0,1-6.49-6.16c0-5.31,3.71-10.45,3.71-15.93,0-9.3-13.2-7.62-13.2,3.63A16.55,16.55,0,0,0,41.25,47c-1.94,8.35-5.9,20.78-5.9,29.38,0,2.66.38,5.27.63,7.93.48.53.24.47,1,.21C44,74.86,43.78,73,47,60.28c1.72,3.28,6.19,5,9.73,5,14.93,0,21.63-14.54,21.63-27.65C78.35,23.73,66.29,14.62,53.06,14.62Z", style: { fill: '#ffffff' } })));
}

function TiktokCircleSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#000000' : color;
    return (React.createElement("svg", { name: "tiktok", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("circle", { cx: "50", cy: "50", r: "50", style: { fill: fillColor } }),
        React.createElement("path", { d: "M71.0383 29.6302C67.3323 27.2414 64.6568 23.4208 63.8228 18.9667C63.6424 18.0039 63.5436 17.0139 63.5436 16H51.7146L51.695 62.8525C51.4963 68.099 47.1275 72.3102 41.7707 72.3102C40.1061 72.3102 38.538 71.8992 37.1583 71.1805C33.9934 69.5342 31.8279 66.2552 31.8279 62.4823C31.8279 57.0632 36.2887 52.6545 41.7707 52.6545C42.7942 52.6545 43.7753 52.8214 44.7047 53.1087V41.1736C43.7431 41.0441 42.7667 40.9635 41.7707 40.9635C29.767 40.9647 20 50.6176 20 62.4823C20 69.7624 23.6807 76.2045 29.2948 80.1C32.8308 82.5535 37.133 84 41.7718 84C53.7766 84 63.5436 74.347 63.5436 62.4823V38.7246C68.1824 42.016 73.8666 43.9553 80 43.9553V32.2643C76.6961 32.2643 73.6185 31.2935 71.0383 29.6302Z", fill: "white" })));
}

function TwitterCircleSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#55ACEE' : color;
    return (React.createElement("svg", { name: "twitter", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("circle", { cx: "50", cy: "50", r: "49.65", style: { fill: fillColor } }),
        React.createElement("path", { d: "M72.85,37.75c0,.52,0,1,0,1.56,0,15.82-12,34.06-34.07,34.06A33.82,33.82,0,0,1,20.44,68a25,25,0,0,0,2.89.15A24,24,0,0,0,38.19,63,12,12,0,0,1,27,54.73a15.2,15.2,0,0,0,2.26.18,12.59,12.59,0,0,0,3.15-.41,12,12,0,0,1-9.6-11.75v-.14a12.16,12.16,0,0,0,5.41,1.52,12,12,0,0,1-3.7-16A34,34,0,0,0,49.2,40.64a13.93,13.93,0,0,1-.29-2.74,12,12,0,0,1,20.72-8.19,23.49,23.49,0,0,0,7.6-2.9A11.89,11.89,0,0,1,72,33.41a23.94,23.94,0,0,0,6.9-1.85,25.78,25.78,0,0,1-6,6.19Z", style: { fill: '#ffffff' } })));
}

function YelpCircleSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#ff1a1a' : color;
    return (React.createElement("svg", { name: "yelp", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("circle", { cx: "50", cy: "50", r: "49.65", style: { fill: fillColor } }),
        React.createElement("g", null,
            React.createElement("path", { d: "M40.46,58.39l3.2-.74.31-.08A3.56,3.56,0,0,0,46.08,56a3.51,3.51,0,0,0,.41-2.61v-.06a3.67,3.67,0,0,0-.54-1.19A4.56,4.56,0,0,0,44.63,51a12.39,12.39,0,0,0-1.85-.85l-3.5-1.28c-2-.73-3.93-1.44-5.92-2.14-1.28-.46-2.37-.86-3.32-1.15l-.54-.17a9.48,9.48,0,0,0-2.63-.5,3.16,3.16,0,0,0-1.32.24,3.5,3.5,0,0,0-1.16.82,6.26,6.26,0,0,0-.45.57,6.44,6.44,0,0,0-.36.63,4.93,4.93,0,0,0-.31.71,18.08,18.08,0,0,0-1,6c0,1.83.06,4.19,1.07,5.78a3.4,3.4,0,0,0,1,1,4.06,4.06,0,0,0,2.19.62,11.25,11.25,0,0,0,3.31-.45l10.62-2.45Z", style: { fill: '#ffffff' } }),
            React.createElement("path", { d: "M76.1,41.43a18.14,18.14,0,0,0-3.47-4.94A4.8,4.8,0,0,0,72,36a6.25,6.25,0,0,0-.6-.4,6.72,6.72,0,0,0-.66-.32A3.45,3.45,0,0,0,69.39,35a3.14,3.14,0,0,0-1.3.37A9.27,9.27,0,0,0,66,37l-.41.39c-.73.68-1.53,1.51-2.49,2.49-1.48,1.5-2.93,3-4.38,4.52l-2.59,2.68a10.94,10.94,0,0,0-1.29,1.59,4.56,4.56,0,0,0-.69,1.58,3.55,3.55,0,0,0,0,1.3l0,.06a3.48,3.48,0,0,0,1.51,2.16,3.52,3.52,0,0,0,2.59.51l.32-.06L72.38,51A11.81,11.81,0,0,0,75.55,50a4,4,0,0,0,1.7-1.52,3.41,3.41,0,0,0,.41-1.36C77.87,45.22,76.89,43.08,76.1,41.43Z", style: { fill: '#ffffff' } }),
            React.createElement("path", { d: "M51.38,47.24c1-1.26,1-3.13,1.09-4.66.3-5.12.62-10.24.87-15.36a53.62,53.62,0,0,0,.19-5.81c-.1-1.61-.11-3.47-1.13-4.79-1.79-2.33-5.62-2.14-8.24-1.78q-1.2.16-2.4.45c-.79.19-1.58.4-2.35.65-2.51.82-6,2.33-6.64,5.22-.33,1.63.47,3.31,1.08,4.8a54.71,54.71,0,0,0,2.71,5.14c2.47,4.49,5,8.95,7.5,13.42.74,1.34,1.56,3,3,3.72l.29.11a3.55,3.55,0,0,0,2,.14l.12,0a3.51,3.51,0,0,0,1.63-1Z", style: { fill: '#ffffff' } }),
            React.createElement("path", { d: "M50.18,60.94a3.21,3.21,0,0,0-3.55-1.2,3.43,3.43,0,0,0-.44.19,4.12,4.12,0,0,0-.63.39,8,8,0,0,0-1.5,1.53,5.55,5.55,0,0,1-.35.46l-2.22,3q-1.89,2.56-3.73,5.17c-.81,1.13-1.5,2.08-2,2.92-.11.16-.21.33-.31.48a9.19,9.19,0,0,0-1.22,2.42A3.14,3.14,0,0,0,34,77.71a3.42,3.42,0,0,0,.48,1.35,5,5,0,0,0,.43.6,5,5,0,0,0,.5.53,5.79,5.79,0,0,0,.61.5,19.63,19.63,0,0,0,5,2.42,17.62,17.62,0,0,0,4.54.87,4.17,4.17,0,0,0,.79,0,5.93,5.93,0,0,0,.72-.1,5.75,5.75,0,0,0,.71-.2A3.52,3.52,0,0,0,49,82.89a3.31,3.31,0,0,0,.73-1.15,9.36,9.36,0,0,0,.54-2.66c0-.17,0-.38,0-.57.09-1,.13-2.18.19-3.56q.16-3.18.26-6.36l.15-3.78a9.16,9.16,0,0,0-.24-2.7A3.93,3.93,0,0,0,50.18,60.94Z", style: { fill: '#ffffff' } }),
            React.createElement("path", { d: "M75.26,66.85a9.39,9.39,0,0,0-2.16-1.64c-.15-.09-.32-.2-.49-.29-.86-.52-1.9-1.07-3.11-1.73-1.87-1-3.73-2-5.62-3l-3.32-1.77a3,3,0,0,1-.51-.25,8,8,0,0,0-2-.72,4.41,4.41,0,0,0-.73-.08,3.87,3.87,0,0,0-.48,0A3.19,3.19,0,0,0,54.15,60a3.87,3.87,0,0,0,0,1.27,8.91,8.91,0,0,0,1,2.53l1.78,3.33c1,1.88,2,3.75,3,5.61.66,1.21,1.21,2.25,1.73,3.11.1.17.21.34.29.49a9.67,9.67,0,0,0,1.65,2.16,3.16,3.16,0,0,0,1.16.71,3.42,3.42,0,0,0,1.42.16,5.86,5.86,0,0,0,.73-.13c.23-.06.47-.14.69-.22a5.93,5.93,0,0,0,.72-.34,17.59,17.59,0,0,0,3.71-2.77,19.73,19.73,0,0,0,3.41-4.36,4.69,4.69,0,0,0,.33-.72,5.68,5.68,0,0,0,.22-.7,6,6,0,0,0,.13-.72A3.41,3.41,0,0,0,76,68,3.12,3.12,0,0,0,75.26,66.85Z", style: { fill: '#ffffff' } }))));
}

function YoutubeCircleSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#C4302B' : color;
    return (React.createElement("svg", { name: "youtube", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("circle", { cx: "50", cy: "50", r: "49.65", style: { fill: fillColor } }),
        React.createElement("path", { d: "M76.45,36.07a7.07,7.07,0,0,0-5-5c-4.39-1.18-22-1.18-22-1.18s-17.58,0-22,1.18a7.07,7.07,0,0,0-5,5c-1.17,4.41-1.17,13.62-1.17,13.62s0,9.2,1.17,13.62a7,7,0,0,0,5,4.92c4.39,1.18,22,1.18,22,1.18s17.57,0,22-1.18a7,7,0,0,0,5-4.92c1.17-4.42,1.17-13.62,1.17-13.62S77.62,40.48,76.45,36.07Zm-32.68,22V41.33l14.69,8.36L43.77,58.05Z", style: { fill: '#ffffff' } })));
}

function FacebookSquareOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#3B5998' : color;
    return (React.createElement("svg", { name: "facebook", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M40.3443 27.3305V37.5152H33V49.9905H40.3536V87H55.4337V49.9905H65.5647C65.5647 49.9905 66.4967 44.0179 66.9627 37.4963H55.4803V28.9775C55.6165 28.1761 56.0141 27.4446 56.6091 26.9004C57.2041 26.3562 57.962 26.0309 58.761 25.977H67V13H55.8158C39.9715 13 40.3443 25.4753 40.3443 27.3305Z", style: { fill: fillColor } }),
        React.createElement("path", { d: "M95.65 4.35V95.65H4.35001V4.35H95.65M99.65 0.349998H0.350006V99.65H99.65V0.349998V0.349998Z", style: { fill: fillColor } })));
}

function InstagramSquareOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#ff0075' : color;
    return (React.createElement("svg", { name: "instagram", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M50,34.89A15.11,15.11,0,1,0,65.12,50,15.09,15.09,0,0,0,50,34.89Zm0,24.94A9.83,9.83,0,1,1,59.83,50,9.85,9.85,0,0,1,50,59.83ZM69.26,34.27a3.53,3.53,0,1,1-3.52-3.53A3.51,3.51,0,0,1,69.26,34.27Zm10,3.58c-.22-4.73-1.3-8.91-4.76-12.36S66.88,21,62.16,20.73s-19.45-.27-24.32,0C33.13,21,29,22,25.49,25.48S21,33.11,20.73,37.83c-.28,4.87-.28,19.46,0,24.32s1.3,8.91,4.76,12.36S33.12,79,37.84,79.27s19.45.27,24.32,0c4.72-.23,8.91-1.3,12.35-4.76S79,66.88,79.27,62.15s.28-19.44,0-24.3ZM73,67.38A10,10,0,0,1,67.38,73C63.5,74.52,54.29,74.16,50,74.16S36.5,74.51,32.63,73a10,10,0,0,1-5.6-5.6C25.49,63.5,25.84,54.29,25.84,50S25.5,36.49,27,32.62a10,10,0,0,1,5.6-5.6c3.88-1.54,13.09-1.18,17.38-1.18S63.52,25.49,67.38,27A10,10,0,0,1,73,32.62C74.53,36.5,74.17,45.71,74.17,50S74.53,63.51,73,67.38Z", style: { fill: fillColor } }),
        React.createElement("path", { d: "M95.65,4.35v91.3H4.35V4.35h91.3m4-4H.35v99.3h99.3V.35Z", style: { fill: fillColor } })));
}

function LinkedinSquareOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#007AB9' : color;
    return (React.createElement("svg", { name: "linkedin", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M35.78,75.75H25.1V41.37H35.78ZM30.43,36.67a6.21,6.21,0,1,1,6.19-6.24A6.23,6.23,0,0,1,30.43,36.67ZM75.74,75.75H65.09V59c0-4-.09-9.1-5.56-9.1s-6.4,4.33-6.4,8.81v17H42.47V41.37H52.71v4.69h.15A11.19,11.19,0,0,1,63,40.5c10.8,0,12.79,7.12,12.79,16.36V75.75Z", style: { fill: fillColor } }),
        React.createElement("path", { d: "M95.65,4.35v91.3H4.35V4.35h91.3m4-4H.35v99.3h99.3V.35Z", style: { fill: fillColor } })));
}

function PinterestSquareOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#CB2027' : color;
    return (React.createElement("svg", { name: "pinterest", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M51.69,14.93C37.27,14.93,23,24.55,23,40.1,23,50,28.59,55.61,32,55.61c1.39,0,2.19-3.88,2.19-5,0-1.31-3.33-4.09-3.33-9.53,0-11.3,8.6-19.3,19.73-19.3,9.57,0,16.65,5.43,16.65,15.42,0,7.47-3,21.46-12.69,21.46A6.24,6.24,0,0,1,48,52.54c0-5.32,3.71-10.46,3.71-15.94,0-9.3-13.2-7.61-13.2,3.63a16.55,16.55,0,0,0,1.35,7.12C37.94,55.7,34,68.13,34,76.73c0,2.66.38,5.27.63,7.93.48.53.24.47,1,.21,7.09-9.7,6.83-11.59,10-24.28,1.72,3.29,6.19,5.06,9.73,5.06C70.28,65.65,77,51.1,77,38,77,24,64.92,14.93,51.69,14.93Z", style: { fill: fillColor } }),
        React.createElement("path", { d: "M95.65,4.35v91.3H4.35V4.35h91.3m4-4H.35v99.3h99.3V.35Z", style: { fill: fillColor } })));
}

function TiktokSquareOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#000000' : color;
    return (React.createElement("svg", { name: "tiktok", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M71.0383 29.6302C67.3323 27.2414 64.6568 23.4208 63.8228 18.9667C63.6424 18.0039 63.5436 17.0139 63.5436 16H51.7146L51.695 62.8525C51.4963 68.099 47.1275 72.3102 41.7707 72.3102C40.1061 72.3102 38.538 71.8992 37.1583 71.1805C33.9934 69.5342 31.8279 66.2552 31.8279 62.4823C31.8279 57.0632 36.2887 52.6545 41.7707 52.6545C42.7942 52.6545 43.7753 52.8214 44.7047 53.1087V41.1736C43.7431 41.0441 42.7667 40.9635 41.7707 40.9635C29.767 40.9647 20 50.6176 20 62.4823C20 69.7624 23.6807 76.2045 29.2948 80.1C32.8308 82.5535 37.133 84 41.7718 84C53.7766 84 63.5436 74.347 63.5436 62.4823V38.7246C68.1824 42.016 73.8666 43.9553 80 43.9553V32.2643C76.6961 32.2643 73.6185 31.2935 71.0383 29.6302Z", style: { fill: fillColor } }),
        React.createElement("path", { d: "M95.3 4.35001V95.65H4V4.35001H95.3M99.3 0.350006H0V99.65H99.3V0.350006V0.350006Z", style: { fill: fillColor } })));
}

function TwitterSquareOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#55ACEE' : color;
    return (React.createElement("svg", { name: "twitter", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M73.2,38.1c0,.52,0,1,0,1.56,0,15.83-12,34.06-34.06,34.06a33.83,33.83,0,0,1-18.39-5.37,25,25,0,0,0,2.89.15,24,24,0,0,0,14.87-5.12,12,12,0,0,1-11.2-8.3,15.2,15.2,0,0,0,2.26.18,12.59,12.59,0,0,0,3.15-.4,12,12,0,0,1-9.6-11.75V43a12.16,12.16,0,0,0,5.41,1.52,12,12,0,0,1-3.7-16A34,34,0,0,0,49.56,41a13.14,13.14,0,0,1-.3-2.74A12,12,0,0,1,70,30.06a23.61,23.61,0,0,0,7.6-2.89,11.9,11.9,0,0,1-5.27,6.59,23.63,23.63,0,0,0,6.9-1.85,25.6,25.6,0,0,1-6,6.19Z", style: { fill: fillColor } }),
        React.createElement("path", { d: "M95.65,4.35v91.3H4.35V4.35h91.3m4-4H.35v99.3h99.3V.35Z", style: { fill: fillColor } })));
}

function YelpSquareOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#ff1a1a' : color;
    return (React.createElement("svg", { name: "yelp", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("g", null,
            React.createElement("path", { d: "M40.46,59.08l3.2-.74.31-.08a3.56,3.56,0,0,0,2.11-1.59,3.51,3.51,0,0,0,.41-2.61V54a3.67,3.67,0,0,0-.54-1.19,4.27,4.27,0,0,0-1.31-1.12,11.5,11.5,0,0,0-1.85-.86l-3.5-1.28c-2-.73-3.93-1.44-5.92-2.14C32.08,47,31,46.57,30,46.27l-.54-.16a9.12,9.12,0,0,0-2.63-.5,3,3,0,0,0-1.32.24,3.5,3.5,0,0,0-1.16.82,6.26,6.26,0,0,0-.45.57c-.13.2-.25.41-.36.62a4.6,4.6,0,0,0-.31.72,18.06,18.06,0,0,0-1,6c0,1.84.06,4.19,1.07,5.79a3.37,3.37,0,0,0,1,1,4,4,0,0,0,2.19.62,11.25,11.25,0,0,0,3.31-.45l10.62-2.45Z", style: { fill: fillColor } }),
            React.createElement("path", { d: "M76.1,42.13a18.19,18.19,0,0,0-3.47-5,4.72,4.72,0,0,0-.59-.5,6.34,6.34,0,0,0-.6-.41,6.67,6.67,0,0,0-.66-.31,3.2,3.2,0,0,0-2.69.13A9.08,9.08,0,0,0,66,37.7l-.41.38c-.73.68-1.53,1.52-2.49,2.5-1.48,1.49-2.93,3-4.38,4.51l-2.59,2.69a11.42,11.42,0,0,0-1.29,1.58,4.64,4.64,0,0,0-.69,1.58,3.61,3.61,0,0,0,0,1.31l0,0A3.51,3.51,0,0,0,58.25,55l.32-.06,13.81-3.19a11.15,11.15,0,0,0,3.17-1,4,4,0,0,0,1.7-1.52,3.42,3.42,0,0,0,.41-1.35C77.87,45.92,76.89,43.78,76.1,42.13Z", style: { fill: fillColor } }),
            React.createElement("path", { d: "M51.38,47.93c1-1.25,1-3.13,1.09-4.66.3-5.12.62-10.24.87-15.36a53.54,53.54,0,0,0,.19-5.81c-.1-1.61-.11-3.46-1.13-4.78-1.79-2.34-5.62-2.15-8.24-1.78q-1.2.17-2.4.45c-.79.19-1.58.4-2.35.64-2.51.83-6,2.33-6.64,5.22-.33,1.64.47,3.31,1.08,4.8a53.5,53.5,0,0,0,2.71,5.14c2.47,4.49,5,9,7.5,13.43.74,1.33,1.56,3,3,3.71l.29.11a3.47,3.47,0,0,0,2,.14l.12,0a3.51,3.51,0,0,0,1.63-1A2.61,2.61,0,0,0,51.38,47.93Z", style: { fill: fillColor } }),
            React.createElement("path", { d: "M50.18,61.64a3.17,3.17,0,0,0-3.55-1.2,3.38,3.38,0,0,0-.44.18,4.12,4.12,0,0,0-.63.39,8.1,8.1,0,0,0-1.5,1.54,5.37,5.37,0,0,1-.35.45l-2.22,3.06c-1.26,1.71-2.5,3.42-3.73,5.17-.81,1.12-1.5,2.07-2,2.91-.11.16-.21.34-.31.48A9.35,9.35,0,0,0,34.18,77,3.18,3.18,0,0,0,34,78.41a3.53,3.53,0,0,0,.48,1.35,5.9,5.9,0,0,0,.43.59,4.18,4.18,0,0,0,.5.53,5.79,5.79,0,0,0,.61.5,19.33,19.33,0,0,0,5,2.43,17.62,17.62,0,0,0,4.54.87,7,7,0,0,0,.79,0c.24,0,.48-.06.72-.1s.48-.13.71-.21A3.52,3.52,0,0,0,49,83.58a3.22,3.22,0,0,0,.73-1.15,9.28,9.28,0,0,0,.54-2.66c0-.17,0-.38,0-.56.09-1,.13-2.18.19-3.56q.16-3.2.26-6.37l.15-3.77a9.13,9.13,0,0,0-.24-2.7A3.82,3.82,0,0,0,50.18,61.64Z", style: { fill: fillColor } }),
            React.createElement("path", { d: "M75.26,67.54A9.68,9.68,0,0,0,73.1,65.9l-.49-.29c-.86-.52-1.9-1.07-3.11-1.72-1.87-1-3.73-2-5.62-3l-3.32-1.76a3.06,3.06,0,0,1-.51-.26,8.46,8.46,0,0,0-2-.72,4.4,4.4,0,0,0-.73-.07,1.94,1.94,0,0,0-.48,0,3.17,3.17,0,0,0-2.66,2.63,3.85,3.85,0,0,0,0,1.27,8.79,8.79,0,0,0,1,2.53l1.78,3.33c1,1.88,2,3.75,3,5.61.66,1.22,1.21,2.26,1.73,3.12.1.16.21.33.29.48a9.67,9.67,0,0,0,1.65,2.16,3.16,3.16,0,0,0,1.16.71,3.27,3.27,0,0,0,1.42.16c.25,0,.49-.07.73-.12s.47-.14.69-.23a4.69,4.69,0,0,0,.72-.33,17.94,17.94,0,0,0,3.71-2.77,19.79,19.79,0,0,0,3.41-4.37,4.69,4.69,0,0,0,.33-.72,6.12,6.12,0,0,0,.22-.69,6.21,6.21,0,0,0,.13-.73A3.43,3.43,0,0,0,76,68.71,3.12,3.12,0,0,0,75.26,67.54Z", style: { fill: fillColor } })),
        React.createElement("path", { d: "M95.65,4.35v91.3H4.35V4.35h91.3m4-4H.35v99.3h99.3V.35Z", style: { fill: fillColor } })));
}

function YoutubeSquareOutlineIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#ff0000' : color;
    return (React.createElement("svg", { name: "youtube", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 99.3 99.3", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M76.93,36.42a7.05,7.05,0,0,0-5-5c-4.38-1.18-22-1.18-22-1.18s-17.58,0-22,1.18a7.05,7.05,0,0,0-5,5C21.89,40.83,21.89,50,21.89,50s0,9.21,1.18,13.62a7,7,0,0,0,5,4.92c4.38,1.18,22,1.18,22,1.18s17.58,0,22-1.18a7,7,0,0,0,5-4.92C78.11,59.25,78.11,50,78.11,50S78.11,40.83,76.93,36.42Zm-32.68,22V41.68L58.94,50,44.25,58.4Z", style: { fill: fillColor } }),
        React.createElement("polygon", { points: "44.25 58.4 44.25 41.68 58.94 50.04 44.25 58.4 44.25 58.4", style: { fill: '#ffffff' } }),
        React.createElement("path", { d: "M95.3,4V95.3H4V4H95.3m4-4H0V99.3H99.3V0Z", style: { fill: fillColor } })));
}

function FacebookSquareSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#3B5998' : color;
    return (React.createElement("svg", { name: "facebook", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("rect", { width: "100", height: "100", style: { fill: fillColor } }),
        React.createElement("path", { d: "M37.82,36.74V47.5H29.94V60.66h7.89v39.1H54V60.67H64.88s1-6.32,1.5-13.21H54.06v-9a3.85,3.85,0,0,1,3.53-3.17h8.83V21.61h-12C37.42,21.61,37.82,34.78,37.82,36.74Z", style: { fill: '#ffffff' } })));
}

function GooglePlusSquareSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#DC4E41' : color;
    return (React.createElement("svg", { name: "googleplus", version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 455.73 455.73", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { style: { fill: fillColor }, d: "M0,0v455.73h455.73V0H0z M265.67,247.037c-7.793,51.194-45.961,80.543-95.376,80.543c-55.531,0-100.552-45.021-100.552-100.552c0-55.517,45.021-100.538,100.552-100.538c26.862,0,50.399,9.586,67.531,26.226l-28.857,28.857c-9.773-9.846-23.147-15.094-38.674-15.094c-32.688,0-59.189,27.874-59.189,60.548c0,32.703,26.501,59.768,59.189,59.768c27.397,0,48.144-13.243,54.129-39.758h-54.129v-40.38h95.131c1.142,6.506,1.72,13.315,1.72,20.37C267.144,234.025,266.638,240.69,265.67,247.037z M386.419,234.517h-35.233v35.218H326.16v-35.218h-35.233v-25.041h35.233v-35.233h25.026v35.233h35.233V234.517z" })));
}

function InstagramSquareSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#ff0075' : color;
    return (React.createElement("svg", { name: "instagram", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("rect", { width: "100", height: "100", style: { fill: fillColor } }),
        React.createElement("path", { d: "M51.19,32.34A17.66,17.66,0,1,0,68.85,50,17.63,17.63,0,0,0,51.19,32.34Zm0,29.14A11.48,11.48,0,1,1,62.67,50,11.5,11.5,0,0,1,51.19,61.48ZM73.7,31.61a4.12,4.12,0,1,1-4.12-4.12A4.11,4.11,0,0,1,73.7,31.61Zm11.7,4.18c-.26-5.51-1.52-10.4-5.57-14.43s-8.91-5.29-14.43-5.57c-5.69-.32-22.74-.32-28.43,0-5.5.26-10.39,1.53-14.44,5.55S17.25,30.26,17,35.78c-.32,5.69-.32,22.74,0,28.43.26,5.51,1.52,10.4,5.56,14.43S31.45,83.93,37,84.21c5.69.32,22.74.32,28.43,0,5.52-.26,10.4-1.53,14.43-5.57s5.29-8.92,5.57-14.43c.32-5.69.32-22.73,0-28.42ZM78.05,70.31a11.65,11.65,0,0,1-6.55,6.55c-4.54,1.8-15.3,1.38-20.31,1.38s-15.79.4-20.31-1.38a11.65,11.65,0,0,1-6.55-6.55C22.53,65.77,23,55,23,50s-.4-15.79,1.38-20.31a11.65,11.65,0,0,1,6.55-6.55c4.54-1.8,15.3-1.38,20.31-1.38S67,21.36,71.5,23.14a11.65,11.65,0,0,1,6.55,6.55C79.85,34.23,79.43,45,79.43,50S79.85,65.79,78.05,70.31Z", style: { fill: '#ffffff' } })));
}

function LinkedinSquareSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#007AB9' : color;
    return (React.createElement("svg", { name: "linkedin", version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("rect", { x: "0", y: "0", width: "100", height: "100", style: { fill: fillColor } }),
        React.createElement("path", { d: "M32.27,81.84H19.08V39.39H32.27Zm-6.6-48.25a7.67,7.67,0,1,1,7.63-7.7A7.7,7.7,0,0,1,25.67,33.59ZM81.61,81.84H68.45V61.17c0-4.92-.1-11.24-6.85-11.24s-7.91,5.35-7.91,10.89v21H40.52V39.39H53.17v5.79h.18c1.76-3.34,6.06-6.86,12.48-6.86,13.34,0,15.79,8.79,15.79,20.2V81.84Z", style: { fill: '#ffffff' } })));
}

function PinterestSquareSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#CB2027' : color;
    return (React.createElement("svg", { name: "pinterest", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("rect", { width: "100", height: "100", style: { fill: fillColor } }),
        React.createElement("path", { d: "M53.62,9.8c-16.55,0-32.9,11-32.9,28.88C20.72,50,27.1,56.49,31,56.49c1.6,0,2.52-4.45,2.52-5.71,0-1.5-3.82-4.69-3.82-10.93,0-13,9.87-22.16,22.64-22.16,11,0,19.11,6.24,19.11,17.7C71.42,44,68,60,56.86,60A7.15,7.15,0,0,1,49.41,53c0-6.1,4.25-12,4.25-18.29,0-10.68-15.14-8.74-15.14,4.16A19,19,0,0,0,40.07,47c-2.23,9.58-6.77,23.85-6.77,33.72,0,3,.43,6,.72,9.09.55.62.28.55,1.11.24C43.26,78.94,43,76.76,46.65,62.2c2,3.77,7.11,5.8,11.17,5.8C75,68,82.64,51.31,82.64,36.27,82.64,20.25,68.81,9.8,53.62,9.8Z", style: { fill: '#ffffff' } })));
}

function TiktokSquareSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#000000' : color;
    return (React.createElement("svg", { name: "tiktok", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("path", { d: "M100 0H0V100H100V0Z", style: { fill: fillColor } }),
        React.createElement("path", { d: "M71.0383 29.6302C67.3323 27.2414 64.6568 23.4208 63.8228 18.9667C63.6424 18.0039 63.5436 17.0139 63.5436 16H51.7146L51.695 62.8525C51.4963 68.099 47.1275 72.3102 41.7707 72.3102C40.1061 72.3102 38.538 71.8992 37.1583 71.1805C33.9934 69.5342 31.8279 66.2552 31.8279 62.4823C31.8279 57.0632 36.2887 52.6545 41.7707 52.6545C42.7942 52.6545 43.7753 52.8214 44.7047 53.1087V41.1736C43.7431 41.0441 42.7667 40.9635 41.7707 40.9635C29.767 40.9647 20 50.6176 20 62.4823C20 69.7624 23.6807 76.2045 29.2948 80.1C32.8308 82.5535 37.133 84 41.7718 84C53.7766 84 63.5436 74.347 63.5436 62.4823V38.7246C68.1824 42.016 73.8666 43.9553 80 43.9553V32.2643C76.6961 32.2643 73.6185 31.2935 71.0383 29.6302Z", fill: "white" })));
}

function TwitterSquareSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#55ACEE' : color;
    return (React.createElement("svg", { name: "twitter", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("rect", { width: "100", height: "100", style: { fill: fillColor } }),
        React.createElement("path", { d: "M76.24,36.52c0,.59,0,1.18,0,1.77,0,17.92-13.64,38.58-38.58,38.58a38.33,38.33,0,0,1-20.82-6.09,27.12,27.12,0,0,0,3.27.17A27.18,27.18,0,0,0,37,65.16a13.59,13.59,0,0,1-12.68-9.41,16.58,16.58,0,0,0,2.56.21,14.55,14.55,0,0,0,3.57-.46A13.56,13.56,0,0,1,19.56,42.19V42a13.61,13.61,0,0,0,6.13,1.72,13.59,13.59,0,0,1-4.2-18.13,38.56,38.56,0,0,0,28,14.19,15.35,15.35,0,0,1-.34-3.11,13.58,13.58,0,0,1,23.47-9.28,26.94,26.94,0,0,0,8.61-3.27,13.51,13.51,0,0,1-6,7.47A27,27,0,0,0,83,29.51a28.84,28.84,0,0,1-6.8,7Z", style: { fill: '#ffffff' } })));
}

function YelpSquareSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#ff1a1a' : color;
    return (React.createElement("svg", { name: "yelp", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("rect", { width: "100", height: "100", style: { fill: fillColor } }),
        React.createElement("g", null,
            React.createElement("path", { d: "M40.46,58.74l3.2-.74.31-.08a3.56,3.56,0,0,0,2.11-1.59,3.51,3.51,0,0,0,.41-2.61v-.06a3.77,3.77,0,0,0-.54-1.19,4.38,4.38,0,0,0-1.31-1.11,11.5,11.5,0,0,0-1.85-.86l-3.5-1.28c-2-.73-3.93-1.44-5.92-2.14-1.28-.46-2.37-.86-3.32-1.15l-.54-.17a9.48,9.48,0,0,0-2.63-.5,3.32,3.32,0,0,0-1.32.24,3.5,3.5,0,0,0-1.16.82q-.24.28-.45.57c-.13.21-.25.41-.36.63a4.93,4.93,0,0,0-.31.71,18.12,18.12,0,0,0-1,6c0,1.83.06,4.19,1.07,5.78a3.29,3.29,0,0,0,1,1,4.06,4.06,0,0,0,2.19.62,11.25,11.25,0,0,0,3.31-.45l10.62-2.45Z", style: { fill: '#ffffff' } }),
            React.createElement("path", { d: "M76.1,41.78a18.14,18.14,0,0,0-3.47-4.94,5.84,5.84,0,0,0-.59-.51,6.25,6.25,0,0,0-.6-.4,6.72,6.72,0,0,0-.66-.32,3.45,3.45,0,0,0-1.39-.23,3.14,3.14,0,0,0-1.3.37A9.27,9.27,0,0,0,66,37.35l-.41.39c-.73.68-1.53,1.52-2.49,2.49-1.48,1.5-2.93,3-4.38,4.52l-2.59,2.69A11.42,11.42,0,0,0,54.79,49a4.56,4.56,0,0,0-.69,1.58,3.55,3.55,0,0,0,0,1.3l0,.06a3.46,3.46,0,0,0,1.51,2.16,3.52,3.52,0,0,0,2.59.51l.32-.06,13.81-3.19a11.47,11.47,0,0,0,3.17-1.05,4,4,0,0,0,1.7-1.52,3.42,3.42,0,0,0,.41-1.35C77.87,45.57,76.89,43.44,76.1,41.78Z", style: { fill: '#ffffff' } }),
            React.createElement("path", { d: "M51.38,47.59c1-1.26,1-3.13,1.09-4.66.3-5.12.62-10.24.87-15.36a53.62,53.62,0,0,0,.19-5.81c-.1-1.61-.11-3.46-1.13-4.79-1.79-2.33-5.62-2.14-8.24-1.78q-1.2.17-2.4.45c-.79.2-1.58.4-2.35.65-2.51.82-6,2.33-6.64,5.22-.33,1.64.47,3.31,1.08,4.8a53.5,53.5,0,0,0,2.71,5.14c2.47,4.49,5,9,7.5,13.43.74,1.33,1.56,3,3,3.71l.29.11a3.55,3.55,0,0,0,2,.14l.12,0a3.51,3.51,0,0,0,1.63-1Z", style: { fill: '#ffffff' } }),
            React.createElement("path", { d: "M50.18,61.29a3.13,3.13,0,0,0-1.58-1.17,3.09,3.09,0,0,0-2,0,3.38,3.38,0,0,0-.44.18,4.12,4.12,0,0,0-.63.39,8.1,8.1,0,0,0-1.5,1.54,5.37,5.37,0,0,1-.35.45l-2.22,3q-1.89,2.57-3.73,5.17C37,72,36.26,73,35.71,73.8c-.11.16-.21.34-.31.48a9.19,9.19,0,0,0-1.22,2.42A3.14,3.14,0,0,0,34,78.06a3.42,3.42,0,0,0,.48,1.35A5,5,0,0,0,35,80a5,5,0,0,0,.5.53,5.79,5.79,0,0,0,.61.5,19.3,19.3,0,0,0,5,2.42,17.62,17.62,0,0,0,4.54.87,5.21,5.21,0,0,0,.79,0c.24,0,.48-.06.72-.11a5.75,5.75,0,0,0,.71-.2A3.52,3.52,0,0,0,49,83.24a3.31,3.31,0,0,0,.73-1.15,9.28,9.28,0,0,0,.54-2.66c0-.17,0-.38,0-.57.09-1,.13-2.17.19-3.56q.16-3.18.26-6.36l.15-3.78a9.16,9.16,0,0,0-.24-2.7A3.93,3.93,0,0,0,50.18,61.29Z", style: { fill: '#ffffff' } }),
            React.createElement("path", { d: "M75.26,67.2a9.68,9.68,0,0,0-2.16-1.64c-.15-.09-.32-.2-.49-.29-.86-.52-1.9-1.07-3.11-1.73-1.87-1-3.73-2-5.62-3l-3.32-1.76a3.06,3.06,0,0,1-.51-.26,8.46,8.46,0,0,0-2-.72,4.41,4.41,0,0,0-.73-.08,3.87,3.87,0,0,0-.48,0,3.3,3.3,0,0,0-1.76.89,3.18,3.18,0,0,0-.9,1.75,3.86,3.86,0,0,0,0,1.27,8.91,8.91,0,0,0,1,2.53l1.78,3.33c1,1.88,2,3.75,3,5.61.66,1.21,1.21,2.25,1.73,3.12.1.16.21.33.29.48a9.67,9.67,0,0,0,1.65,2.16,3.16,3.16,0,0,0,1.16.71,3.42,3.42,0,0,0,1.42.16,5.86,5.86,0,0,0,.73-.13c.23-.06.47-.14.69-.22a7.89,7.89,0,0,0,.72-.33,17.64,17.64,0,0,0,3.71-2.78,19.5,19.5,0,0,0,3.41-4.36,4.69,4.69,0,0,0,.33-.72,5.68,5.68,0,0,0,.22-.7,6,6,0,0,0,.13-.72A3.41,3.41,0,0,0,76,68.37,3.12,3.12,0,0,0,75.26,67.2Z", style: { fill: '#ffffff' } }))));
}

function YoutubeSquareSolidIcon(props) {
    const { size, color } = props;
    const fillColor = color === 'default' ? '#C4302B' : color;
    return (React.createElement("svg", { name: "youtube", version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 100 100", style: {
            width: `${size}px`,
            height: `${size}px`,
        } },
        React.createElement("rect", { width: "100", height: "100", style: { fill: fillColor } }),
        React.createElement("path", { d: "M81.1,34.24a8.21,8.21,0,0,0-5.78-5.81c-5.08-1.37-25.49-1.37-25.49-1.37s-20.41,0-25.5,1.37a8.18,8.18,0,0,0-5.77,5.81c-1.37,5.12-1.37,15.81-1.37,15.81s0,10.68,1.37,15.81a8.07,8.07,0,0,0,5.77,5.71c5.09,1.37,25.5,1.37,25.5,1.37s20.41,0,25.49-1.37a8.1,8.1,0,0,0,5.78-5.71c1.36-5.13,1.36-15.81,1.36-15.81S82.46,39.36,81.1,34.24ZM43.15,59.75V40.34l17.06,9.71-17.06,9.7Z", style: { fill: '#ffffff' } })));
}

function SocialMediaIcon(props) {
    const { site, type, size, color } = props;
    switch (type) {
        case 'block':
            switch (site) {
                case 'facebook':
                    return React.createElement(FacebookBlockIcon, { size: size, color: color });
                case 'google-plus':
                    return React.createElement(GooglePlusBlockIcon, { size: size, color: color });
                case 'instagram':
                    return React.createElement(InstagramBlockIcon, { size: size, color: color });
                case 'linkedin':
                    return React.createElement(LinkedinBlockIcon, { size: size, color: color });
                case 'pinterest':
                    return React.createElement(PinterestBlockIcon, { size: size, color: color });
                case 'tiktok':
                    return React.createElement(TiktokBlockIcon, { size: size, color: color });
                case 'twitter':
                    return React.createElement(TwitterBlockIcon, { size: size, color: color });
                case 'yelp':
                    return React.createElement(YelpBlockIcon, { size: size, color: color });
                case 'youtube':
                    return React.createElement(YoutubeBlockIcon, { size: size, color: color });
                default:
                    return null;
            }
        case 'circle-outline':
            switch (site) {
                case 'facebook':
                    return React.createElement(FacebookCircleOutlineIcon, { size: size, color: color });
                case 'instagram':
                    return React.createElement(InstagramCircleOutlineIcon, { size: size, color: color });
                case 'linkedin':
                    return React.createElement(LinkedinCircleOutlineIcon, { size: size, color: color });
                case 'pinterest':
                    return React.createElement(PinterestCircleOutlineIcon, { size: size, color: color });
                case 'tiktok':
                    return React.createElement(TiktokCircleOutlineIcon, { size: size, color: color });
                case 'twitter':
                    return React.createElement(TwitterCircleOutlineIcon, { size: size, color: color });
                case 'yelp':
                    return React.createElement(YelpCircleOutlineIcon, { size: size, color: color });
                case 'youtube':
                    return React.createElement(YoutubeCircleOutlineIcon, { size: size, color: color });
                default:
                    return null;
            }
        case 'circle-solid':
            switch (site) {
                case 'facebook':
                    return React.createElement(FacebookCircleSolidIcon, { size: size, color: color });
                case 'google-plus':
                    return React.createElement(GooglePlusCircleSolidIcon, { size: size, color: color });
                case 'instagram':
                    return React.createElement(InstagramCircleSolidIcon, { size: size, color: color });
                case 'linkedin':
                    return React.createElement(LinkedinCircleSolidIcon, { size: size, color: color });
                case 'pinterest':
                    return React.createElement(PinterestCircleSolidIcon, { size: size, color: color });
                case 'tiktok':
                    return React.createElement(TiktokCircleSolidIcon, { size: size, color: color });
                case 'twitter':
                    return React.createElement(TwitterCircleSolidIcon, { size: size, color: color });
                case 'yelp':
                    return React.createElement(YelpCircleSolidIcon, { size: size, color: color });
                case 'youtube':
                    return React.createElement(YoutubeCircleSolidIcon, { size: size, color: color });
                default:
                    return null;
            }
        case 'square-outline':
            switch (site) {
                case 'facebook':
                    return React.createElement(FacebookSquareOutlineIcon, { size: size, color: color });
                case 'instagram':
                    return React.createElement(InstagramSquareOutlineIcon, { size: size, color: color });
                case 'linkedin':
                    return React.createElement(LinkedinSquareOutlineIcon, { size: size, color: color });
                case 'pinterest':
                    return React.createElement(PinterestSquareOutlineIcon, { size: size, color: color });
                case 'tiktok':
                    return React.createElement(TiktokSquareOutlineIcon, { size: size, color: color });
                case 'twitter':
                    return React.createElement(TwitterSquareOutlineIcon, { size: size, color: color });
                case 'yelp':
                    return React.createElement(YelpSquareOutlineIcon, { size: size, color: color });
                case 'youtube':
                    return React.createElement(YoutubeSquareOutlineIcon, { size: size, color: color });
                default:
                    return null;
            }
        case 'square-solid':
            switch (site) {
                case 'facebook':
                    return React.createElement(FacebookSquareSolidIcon, { size: size, color: color });
                case 'google-plus':
                    return React.createElement(GooglePlusSquareSolidIcon, { size: size, color: color });
                case 'instagram':
                    return React.createElement(InstagramSquareSolidIcon, { size: size, color: color });
                case 'linkedin':
                    return React.createElement(LinkedinSquareSolidIcon, { size: size, color: color });
                case 'pinterest':
                    return React.createElement(PinterestSquareSolidIcon, { size: size, color: color });
                case 'tiktok':
                    return React.createElement(TiktokSquareSolidIcon, { size: size, color: color });
                case 'twitter':
                    return React.createElement(TwitterSquareSolidIcon, { size: size, color: color });
                case 'yelp':
                    return React.createElement(YelpSquareSolidIcon, { size: size, color: color });
                case 'youtube':
                    return React.createElement(YoutubeSquareSolidIcon, { size: size, color: color });
                default:
                    return null;
            }
        default:
            return null;
    }
}

const socialMedia = [
    { type: 'facebook', query: 'default/facebook' },
    { type: 'twitter', query: 'default/twitter' },
    { type: 'instagram', query: 'default/instagram' },
    { type: 'linkedin', query: 'default/linkedin' },
    { type: 'pinterest', query: 'default/pinterest' },
    { type: 'youtube', query: 'default/youtube' },
    { type: 'yelp', query: 'default/yelp' },
    { type: 'tiktok', query: 'default/tiktok' },
    { type: 'google-plus', query: 'default/googleplus' },
];
const createJustifiedElements = (mode, element) => {
    switch (mode.type) {
        case 'REACT': {
            return socialMedia.reduce((p, c) => mode.signatureData[c.query.indexOf('default/') === 0 && !mode.signatureData[c.query]
                ? mode.signatureData[c.query.replace('default/', '')]
                    ? c.query.replace('default/', '')
                    : c.query
                : c.query]
                ? p.concat(React.createElement("td", { className: 'alignCenter', style: { textAlign: 'center', paddingTop: '16px' } },
                    React.createElement(SocialMediaIcon, Object.assign({ key: c.type }, element, { site: c.type, type: element.iconPack }))))
                : p, []);
        }
        case 'XSLT': {
            return socialMedia.map((x) => (React.createElement("span", { key: `SMI${x.query.indexOf('default/') === -1 ? `default/${x.query}` : x.query}`, className: `XSLT XSLT_if_account/${x.query.indexOf('default/') === -1 ? `default/${x.query}` : x.query}` },
                React.createElement("td", { className: 'alignCenter', style: { textAlign: 'center', paddingTop: '16px' } },
                    React.createElement("a", { href: `XSLT_valueof_account/${x.query.indexOf('default/') === -1
                            ? `default/${x.query}`
                            : x.query}`, target: '_blank' },
                        React.createElement(SocialMediaIcon, Object.assign({}, element, { site: x.type, type: element.iconPack })))))));
        }
        default:
            return null;
    }
};
const createNormalElements = (mode, element) => {
    switch (mode.type) {
        case 'REACT': {
            return socialMedia.reduce((p, c) => mode.signatureData[c.query.indexOf('default/') === 0 && !mode.signatureData[c.query]
                ? mode.signatureData[c.query.replace('default/', '')]
                    ? c.query.replace('default/', '')
                    : c.query
                : c.query]
                ? p.concat(React.createElement("td", { key: `SMI-${c.query.indexOf('default/') === -1
                        ? `default/${c.query}`
                        : c.query}`, style: { padding: '16px 8px 0 0' } },
                    React.createElement(SocialMediaIcon, Object.assign({}, element, { site: c.type, type: element.iconPack }))))
                : p, []);
        }
        case 'XSLT': {
            return socialMedia.map((x) => (React.createElement("span", { key: `SMI${x.query.indexOf('default/') === -1 ? `default/${x.query}` : x.query}`, className: `XSLT XSLT_if_account/${x.query.indexOf('default/') === -1 ? `default/${x.query}` : x.query}` },
                React.createElement("td", { style: { padding: '16px 8px 0 0' } },
                    React.createElement("a", { href: `XSLT_valueof_account/${x.query.indexOf('default/') === -1
                            ? `default/${x.query}`
                            : x.query}`, "data-tracking": `${x.type}`, target: '_blank' },
                        React.createElement(SocialMediaIcon, Object.assign({}, element, { site: x.type, type: element.iconPack })))))));
        }
        default:
            return null;
    }
};
function SocialMedia(props) {
    const { element, mode } = props;
    switch (element.alignment) {
        case 'justify': {
            return (React.createElement("table", { className: 'noBorder', "data-width": '100%', cellPadding: 0, cellSpacing: 0, style: { width: '100%' } },
                React.createElement("tr", { style: { textAlign: 'center' } },
                    React.createElement("td", null,
                        React.createElement("table", { role: 'presentation', cellSpacing: 0, cellPadding: 0, className: 'noBorder', "data-width": '100%', style: { width: '100%' } },
                            React.createElement("tr", null, createJustifiedElements(mode, element)))))));
        }
        case 'left': {
            return (React.createElement("table", { role: 'presentation', "data-width": '100%', cellPadding: 0, cellSpacing: 0, className: 'noBorder pushTableLeft alignLeft', style: { maxWidth: '660px', width: '100%' } },
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("table", { role: 'presentation', cellPadding: 0, cellSpacing: 0, className: 'noBorder pushTableLeft' },
                            React.createElement("tr", null, createNormalElements(mode, element)))))));
        }
        case 'right': {
            return (React.createElement("table", { role: 'presentation', "data-width": '100%', cellPadding: 0, cellSpacing: 0, className: 'noBorder pushTableLeft alignRight', style: { maxWidth: '660px', width: '100%' } },
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("table", { role: 'presentation', cellPadding: 0, cellSpacing: 0, className: 'noBorder pushTableRight alignRight' },
                            React.createElement("tr", null, createNormalElements(mode, element)))))));
        }
        case 'center': {
            return (React.createElement("table", { role: 'presentation', "data-width": '100%', cellPadding: 0, cellSpacing: 0, className: 'noBorder pushTableLeft alignCenter', style: { maxWidth: '660px', width: '100%' } },
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("table", { role: 'presentation', style: { textAlign: 'center' }, cellPadding: 0, cellSpacing: 0, className: 'noBorder alignCenter' },
                            React.createElement("tr", null, createNormalElements(mode, element)))))));
        }
        default:
            return null;
    }
}

function customText(props) {
    const { element } = props;
    const maxWidth = element.profileImage
        ? `${maxTemplateComponentWidth - (element.profileImage.width + 24) - 5}px`
        : '100%';
    return {
        component: React.createElement(CustomText, Object.assign({}, props)),
        wrapperStyle: {
            display: 'inline-block',
            // minWidth: "320px",
            width: '100%',
            maxWidth,
            verticalAlign: (element.profileImage && element.profileImage.verticalAlignment) ||
                'top',
        },
    };
}
function CustomText(props) {
    const { mode, element } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", { style: {
                    fontFamily: getFontHtmlCode(element.fontFamily),
                } },
                element.customSignature &&
                    (mode.type === 'REACT' ? (React.createElement("span", { dangerouslySetInnerHTML: {
                            __html: transformXslt(element.customSignature.xslt, convertSignatureDataToXml(mode.signatureData)),
                        } })) : (React.createElement("span", { dangerouslySetInnerHTML: {
                            __html: element.customSignature.xslt,
                        } }))),
                element.socialMedia ? (React.createElement(SocialMedia, { element: element.socialMedia, mode: mode })) : null))));
}

function BlockItem(props) {
    const { mode, query, style } = props;
    const LegacySignatureData = {
        ['[Division]']: '',
        ['[Phone 1]']: '[Phone number]',
        ['[Phone 2]']: '',
        ['[Phone 3]']: '',
    };
    switch (mode.type) {
        case 'XSLT': {
            let queryData = query;
            if (query.indexOf('default/') === -1 &&
                query.indexOf('emailAccount/') === -1) {
                queryData = `default/${query}`;
            }
            return (React.createElement("span", { className: `XSLT XSLT_if_account/${queryData}` },
                React.createElement("div", { style: style },
                    React.createElement("span", { className: `XSLT XSLT_valueof_account/${queryData}` })),
                props.children));
        }
        case 'REACT': {
            let queryData = query;
            if (query.indexOf('emailAccount/') === -1 &&
                query.indexOf('default/') === 0 &&
                !mode.signatureData[query]) {
                queryData = mode.signatureData[query.replace('default/', '')]
                    ? query.replace('default/', '')
                    : query;
            }
            if (!mode.signatureData[queryData]) {
                return null;
            }
            const res = LegacySignatureData[mode.signatureData[queryData]];
            if (res === '') {
                return null;
            }
            return (React.createElement("div", { style: style }, res ? res : mode.signatureData[queryData]));
        }
        default: {
            return null;
        }
    }
}

function defaultText(props) {
    const { element } = props;
    const maxWidth = element.profileImage
        ? `${maxTemplateComponentWidth - (element.profileImage.width + 24) - 5}px`
        : '100%';
    return {
        component: React.createElement(DefaultText, Object.assign({}, props)),
        wrapperStyle: {
            display: 'inline-block',
            // minWidth: "320px",
            width: '100%',
            maxWidth,
            verticalAlign: (element.profileImage && element.profileImage.verticalAlignment) ||
                'top',
        },
    };
}
function DefaultText(props) {
    const { mode, element } = props;
    const ss = {
        primary: {
            lineHeight: `${element.fontSize + 6}px`,
            fontFamily: getFontHtmlCode(element.fontFamily),
            fontSize: element.fontSize + 2,
            fontWeight: 'bold',
            color: element.fontPrimaryColour,
        },
        secondary: {
            lineHeight: `${element.fontSize + 4}px`,
            fontFamily: getFontHtmlCode(element.fontFamily),
            fontSize: element.fontSize,
            color: element.fontSecondaryColour,
        },
    };
    const firstSet = [
        {
            query: 'default/name',
            style: ss.primary,
        },
        {
            query: 'default/position',
            style: ss.secondary,
        },
        {
            query: 'default/division',
            style: ss.secondary,
        },
        {
            query: 'default/workphone',
            style: ss.secondary,
        },
        {
            query: 'default/mobilephone',
            style: ss.secondary,
        },
        {
            query: 'default/homephone',
            style: ss.secondary,
        },
        {
            query: 'default/fax',
            style: ss.secondary,
        },
        {
            query: 'default/skype',
            style: ss.secondary,
        },
    ];
    const secondSet = [
        {
            query: 'default/orgname',
            style: ss.primary,
        },
        {
            query: 'default/physicaladdress',
            style: ss.secondary,
        },
        {
            query: 'default/physicaladdresscity',
            style: ss.secondary,
        },
        {
            query: 'default/physicaladdressstate',
            style: ss.secondary,
        },
        {
            query: 'default/physicaladdresspostcode',
            style: ss.secondary,
        },
        {
            query: 'default/physicaladdresscountry',
            style: ss.secondary,
        },
        {
            query: 'default/postaladdress',
            style: ss.secondary,
        },
        {
            query: 'default/postaladdresscity',
            style: ss.secondary,
        },
        {
            query: 'default/postaladdressstate',
            style: ss.secondary,
        },
        {
            query: 'default/postaladdresspostcode',
            style: ss.secondary,
        },
        {
            query: 'default/postaladdresscountry',
            style: ss.secondary,
        },
        {
            query: 'default/website',
            style: ss.secondary,
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", { style: {
                    fontFamily: getFontHtmlCode(element.fontFamily),
                } },
                firstSet.map((item, index) => {
                    return (React.createElement(BlockItem, { key: index, style: item.style, query: item.query, mode: mode }));
                }),
                React.createElement("div", { style: ss.primary, dangerouslySetInnerHTML: { __html: '&#160;&#8204;' } }),
                secondSet.map((item, index) => {
                    return (React.createElement(BlockItem, { key: index, style: item.style, query: item.query, mode: mode }));
                }),
                element.socialMedia ? (React.createElement(SocialMedia, { element: element.socialMedia, mode: mode })) : null))));
}

function ProfileImage(props) {
    const { mode, alignment, width, height, direction } = props;
    const divStyle = {
        display: 'inline-block',
        maxWidth: `${width + 24}px`,
        width: '100%',
    };
    const spacingStyle = {
        padding: direction === 'rtl' ? '0 0 0 24px' : '0 24px 0 0',
    };
    switch (mode.type) {
        case 'REACT':
            const url = mode.signatureData['default/profileimage'] === '' ||
                mode.signatureData['default/profileimage'] === undefined
                ? mode.signatureData.profileimage
                : mode.signatureData['default/profileimage'];
            if (!url) {
                return null;
            }
            return (React.createElement("div", { style: { ...divStyle, verticalAlign: alignment }, className: 'stack-profile' },
                React.createElement("table", { role: 'presentation', cellSpacing: 0, cellPadding: 0, className: `noBorder`, "data-width": '100%', style: { width: '100%' } },
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { style: { ...spacingStyle, verticalAlign: alignment }, className: `vAlign${alignment.charAt(0).toUpperCase() + alignment.slice(1)} ${direction === 'rtl'
                                    ? 'padding-top'
                                    : 'padding-bottom padding-strip'}` },
                                React.createElement("img", { src: url, width: width, height: height, alt: '' })))))));
        case 'XSLT':
            return (React.createElement("span", { className: 'XSLT XSLT_if_account/default/profileimage' },
                React.createElement("div", { style: { ...divStyle, verticalAlign: alignment }, className: 'stack-profile' },
                    React.createElement("table", { role: 'presentation', cellSpacing: 0, cellPadding: 0, className: `noBorder`, "data-width": '100%', style: { width: '100%' } },
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("td", { style: { ...spacingStyle, verticalAlign: alignment }, className: `vAlign${alignment.charAt(0).toUpperCase() + alignment.slice(1)} ${direction === 'rtl'
                                        ? 'padding-top'
                                        : 'padding-bottom padding-strip'}` },
                                    React.createElement("img", { src: 'XSLT_valueof_account/default/profileimage', width: width, height: height, className: 'noBorder', alt: 'XSLT_valueof_account/default/name' }))))))));
        default:
            return null;
    }
}

function Signature(props) {
    const { mode, element, templateStyle, isDisclaimerNextActive } = props;
    const layout = !props.layout ? { type: 'DefaultSignature' } : props.layout;
    const direction = element.profileImage && element.profileImage.horizontalAlignment === 'left'
        ? 'ltr'
        : 'rtl';
    const vAlign = element.profileImage
        ? element.profileImage.verticalAlignment
        : '';
    const bgColour = getBackgroundColour(templateStyle, element.backgroundColour);
    const bgClass = mode.type === 'XSLT' ? `TMPL TMPL_BGCOLOUR_${bgColour}` : '';
    const bgStyle = mode.type === 'REACT' ? { background: bgColour } : undefined;
    const cleanProps = { ...props, layout };
    const pImage = element.profileImage && element.profileImage.width
        ? element.profileImage.width
        : 100;
    const profileSpace = pImage <= 100 ? 80 : 80 - (pImage - 100) / 8;
    const rightCell = direction === 'rtl' && element.profileImage
        ? `width="${profileSpace}%"`
        : `width="${getProfileText(props)
            .wrapperStyle.maxWidth.toString()
            .replace('px', '')}"`;
    // changed to flat value instead of looking at the custom signature
    return (React.createElement("td", { className: `alignCenter vAlignTop ${bgClass} ${isDisclaimerNextActive ? 'disclaimer-bottom' : 'padding-bottom'}`, "data-height": '100%', "data-width": '100%', style: {
            ...bgStyle,
            width: '100%',
            height: '100%',
            padding: `0 24px ${getCorrectSpacing(isDisclaimerNextActive, templateStyle.spacing)}px`,
        } },
        React.createElement(HtmlComment, { mode: mode }, `[if mso]><table role="presentation" border="0" cellspacing="0" cellpadding="0" align="left"><tr><td align="center" valign="top" width="${maxTemplateComponentWidth}" style="padding: 0 24px 0 0"><![endif]`),
        React.createElement("table", { role: 'presentation', className: 'noBorder pushTableLeft alignLeft', cellPadding: 0, cellSpacing: 0, "data-width": '100%', style: {
                maxWidth: `${maxTemplateComponentWidth}px`,
                textAlign: 'left',
                width: '100%',
            } },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { className: 'vAlignTop', style: { fontSize: '0' } },
                        element.profileImage && direction === 'ltr' ? (React.createElement(React.Fragment, null,
                            React.createElement("span", { className: 'XSLT XSLT_if_account/default/profileimage' },
                                React.createElement(HtmlComment, { mode: mode }, `[if mso]><table role="presentation" border="0" cellspacing="0" cellpadding="0" align="left" style="display:inline-block;"><tr><![endif]`),
                                React.createElement(HtmlComment, { mode: mode }, `[if mso]><td align="left" width="300" style="width:300px" valign="${vAlign}"><![endif]`)),
                            React.createElement("span", { className: 'XSLT XSLT_if_not_account/default/profileimage' },
                                React.createElement(HtmlComment, { mode: mode }, `[if mso]><table role="presentation" border="0" cellspacing="0" cellpadding="0" align="left" style=""><tr><td align="left" valign="${vAlign}" ${element.profileImage ? rightCell : ''}><![endif]`)))) : (React.createElement(HtmlComment, { mode: mode }, `[if mso]><table role="presentation" border="0" cellspacing="0" cellpadding="0" align="left" style="display:inline-block;"><tr><td align="left" valign="${vAlign}" ${element.profileImage ? rightCell : ''}><![endif]`)),
                        getColumnItem(direction, cleanProps, 'left'),
                        getColumnItem(direction, cleanProps, 'right'),
                        React.createElement(HtmlComment, { mode: mode }, `[if mso]></tr></table><![endif]`))))),
        React.createElement(HtmlComment, { mode: mode }, `[if mso]></td></tr></table><![endif]`)));
}
function getColumnItem(direction, props, column) {
    switch (column) {
        case 'left':
            switch (direction) {
                case 'ltr':
                    return getProfileImage(props);
                case 'rtl':
                    return getProfileDetails(props);
                default:
                    return null;
            }
        case 'right':
            switch (direction) {
                case 'ltr':
                    return getProfileDetails(props);
                case 'rtl':
                    return getProfileImage(props);
                default:
                    return null;
            }
        default:
            return null;
    }
}
function getProfileDetails(props) {
    const element = props.element;
    const direction = element.profileImage && element.profileImage.horizontalAlignment === 'left'
        ? 'ltr'
        : 'rtl';
    const vAlign = element.profileImage
        ? element.profileImage.verticalAlignment
        : '';
    const pImage = element.profileImage && element.profileImage.width
        ? element.profileImage.width
        : 100;
    const profileSpace = pImage <= 100 ? 80 : 80 - (pImage - 100) / 8;
    const profileText = getProfileText(props);
    const rightCell = direction === 'rtl' && element.profileImage
        ? `width="${element.profileImage.width}"`
        : `width="${profileSpace}%"`;
    return (React.createElement(React.Fragment, null,
        element.profileImage && direction === 'ltr' ? (React.createElement(React.Fragment, null,
            React.createElement("span", { className: 'XSLT XSLT_if_account/default/profileimage' },
                React.createElement(HtmlComment, { mode: props.mode }, `[if mso]></td><td align="left" valign="${vAlign}" ${element.profileImage ? rightCell : ''}><![endif]`)))) : null,
        React.createElement("div", { className: 'stack-column', style: profileText.wrapperStyle },
            React.createElement("table", { role: 'presentation', "data-width": '100%', style: { width: '100%' }, cellSpacing: 0, cellPadding: 0, className: `noBorder tableNotCentered ${direction === 'rtl' ? 'padding-bottom' : ''}` },
                React.createElement("tbody", null, profileText.component))),
        element.profileImage && direction === 'rtl' ? (React.createElement("span", { className: 'XSLT XSLT_if_account/default/profileimage' },
            React.createElement(HtmlComment, { mode: props.mode }, `[if mso]></td><td align="left" valign="${vAlign} ${element.profileImage ? rightCell : ''}"><![endif]`))) : (React.createElement(HtmlComment, { mode: props.mode }, `[if mso]></td><![endif]`))));
}
function getProfileImage(props) {
    const { mode, element } = props;
    const direction = element.profileImage && element.profileImage.horizontalAlignment === 'left'
        ? 'ltr'
        : 'rtl';
    if (element.profileImage === null) {
        return null;
    }
    return (React.createElement(ProfileImage, { width: element.profileImage.width, height: element.profileImage.height, alignment: element.profileImage.verticalAlignment, mode: mode, direction: direction }));
}
function getProfileText(props) {
    switch (props.layout.type) {
        case 'CustomSignature': {
            return customText(props);
        }
        case 'DefaultSignature': {
            return defaultText(props);
        }
        default: {
            return defaultText(props);
        }
    }
}

function CerberusTemplate(props) {
    const { mode, template } = props;
    const width = template.style.kind === 'fluid' ? '100%' : `${template.style.width + 48}px`;
    /* Set the email width. Defined in two places:
     ** 1. max-width for all clients except Desktop Windows Outlook, allowing the email to squish on narrow but never go wider than 680px.
     ** 2. MSO tags for Desktop Windows Outlook enforce a 680px width.
     ** Note: The Fluid and Responsive templates have a different width (600px). The hybrid grid is more "fragile", and I've found that 680px is a good width. Change with caution.
     */
    const elementList = template.components
        .filter((x) => isImageActive(x))
        .map((item, index) => [
        React.createElement(React.Fragment, { key: index },
            React.createElement(HtmlComment, { key: `CerberusCommentBegin=${index}`, mode: props.mode }, `BEGIN: ${item.type}`),
            React.createElement(CerberusTemplateElement, { key: `CerberusElement=${index}`, element: item, template: template, index: index, mode: mode }),
            React.createElement(HtmlComment, { key: `CerberusCommentEnd=${index}`, mode: props.mode }, `END: ${item.type}`)),
    ]);
    // noinspection HtmlDeprecatedAttribute
    return (React.createElement("div", { style: {
            maxWidth: width,
            margin: 'auto',
            paddingTop: template.style.kind === 'fixed' ? '24px' : '0',
            background: '#ffffff',
        }, className: template.style.kind === 'fixed' ? 'email-container' : 'alignLeft' },
        React.createElement(HtmlComment, { mode: props.mode }, `[if mso]><table role="presentation" cellspacing="0" cellpadding="0" border="0" class="${template.style.kind === 'fixed' ? 'mso-email-container' : ''}" ><tr><td style="padding: 24px 0; background: #ffffff;"><![endif]`),
        React.createElement(HtmlComment, { mode: props.mode }, `[if mso]><table role="presentation" cellspacing="0" cellpadding="0" border="0" align="center" class="${template.style.kind === 'fixed' ? 'mso-email-container' : ''}" ><tr><td class="${template.style.kind === 'fixed' ? 'mso-email-container' : ''}"><![endif]`),
        elementList.map((item) => {
            return item;
        }),
        React.createElement(HtmlComment, { mode: props.mode }, `[if mso]></td></tr></table><![endif]`),
        React.createElement(HtmlComment, { mode: props.mode }, `[if mso]></td></tr></table><![endif]`)));
}
function CerberusTemplateElement(props) {
    const { template } = props;
    const width = template.style.kind === 'fluid' ? '100%' : `${template.style.width + 48}px`;
    const tableStyles = {
        maxWidth: width,
        width: '100%',
    };
    return (React.createElement("table", { role: 'presentation', cellSpacing: 0, cellPadding: 0, "data-width": '100%', style: tableStyles, className: 'noBorder' },
        React.createElement("tbody", null,
            React.createElement("tr", null, getElement(props)))));
}
function getElement(props) {
    const { element, mode, template, index } = props;
    const style = props.template.style;
    switch (element.type) {
        case 'LogoComponent': {
            return (React.createElement(Logo, { mode: mode, data: element, templateStyle: style, isDisclaimerNextActive: isDisclaimerNextActive(template.components, index) }));
        }
        case 'ContentComponent': {
            return React.createElement(Content$2, Object.assign({ mode: mode, templateStyle: style }, element));
        }
        case 'SignatureComponent': {
            return (React.createElement(Signature, { layout: element.layout, element: element, mode: mode, templateStyle: style, isDisclaimerNextActive: isDisclaimerNextActive(template.components, index) }));
        }
        case 'SignatureComponentEmpty': {
            return null;
        }
        case 'BannerComponent': {
            return (React.createElement(Banner, { link: element.linkUrl, mode: mode, url: element.url, name: element.name, height: element.height, width: element.width, templateStyle: style, isDisclaimerNextActive: isDisclaimerNextActive(template.components, index) }));
        }
        case 'DisclaimerComponent': {
            return React.createElement(Disclaimer, { mode: mode, element: element, templateStyle: style });
        }
        case 'FreemiumComponent': {
            return (React.createElement("div", { className: "XSLT XSLT_if_account[@subscriptiontype='Freemium']" },
                React.createElement(Freemium, { mode: mode })));
        }
        default: {
            return null;
        }
    }
}

const templateBase = `<html xmlns="http://www.w3.org/1999/xhtml">
<head>
    <meta charset="utf-8" /> <!-- utf-8 works for most cases -->
    <meta name="viewport" content="width=device-width" /> <!-- Forcing initial-scale shouldn't be necessary -->
    <meta http-equiv="X-UA-Compatible" content="IE=edge" /> <!-- Use the latest (edge) version of IE rendering engine -->
    <meta name="x-apple-disable-message-reformatting" />  <!-- Disable auto-scale in iOS 10 Mail entirely -->
    <!--[1] webfonts-->
    <!-- CSS Reset -->
    <style>

        /* What it does: Tells the email client that only light styles are provided but the client can transform them to dark. A duplicate of meta color-scheme meta tag above. */
        :root {
            color-scheme: light;
            supported-color-schemes: light;
        }

        /* What it does: Remove spaces around the email design added by some email clients. */
        /* Beware: It can remove the padding / margin and add a background color to the compose a reply window. */
        html,
        body {
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
        }

        /* What it does: Stops email clients resizing small text. */
        * {
            -ms-text-size-adjust: 100%;
            -webkit-text-size-adjust: 100%;
        }

        /* What it does: Centers email on Android 4.4 */
        div[style*="margin: 16px 0"] {
            margin: 0 !important;
        }

        /* What it does: Stops Outlook from adding extra spacing to tables. */
        table,
        td {
            mso-table-lspace: 0pt !important;
            mso-table-rspace: 0pt !important;
        }

        /* What it does: Replaces default bold style. */
        th {
            font-weight: normal;
        }

        /* What it does: Fixes webkit padding issue. */
        table {
            border-spacing: 0 !important;
            border-collapse: collapse !important;
            table-layout: fixed !important;
            margin: 0 auto !important;
        }

        /* What it does: Prevents Windows 10 Mail from underlining links despite inline CSS. Styles for underlined links should be inline. */
        a {
            text-decoration: none;
        }

        /* What it does: Uses a better rendering method when resizing images in IE. */
        img {
            -ms-interpolation-mode: bicubic;
            max-width: 100%;
        }

        /* What it does: A work-around for iOS meddling in triggered links. */
        *[x-apple-data-detectors] {
            color: inherit !important;
            text-decoration: none !important;
        }

        /* What it does: A work-around for Gmail meddling in triggered links. */
        .x-gmail-data-detectors,
        .x-gmail-data-detectors *,
        .aBn {
            border-bottom: 0 !important;
            cursor: default !important;
        }

        /* What it does: Prevents Gmail from displaying an download button on large, non-linked images. */
        .a6S {
            display: none !important;
            opacity: 0.01 !important;
        }
        /* If the above doesn't work, add a .g-img class to any image in question. */
        img.g-img + div {
            display: none !important;
        }

        /* What it does: Prevents underlining the button text in Windows 10 */
        .button-link {
            text-decoration: none !important;
        }

        /* Because centered tables are not always desired! */
        .tableNotCentered {
            margin: 0 !important;
        }

        .pushTableLeft {
            margin: 0 auto 0 0 !important;
        }

        .signatureLabel {
            font-weight: bold;
            white-space: nowrap;
        }

        .signaturePipePadding {
            mso-line-height-rule:exactly;
            line-height: 20%;
            padding: 0px 4px;
            color: initial;
            font-weight: normal;
            white-space: pre-line;
        }

        .pushTableRight {
            margin: 0 0 0 auto !important;
        }
        
        /* What it does: Removes right gutter in Gmail iOS app: [2]  */
        /* Create one of these media queries for each additional viewport size you'd like to fix */
        /* iPhone 4, 4S, 5, 5S, 5C, and 5SE */
        @media only screen and (min-device-width: 320px) and (max-device-width: 374px) {
            .email-container {
                min-width: 320px !important;
            }
            .stack-signatureItem{
                display: inline-block !important;
            }
        }
        /* iPhone 6+, 7+, and 8+ */
        @media only screen and (min-device-width: 414px) {
            .stack-signatureItem{
                display: inline-block !important;
            }
        }
    </style>

    <!-- Progressive Enhancements -->
    <style>
        /* Media Queries */
        @media screen and (max-width: 480px) {

            /* What it does: Forces elements to resize to the full width of their container. Useful for resizing images beyond their max-width. */
            .fluid {
                width: 100% !important;
                max-width: 100% !important;
                height: auto !important;
                margin-left: auto !important;
                margin-right: auto !important;
            }

            /* What it does: Forces table cells into full-width rows. */
            .stack-column,
            .stack-column-center {
                display: block !important;
                width: 100% !important;
                max-width: 100% !important;
                direction: ltr !important;
            }
            /* And center justify these ones. */
            .stack-column-center {
                text-align: center !important;
            }

            .stack-profile {
                display: inline-block !important;
                direction: ltr !important;
            }

            .email-container {
                padding: 24px 12px !important;
            }

            .padding-top {
                padding: {{LayoutSpacing}}px 0 0 0 !important;
            }

            .padding-strip {
                padding: 0 !important;
            }

            .padding-bottom {
                padding-bottom: {{LayoutSpacing}}px !important;
            }

            .disclaimer-bottom {
                padding-bottom: 12px !important;
            }

            .height {
                height: {{LayoutSpacing}}px !important;
            }


            /* What it does: Generic utility class for centering. Useful for images, buttons, and nested tables. */
            .center-on-narrow {
                text-align: center !important;
                display: block !important;
                margin-left: auto !important;
                margin-right: auto !important;
                float: none !important;
                width: 100% !important;
            }

            .stack-signatureItem{
                display: inline-block !important;
            }

            table.center-on-narrow {
                display: inline-block !important;
            }
        }
    </style>
</head>
<body width="100%" bgcolor="{{BackgroundColour}}" style="margin: 0; padding:0 !important; mso-line-height-rule: exactly;">
    <div id="BPMPREHEADER" style="display: none; font-size: 0px; line-height: 0px; max-height: 0px; max-width: 0px; width: 0px; opacity: 0; overflow: hidden;">
    </div>
    <center id="react-entry" style="width: 100%; background: {{BackgroundColour}}; padding: 24px 0;">
        {{Content}}
    </center>
    <div id="BPMONTEM"></div>
    <table role="presentation" cellSpacing="0" cellPadding="0" width="100%" style="max-width: 100%" border="0">
        <tbody>
            <tr>
                <td id="SignatureTruncation"></td>
            </tr>
        </tbody>
    </table>
    <div id="FwdReplyContent"></div>
</body>
</html>`;

const xsltBase = `<xsl:stylesheet version="1.0" xmlns:xsl="http://www.w3.org/1999/XSL/Transform">
  <xsl:output method="html" indent="yes" />
  <xsl:template match="@* | node()">
    <xsl:variable name="urlChecker" select="'http://'"></xsl:variable>
    <xsl:variable name="urlCheckerSecure" select="'https://'"></xsl:variable>
    {{HTMLTemplate}}
  </xsl:template>
</xsl:stylesheet>`;

// tslint:disable: no-require-imports
const CerberusBuild = (template) => {
    const mode = { type: 'XSLT' };
    let bgColour;
    if (template.style.kind === 'fluid') {
        bgColour = '#ffffff';
    }
    else if (template.style.colour) {
        bgColour = template.style.colour;
    }
    else {
        bgColour = '#ffffff';
    }
    const hotMelt = server.renderToStaticMarkup(React.createElement(CerberusTemplate, { template: template, mode: mode }));
    const basis = templateBase
        .replace(/{{LayoutSpacing}}/g, (template.style.spacing / 2).toString())
        .replace(/{{BackgroundColour}}/g, bgColour)
        .replace(/{{Content}}/g, hotMelt);
    const hotmel = xsltBase.replace(/{{HTMLTemplate}}/g, basis);
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(hotmel, 'text/xml');
    transformNoBorders(newDoc);
    transformAlignLeft(newDoc);
    transformAlignCenter(newDoc);
    transformAlignRight(newDoc);
    transformVAlignTop(newDoc);
    transformVAlignMiddle(newDoc);
    transformVAlignBottom(newDoc);
    transformComments(newDoc);
    insertXsltTransforms(newDoc);
    insertTemplateTransforms(newDoc);
    transformImages(newDoc);
    transformLinks(newDoc);
    insertHsTracking(newDoc);
    insertAnchorClickTrackingLinks(newDoc);
    profileImageWidth(newDoc);
    insertOpenTracking(newDoc);
    transformPushTableLeft(newDoc);
    transformPushTableRight(newDoc);
    insertOutlookFixes(newDoc);
    insertSignatureTruncation(newDoc);
    replaceWidthAttributes(newDoc);
    // Insert Content query
    const body = newDoc.getElementById('BodyContent');
    if (!body) {
        throw new Error('Body does not exist!');
    }
    body.innerHTML = `<xsl:value-of disable-output-escaping="yes" select="message/htmlBody" />${body.innerHTML}`;
    // Insert FwdReply Content query
    const fwdReply = newDoc.getElementById('FwdReplyContent');
    if (!fwdReply) {
        throw new Error('FwdReply does not exist!');
    }
    fwdReply.innerHTML = `<xsl:value-of disable-output-escaping="yes" select="message/htmlHistoryBody" />`;
    return newDoc;
};
const insertSignatureTruncation = (doc) => {
    const signatureTruncation = doc.getElementById('SignatureTruncation');
    if (signatureTruncation) {
        const span = doc.createElement('span');
        const valueOfElem = doc.createElement('xsl:value-of');
        valueOfElem.setAttribute('select', 'generate-id()');
        const br = doc.createElement('br');
        span.innerText = '--';
        span.setAttribute('style', 'color: white;font-size:0px;line-height:0px;');
        span.appendChild(br);
        span.appendChild(valueOfElem);
        // span.removeAttribute("xmlns");
        signatureTruncation.appendChild(span);
    }
};
const insertOutlookFixes = (doc, template) => {
    const data = document.createTextNode(`[if gte mso 9]>
<style type="text/css" media="all">
     td { line-height: normal !important; }
</style>
<![endif]`);
    const outlookBorders = document.createTextNode(`[if mso]>
<style type="text/css" media="all">   
    .mso-email-container {
      width: 728px;
      max-width: 728px;
    }
</style>
<![endif]`);
    const outlookDPIScaling = document.createTextNode(`[if gte mso 9]>
<xml>
    <o:OfficeDocumentSettings>
        <o:PixelsPerInch>96</o:PixelsPerInch>
    </o:OfficeDocumentSettings>
</xml>
<![endif]`);
    const comment = doc.createElement('xsl:comment');
    comment.appendChild(data);
    const borderComment = doc.createElement('xsl:comment');
    borderComment.appendChild(outlookBorders);
    const scaleComment = doc.createElement('xsl:comment');
    scaleComment.appendChild(outlookDPIScaling);
    doc.getElementsByTagName('head')[0].appendChild(comment);
    doc.getElementsByTagName('head')[0].appendChild(borderComment);
    doc.getElementsByTagName('head')[0].appendChild(scaleComment);
    // Prevent Outlook preview displaying image html
    const preHeader = doc.getElementById('BPMPREHEADER');
    // DEV-324: this work was released but with some linter corrections and deeper testing it appears to be misbehaving
    //          and as such it has been commented out to make it safe for the switch over to this library
    //
    // if (preHeader && isImageActive(template.components[0])) {
    //   const span = document.createElement('span')
    //   span.innerText = `&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;
    //           &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;
    //           &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;
    //           &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;
    //           &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;`
    //   preHeader.appendChild(span)
    // } else
    if (preHeader) {
        const span = document.createElement('span');
        span.innerText = ' ';
        preHeader.appendChild(span);
    }
};
const insertXsltTransforms = (doc) => {
    const xsltElems = doc.getElementsByClassName('XSLT');
    while (xsltElems.length > 0) {
        const elem = xsltElems.item(0);
        if (elem !== null) {
            const ifResult = elem.className
                .split(' ')
                .filter((x) => x.startsWith('XSLT_if_') && !x.startsWith('XSLT_if_not'));
            if (ifResult.length > 0) {
                const query = ifResult[0].slice(8, ifResult[0].length);
                const testElem = doc.createElement('xsl:if');
                testElem.setAttribute('test', `${query}`);
                while (elem.childNodes.length > 0) {
                    testElem.appendChild(elem.childNodes.item(0));
                }
                elem.insertAdjacentElement('afterend', testElem);
            }
            const ifNotResult = elem.className
                .split(' ')
                .filter((x) => x.startsWith('XSLT_if_not_'));
            if (ifNotResult.length > 0) {
                const query = ifNotResult[0].slice(12, ifNotResult[0].length);
                const testElem = doc.createElement('xsl:if');
                testElem.setAttribute('test', `not(${query})`);
                while (elem.childNodes.length > 0) {
                    testElem.appendChild(elem.childNodes.item(0));
                }
                elem.insertAdjacentElement('afterend', testElem);
            }
            const valueOfResult = elem.className
                .split(' ')
                .filter((x) => x.startsWith('XSLT_valueof_'));
            if (valueOfResult.length > 0) {
                const query = valueOfResult[0].slice(13, valueOfResult[0].length);
                const valueOfElem = doc.createElement('xsl:value-of');
                valueOfElem.setAttribute('select', `${query}`);
                elem.parentElement && elem.parentElement.insertBefore(valueOfElem, elem);
            }
            elem.parentElement && elem.parentElement.removeChild(elem);
        }
    }
};
const insertTemplateTransforms = (doc) => {
    const tmplElems = doc.getElementsByClassName('TMPL');
    while (tmplElems.length > 0) {
        const elem = tmplElems.item(0);
        if (elem !== null) {
            const valueOfResult = elem.className
                .split(' ')
                .filter((x) => x.startsWith('TMPL_BGCOLOUR_'));
            if (valueOfResult.length > 0) {
                const backgroundColour = valueOfResult[0].slice(14, valueOfResult[0].length);
                elem.setAttribute('bgcolor', backgroundColour);
                elem.className = elem.className
                    .split(' ')
                    .filter((x) => !x.startsWith('TMPL_BGCOLOUR_'))
                    .join(' ');
            }
            elem.className = elem.className
                .split(' ')
                .filter((x) => x !== 'TMPL')
                .join(' ');
        }
    }
};
const transformImages = (doc) => {
    const imgResult = doc.getElementsByTagName('img');
    for (let i = 0; i < imgResult.length; i++) {
        const src = imgResult[i].getAttribute('src');
        if (src && src.startsWith('XSLT_valueof_')) {
            imgResult[i].src = `{${src.slice(13, src.length)}}`;
        }
        if (imgResult[i].alt.startsWith('XSLT_valueof_')) {
            imgResult[i].alt = `{${imgResult[i].alt.slice(13, imgResult[i].alt.length)}}`;
        }
    }
};
const transformPushTableLeft = (doc) => {
    const result = doc.getElementsByClassName('pushTableLeft');
    while (result.length > 0) {
        result.item(0).style.setProperty('margin', '0 auto 0 0', 'important');
        result.item(0).className = result.item(0).className
            .split(' ')
            .filter((x) => x !== 'pushTableLeft')
            .join(' ');
    }
};
const transformPushTableRight = (doc) => {
    const result = doc.getElementsByClassName('pushTableRight');
    while (result.length > 0) {
        result.item(0).style.setProperty('margin', '0 0 0 auto', 'important');
        result.item(0).className = result.item(0).className
            .split(' ')
            .filter((x) => x !== 'pushTableRight')
            .join(' ');
    }
};
const transformLinks = (doc) => {
    const aResult = doc.getElementsByTagName('a');
    for (let i = 0; i < aResult.length; i++) {
        const src = aResult[i].getAttribute('href');
        if (src && src.startsWith('XSLT_valueof_')) {
            const query = src.slice(13, src.length);
            const urlChecker = `not(contains(${query},$urlChecker)) and not(contains(${query},$urlCheckerSecure))`;
            const nonUrl = aResult[i].cloneNode(true);
            nonUrl.setAttribute('href', `http://{${query}}`);
            nonUrl.removeAttribute('xmlns');
            const url = aResult[i].cloneNode(true);
            url.setAttribute('href', `{${query}}`);
            url.removeAttribute('xmlns');
            const when = doc.createElement('xsl:when');
            when.setAttribute('test', urlChecker);
            when.appendChild(nonUrl);
            const other = doc.createElement('xsl:otherwise');
            other.appendChild(url);
            const choose = doc.createElement('xsl:choose');
            choose.appendChild(when);
            choose.appendChild(other);
            aResult[i].insertAdjacentElement('afterend', choose);
            const ape = aResult[i].parentElement;
            ape && ape.removeChild(aResult[i]);
        }
        if (src && src.startsWith('mailto:XSLT_valueof_')) {
            const query = src.slice(20, src.length);
            const url = aResult[i].cloneNode(true);
            url.setAttribute('href', `mailto:{${query}}`);
            url.removeAttribute('xmlns');
            aResult[i].insertAdjacentElement('afterend', url);
            const ape = aResult[i].parentElement;
            ape && ape.removeChild(aResult[i]);
        }
    }
};
const insertHsTracking = (doc) => {
    const aResult = doc.getElementsByTagName('a');
    for (let i = 0; i < aResult.length; i++) {
        const track = aResult[i].getAttribute('data-hstracking');
        if (track != null) {
            aResult[i].removeAttribute('data-hstracking');
            aResult[i].setAttribute('HsTracking', 'true');
        }
    }
};
const replaceWidthAttributes = (doc) => {
    const table = doc.getElementsByTagName('table');
    const td = doc.getElementsByTagName('td');
    for (let i = 0; i < table.length; i++) {
        const width = table[i].getAttribute('data-width');
        const height = table[i].getAttribute('data-height');
        if (width != null) {
            table[i].setAttribute('width', width);
            table[i].removeAttribute('data-width');
        }
        if (height != null) {
            table[i].setAttribute('height', height);
            table[i].removeAttribute('data-height');
        }
    }
    for (let i = 0; i < td.length; i++) {
        const width = td[i].getAttribute('data-width');
        const height = td[i].getAttribute('data-height');
        if (width != null) {
            td[i].setAttribute('width', width);
            td[i].removeAttribute('data-width');
        }
        if (height != null) {
            td[i].setAttribute('height', height);
            td[i].removeAttribute('data-height');
        }
    }
};
const insertAnchorClickTrackingLinks = (doc) => {
    const aResult = doc.getElementsByTagName('a');
    for (let i = 0; i < aResult.length; i++) {
        const track = aResult[i].getAttribute('data-tracking');
        if (track != null) {
            const trackValue = aResult[i].getAttribute('data-tracking');
            const trackurl = aResult[i].getAttribute('href');
            const trackurlvalue = aResult[i].getAttribute('href');
            aResult[i].removeAttribute('data-tracking');
            const nonUrl = aResult[i].cloneNode(true);
            nonUrl.setAttribute('href', `${trackurl}`);
            nonUrl.removeAttribute('xmlns');
            const url = aResult[i].cloneNode(true);
            const bpref = trackurlvalue && trackurlvalue.indexOf('?') === -1
                ? '?bpref='
                : '&bpref=';
            const hashParts = trackurl != null ? trackurl.split(/#(.+)/) : [];
            if (hashParts.filter((x) => x.length > 0).length > 1) {
                url.setAttribute('href', `${hashParts[0]}${bpref}${trackValue}#${hashParts[1]}`);
            }
            else {
                url.setAttribute('href', `${trackurl}${bpref}${trackValue}`);
            }
            url.removeAttribute('xmlns');
            const when = doc.createElement('xsl:when');
            when.setAttribute('test', `account[@tracking ='True']`);
            when.appendChild(url);
            const other = doc.createElement('xsl:otherwise');
            other.appendChild(nonUrl);
            const choose = doc.createElement('xsl:choose');
            choose.appendChild(when);
            choose.appendChild(other);
            aResult[i].insertAdjacentElement('afterend', choose);
            const ape = aResult[i].parentElement;
            ape && ape.removeChild(aResult[i]);
        }
    }
};
const profileImageWidth = (doc) => {
    const aResult = doc.getElementById('signatureLandscape');
    if (aResult != null && aResult.style.maxWidth !== '100%') {
        const orginalDivElement = aResult.cloneNode(true);
        orginalDivElement.removeAttribute('xmlns');
        const newdivElement = aResult.cloneNode(true);
        const profileImageEnabled = newdivElement.style.maxWidth === '66.66%';
        if (profileImageEnabled) {
            newdivElement.style.maxWidth = '100%';
        }
        newdivElement.removeAttribute('xmlns');
        const when = doc.createElement('xsl:when');
        when.setAttribute('test', `account/default/profileimage`);
        when.appendChild(orginalDivElement);
        const other = doc.createElement('xsl:otherwise');
        other.appendChild(newdivElement);
        const choose = doc.createElement('xsl:choose');
        choose.appendChild(when);
        choose.appendChild(other);
        aResult.insertAdjacentElement('afterend', choose);
        const ape = aResult.parentElement;
        ape && ape.removeChild(aResult);
    }
};
const insertOpenTracking = (doc) => {
    const container = doc.getElementById('BPMONTEM');
    const hsTracking = doc.createElement('HsTracking');
    const openTracking = doc.createElement('xsl:if');
    openTracking.setAttribute('test', `account[@opentracking='True']`);
    openTracking.appendChild(hsTracking);
    container && container.insertAdjacentElement('afterend', openTracking);
    const parent = container && container.parentNode;
    container && parent && parent.removeChild(container);
};
const transformNoBorders = (doc) => {
    const noBorderElems = doc.getElementsByClassName('noBorder');
    while (noBorderElems.length > 0) {
        noBorderElems.item(0).setAttribute('border', '0');
        noBorderElems.item(0).className = noBorderElems.item(0).className
            .split(' ')
            .filter((x) => x !== 'noBorder')
            .join(' ');
    }
};
const transformAlignCenter = (doc) => {
    const alignCenterElems = doc.getElementsByClassName('alignCenter');
    while (alignCenterElems.length > 0) {
        alignCenterElems.item(0).setAttribute('align', 'center');
        alignCenterElems.item(0).className = alignCenterElems.item(0).className
            .split(' ')
            .filter((x) => x !== 'alignCenter')
            .join(' ');
    }
};
const transformAlignLeft = (doc) => {
    const alignLeftElems = doc.getElementsByClassName('alignLeft');
    while (alignLeftElems.length > 0) {
        alignLeftElems.item(0).setAttribute('align', 'left');
        alignLeftElems.item(0).className = alignLeftElems.item(0).className
            .split(' ')
            .filter((x) => x !== 'alignLeft')
            .join(' ');
    }
};
const transformAlignRight = (doc) => {
    const alignLeftElems = doc.getElementsByClassName('alignRight');
    while (alignLeftElems.length > 0) {
        alignLeftElems.item(0).setAttribute('align', 'right');
        alignLeftElems.item(0).className = alignLeftElems.item(0).className
            .split(' ')
            .filter((x) => x !== 'alignRight')
            .join(' ');
    }
};
const transformVAlignTop = (doc) => {
    const vAlignTopElems = doc.getElementsByClassName('vAlignTop');
    while (vAlignTopElems.length > 0) {
        vAlignTopElems.item(0).setAttribute('valign', 'top');
        vAlignTopElems.item(0).className = vAlignTopElems.item(0).className
            .split(' ')
            .filter((x) => x !== 'vAlignTop')
            .join(' ');
    }
};
const transformVAlignMiddle = (doc) => {
    const vAlignTopElems = doc.getElementsByClassName('vAlignMiddle');
    while (vAlignTopElems.length > 0) {
        vAlignTopElems.item(0).setAttribute('valign', 'middle');
        vAlignTopElems.item(0).className = vAlignTopElems.item(0).className
            .split(' ')
            .filter((x) => x !== 'vAlignMiddle')
            .join(' ');
    }
};
const transformVAlignBottom = (doc) => {
    const vAlignBottomElems = doc.getElementsByClassName('vAlignBottom');
    while (vAlignBottomElems.length > 0) {
        vAlignBottomElems.item(0).setAttribute('valign', 'bottom');
        vAlignBottomElems.item(0).className = vAlignBottomElems.item(0).className
            .split(' ')
            .filter((x) => x !== 'vAlignBottom')
            .join(' ');
    }
};
const transformComments = (doc) => {
    const comments = doc.getElementsByClassName('Cerberus_Comment');
    while (comments.length > 0) {
        const comment = doc.createElement('xsl:comment');
        while (comments.item(0).childNodes.length > 0) {
            comment.appendChild(comments.item(0).childNodes.item(0));
        }
        comment && comments[0].insertAdjacentElement('afterend', comment);
        const parent = comments[0].parentNode;
        parent && parent.removeChild(comments[0]);
    }
};

var lib = {};

var Frame$1 = {};

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs.exports;
var assign = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var checkPropTypes = checkPropTypes_1;

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var Context = {};

Object.defineProperty(Context, "__esModule", {
  value: true
});
Context.FrameContextConsumer = Context.FrameContextProvider = Context.useFrame = Context.FrameContext = undefined;

var _react$2 = React;

var _react2$1 = _interopRequireDefault$2(_react$2);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var doc = void 0;
var win = void 0;
if (typeof document !== 'undefined') {
  doc = document;
}
if (typeof window !== 'undefined') {
  win = window;
}

var FrameContext = Context.FrameContext = _react2$1.default.createContext({ document: doc, window: win });

Context.useFrame = function useFrame() {
  return _react2$1.default.useContext(FrameContext);
};

var FrameContextProvider = FrameContext.Provider,
    FrameContextConsumer = FrameContext.Consumer;
Context.FrameContextProvider = FrameContextProvider;
Context.FrameContextConsumer = FrameContextConsumer;

var Content$1 = {};

Object.defineProperty(Content$1, "__esModule", {
  value: true
});

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1 = React;

_interopRequireDefault$1(_react$1);

var _propTypes$1 = propTypes.exports;

var _propTypes2$1 = _interopRequireDefault$1(_propTypes$1);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars


var Content = function (_Component) {
  _inherits$1(Content, _Component);

  function Content() {
    _classCallCheck$1(this, Content);

    return _possibleConstructorReturn$1(this, (Content.__proto__ || Object.getPrototypeOf(Content)).apply(this, arguments));
  }

  _createClass$1(Content, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.contentDidMount();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.props.contentDidUpdate();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react$1.Children.only(this.props.children);
    }
  }]);

  return Content;
}(_react$1.Component);

Content.propTypes = {
  children: _propTypes2$1.default.element.isRequired,
  contentDidMount: _propTypes2$1.default.func.isRequired,
  contentDidUpdate: _propTypes2$1.default.func.isRequired
};
Content$1.default = Content;

Object.defineProperty(Frame$1, "__esModule", {
  value: true
});
Frame$1.Frame = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = React;

var _react2 = _interopRequireDefault(_react);

var _reactDom = require$$1$1;

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = propTypes.exports;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Context = Context;

var _Content = Content$1;

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Frame = Frame$1.Frame = function (_Component) {
  _inherits(Frame, _Component);

  // React warns when you render directly into the body since browser extensions
  // also inject into the body and can mess up React. For this reason
  // initialContent is expected to have a div inside of the body
  // element that we render react into.
  function Frame(props, context) {
    _classCallCheck(this, Frame);

    var _this = _possibleConstructorReturn(this, (Frame.__proto__ || Object.getPrototypeOf(Frame)).call(this, props, context));

    _this.setRef = function (node) {
      _this.nodeRef.current = node;

      var forwardedRef = _this.props.forwardedRef; // eslint-disable-line react/prop-types

      if (typeof forwardedRef === 'function') {
        forwardedRef(node);
      } else if (forwardedRef) {
        forwardedRef.current = node;
      }
    };

    _this.handleLoad = function () {
      _this.setState({ iframeLoaded: true });
    };

    _this._isMounted = false;
    _this.nodeRef = _react2.default.createRef();
    _this.state = { iframeLoaded: false };
    return _this;
  }

  _createClass(Frame, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;

      var doc = this.getDoc();
      if (doc && doc.readyState === 'complete') {
        this.forceUpdate();
      } else {
        this.nodeRef.current.addEventListener('load', this.handleLoad);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;

      this.nodeRef.current.removeEventListener('load', this.handleLoad);
    }
  }, {
    key: 'getDoc',
    value: function getDoc() {
      return this.nodeRef.current ? this.nodeRef.current.contentDocument : null; // eslint-disable-line
    }
  }, {
    key: 'getMountTarget',
    value: function getMountTarget() {
      var doc = this.getDoc();
      if (this.props.mountTarget) {
        return doc.querySelector(this.props.mountTarget);
      }
      return doc.body.children[0];
    }
  }, {
    key: 'renderFrameContents',
    value: function renderFrameContents() {
      if (!this._isMounted) {
        return null;
      }

      var doc = this.getDoc();

      if (!doc) {
        return null;
      }

      var contentDidMount = this.props.contentDidMount;
      var contentDidUpdate = this.props.contentDidUpdate;

      var win = doc.defaultView || doc.parentView;
      var contents = _react2.default.createElement(
        _Content2.default,
        {
          contentDidMount: contentDidMount,
          contentDidUpdate: contentDidUpdate
        },
        _react2.default.createElement(
          _Context.FrameContextProvider,
          { value: { document: doc, window: win } },
          _react2.default.createElement(
            'div',
            { className: 'frame-content' },
            this.props.children
          )
        )
      );

      var mountTarget = this.getMountTarget();

      return [_reactDom2.default.createPortal(this.props.head, this.getDoc().head), _reactDom2.default.createPortal(contents, mountTarget)];
    }
  }, {
    key: 'render',
    value: function render() {
      var props = _extends({}, this.props, {
        srcDoc: this.props.initialContent,
        children: undefined // The iframe isn't ready so we drop children from props here. #12, #17
      });
      delete props.head;
      delete props.initialContent;
      delete props.mountTarget;
      delete props.contentDidMount;
      delete props.contentDidUpdate;
      delete props.forwardedRef;
      return _react2.default.createElement(
        'iframe',
        _extends({}, props, { ref: this.setRef, onLoad: this.handleLoad }),
        this.state.iframeLoaded && this.renderFrameContents()
      );
    }
  }]);

  return Frame;
}(_react.Component);

Frame.propTypes = {
  style: _propTypes2.default.object, // eslint-disable-line
  head: _propTypes2.default.node,
  initialContent: _propTypes2.default.string,
  mountTarget: _propTypes2.default.string,
  contentDidMount: _propTypes2.default.func,
  contentDidUpdate: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)])
};
Frame.defaultProps = {
  style: {},
  head: null,
  children: undefined,
  mountTarget: undefined,
  contentDidMount: function contentDidMount() {},
  contentDidUpdate: function contentDidUpdate() {},
  initialContent: '<!DOCTYPE html><html><head></head><body><div class="frame-root"></div></body></html>'
};
Frame$1.default = _react2.default.forwardRef(function (props, ref) {
  return _react2.default.createElement(Frame, _extends({}, props, { forwardedRef: ref }));
});

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Frame = Frame$1;

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Frame).default;
  }
});

var _Context = Context;

Object.defineProperty(exports, 'FrameContext', {
  enumerable: true,
  get: function get() {
    return _Context.FrameContext;
  }
});
Object.defineProperty(exports, 'FrameContextConsumer', {
  enumerable: true,
  get: function get() {
    return _Context.FrameContextConsumer;
  }
});
Object.defineProperty(exports, 'useFrame', {
  enumerable: true,
  get: function get() {
    return _Context.useFrame;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
}(lib));

var FrameComponent = /*@__PURE__*/getDefaultExportFromCjs(lib);

function CerberusPreview(props) {
    var _a, _b, _c, _d, _e, _f;
    const [dimensions, updateDimensions] = useState({ height: 0, width: 0 });
    const iFrameRef = useRef();
    const { template, signatureData, style, dynamicHeight } = props;
    const { document } = lib.useFrame();
    const iframeRefHeight = (_c = (_b = (_a = iFrameRef.current) === null || _a === void 0 ? void 0 : _a.contentDocument) === null || _b === void 0 ? void 0 : _b.documentElement) === null || _c === void 0 ? void 0 : _c.offsetHeight;
    const iframeRefWidth = (_f = (_e = (_d = iFrameRef.current) === null || _d === void 0 ? void 0 : _d.contentDocument) === null || _e === void 0 ? void 0 : _e.documentElement) === null || _f === void 0 ? void 0 : _f.offsetHeight;
    const mode = {
        type: 'REACT',
        signatureData,
    };
    const defaultStyle = {
        border: 'none',
        width: '1px',
        minWidth: '100%',
    };
    function addHeight() {
        if (dynamicHeight) {
            return {
                height: dimensions.height < 50 ? '100%' : `${dimensions.height}px `,
            };
        }
        return {};
    }
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        // This triggers the initial height on mobile switch view (ie from display none).
        if (dynamicHeight && ((_c = (_b = (_a = iFrameRef.current) === null || _a === void 0 ? void 0 : _a.contentDocument) === null || _b === void 0 ? void 0 : _b.documentElement) === null || _c === void 0 ? void 0 : _c.offsetHeight) &&
            ((_f = (_e = (_d = iFrameRef.current) === null || _d === void 0 ? void 0 : _d.contentDocument) === null || _e === void 0 ? void 0 : _e.documentElement) === null || _f === void 0 ? void 0 : _f.offsetHeight) !== 0 &&
            ((_j = (_h = (_g = iFrameRef.current) === null || _g === void 0 ? void 0 : _g.contentDocument) === null || _h === void 0 ? void 0 : _h.documentElement) === null || _j === void 0 ? void 0 : _j.offsetHeight) + 1 !==
                dimensions.height) {
            updateDimensions({
                height: ((_m = (_l = (_k = iFrameRef.current) === null || _k === void 0 ? void 0 : _k.contentDocument) === null || _l === void 0 ? void 0 : _l.documentElement) === null || _m === void 0 ? void 0 : _m.offsetHeight) + 1,
                width: document.documentElement.clientWidth,
            });
        }
    });
    const bodyColor = template.style.kind === 'fixed'
        ? template.style.colour || '#ffffff'
        : '#ffffff';
    const previewStyles = `
  body {
    background-color: ${bodyColor} !important;
  }
  
  center {
    background-color: ${bodyColor} !important;
  }
  `;
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        // This triggers with the rendering of the preview document in the iFrame.
        if (dynamicHeight && ((_c = (_b = (_a = iFrameRef.current) === null || _a === void 0 ? void 0 : _a.contentDocument) === null || _b === void 0 ? void 0 : _b.documentElement) === null || _c === void 0 ? void 0 : _c.offsetHeight) &&
            ((_f = (_e = (_d = iFrameRef.current) === null || _d === void 0 ? void 0 : _d.contentDocument) === null || _e === void 0 ? void 0 : _e.documentElement) === null || _f === void 0 ? void 0 : _f.offsetHeight) !== 0 &&
            ((_j = (_h = (_g = iFrameRef.current) === null || _g === void 0 ? void 0 : _g.contentDocument) === null || _h === void 0 ? void 0 : _h.documentElement) === null || _j === void 0 ? void 0 : _j.offsetHeight) + 1 !==
                dimensions.height) {
            updateDimensions({
                height: iFrameRef.current.contentDocument.documentElement.offsetHeight + 1,
                width: document.documentElement.clientWidth,
            });
        }
    }, [iframeRefHeight, iframeRefWidth]);
    return (React.createElement(FrameComponent, { style: { ...defaultStyle, ...style, ...addHeight() }, initialContent: templateBase
            .replace(/{{Content}}/g, '')
            .replace(/{{BackgroundColour}}/g, 'transparent'), mountTarget: '#react-entry', ref: iFrameRef },
        React.createElement(InnerFrame, { template: template, updateDimensions: updateDimensions, dimensions: dimensions, dynamicHeight: dynamicHeight }),
        React.createElement(CerberusTemplate, { template: template, mode: mode }),
        React.createElement("style", null, previewStyles)));
}
const InnerFrame = (props) => {
    // Hook returns iframe's window and document instances from Frame context
    const { document } = lib.useFrame();
    const { template, updateDimensions, dynamicHeight } = props;
    // This monitors the change in template configuration object to know if the
    // background color has changed or if the preview height was effected
    const handleResize = () => {
        if (document && dynamicHeight) {
            updateDimensions({
                height: document.body.clientHeight + 1,
                width: document.documentElement.clientWidth,
            });
        }
    };
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [template, document.documentElement, document.body.clientHeight]);
    return null;
};
CerberusPreview.defaultProps = {
    dynamicHeight: false,
};

export { CerberusBuild, CerberusPreview, CerberusTemplate, SocialMediaIcon as SampleTemplateIcon, customXslt, defaultBanner, defaultDisclaimer, defaultLogo, defaultSignatureData, defaultTemplate, formatSignatureData, getBackgroundColour, getFontHtmlCode, maxTemplateComponentWidth, updateLegacyValues };
//# sourceMappingURL=index.esm.js.map
